import React, { useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useState, useEffect } from "react";
import { clsx } from "clsx";
import { createPortal } from "react-dom";
import PenIcon from "images/pen.svg";
import hideWorkIcon from "images/hide_work.svg";
import showFullWorkIcon from "images/show_full_work.svg";
import showWorkIcon from "images/show_work.svg";
import styles from "./style.module.css";
import Select, { components } from "react-select";
import { HexColorPicker } from "react-colorful";
import { Virtuoso } from "react-virtuoso";
import moment from "moment";
import { ButtonGroup, Button, Icon, Accordion } from "aible";
import { TileItem } from "aible";
import { Popover, OverlayTrigger, Alert } from "react-bootstrap";
import numeral from "numeral";
import { getSchemaMonitors } from "containers/SchemaMonitor/reducer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown, faChevronLeft, faChevronRight, faInfo, faArrowRight, faThumbsUp, faThumbsDown, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Labeled } from "components/Tiles/Sense/Relation/Common";
import { LineInput } from "components/Inputs/LineInput";
import LabeledToggle from "components/Inputs/Toggle/Toggle";
import TextInput from "components/Inputs/TextInput";
import Tooltip from "components/Inputs/Tooltip";
import { isEnabled } from "utils/featureFlags";
import { MODEL_OPTIONS, CHAT_MARKDOWN_OVERRIDES, USER_MARKDOWN_OVERRIDES, getDefaultDateIndices, getIsAskingSuggestQuestions } from "containers/ChatGPT/reducer";
import SenseTile from "components/Tiles/Sense/SenseTile";
import { VoiceButton } from "components/AibleAgent/AibleAgent";
import FeatureChartContainer from "containers/FeatureChart/FeatureChart";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import BlueprintSelector from "components/ChatGPT/BlueprintSelector";
import ModelSelector from "components/ChatGPT/ModelSelector";
import MessageCost from "components/ChatGPT/MessageCost";
import ToneSelector from "components/ChatGPT/ToneSettings/ToneSelector";
import DocumentSelector from "components/LanguageModelArtifact/DocumentSelector";
import SqlWarningPopup from "components/ChatGPT/SqlWarningPopup";
import LegacyModelWarning from "components/ChatGPT/LegacyModelWarning";
import SqlBarChart from "components/ChatGPT/SqlBarChart";
import MarkdownPanel from "components/ChatGPT/MarkdownPanel";
import ChatExportModal from "components/ChatGPT/ChatExportModal";
import AgentAutonomyControls from "components/AgentAutonomy/AgentAutonomyControls";
import UploadDocument from "../LanguageModelArtifact/UploadDocument";
import DistributionChart from "components/Gallery/Charts/DistributionChart";
import { parseMarkdownGeneric, parseMarkdownLine } from "utils/markdown";
import ChatGPTSettings from "components/ChatGPT/ChatGPTSettings";
import InfoChartContainer from "containers/Next/Charts/InfoChart";
import NextChartContainer from "components/Next/Charts/NextChart";
import SenseViewContainer from "containers/View/Sense";
import LeakageChartContainer from "containers/Next/Charts/LeakageChart";
import ComparisonChartContainer from "containers/Next/Charts/ComparisonChart";
import NextSearchContainer from "containers/Next/NextSearch";
import aibleBadge from "images/Aible-Badge.svg";
import llmBadge from "images/LLM.svg";
import chataibleEmailBadge from "images/chataible-email-automation.svg";
import multiDocIcon from "images/file-lines-light.svg";
import multiNLQIcon from "images/code-sharp-light.svg";
import multiAnalyticsIcon from "images/chart-simple-light.svg";
import IconThumbsUp from "images/thumbs-up-light 3.svg";
import IconThumbsUpFilled from "images/Thumbs Up Active.svg";
import IconThumbsDown from "images/thumbs-down-light 3.svg";
import IconThumbsDownFilled from "images/Thumbs Down Active.svg";
import documentSetIconGray from "images/files-gray.svg";
import circleCheckGreen from "images/Circle Check Light 2.svg";
import minimizeIcon from "images/minimize-light.svg";
import crystalBallIcon from "images/crystal-ball-light.svg";
import sparklesImg from "images/admin_images/sparkles-light 1.svg";
import paperPlaneWhiteIcon from "images/paper-plane-white.svg";
import gearGrayIcon from "images/gear-light.svg";
import NumberIcon from "images/EDG/123.svg";
import CategoryIcon from "images/EDG/abc.svg";
import DateIcon from "images/EDG/DateIcon.svg";
import GoogleSlidesExport from "containers/ChatGPT/GoogleSlidesExport";
import SmallDateChart from "components/Tiles/Sense/SmallDateChart";
import { CHATAIBLE_BLUEPRINTS, CHATAIBLE_DOCUMENT_SUMMARIZATION, CHATAIBLE_SQL } from "containers/ChatGPT/reducer";
import { EventType, InteractionStatus } from "@azure/msal-browser";
import { MsalContext } from "@azure/msal-react";
import { service, factories, models } from "powerbi-client";
import { FilterType } from "powerbi-models/dist/models";
import * as config from "./../PowerBI/config";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as homeReducer from "containers/Home/reducer";
import * as viewReducer from "containers/View/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as chatAppReducer from "containers/ChatApp/reducer";
import * as globalReducer from "containers/App/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as tagsReducer from "containers/Tags/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as languagageModelArtifactReducer from "containers/LanguageModelArtifact/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import DynamicWidthSelector from "components/ChatGPT/DynamicWidthSelector";
import DatasetSelector from "components/Dataset/DatasetSelector";
import RecommendedOptionsPopup from "components/ChatGPT/RecommendedOptionsPopup";
import FeedbackDatasetPopup from "components/ChatGPT/FeedbackDatasetPopup";
import FewShotView from "components/ChatGPT/FewShotView";
import SeeWhatWasSent from "components/ChatGPT/SeeWhatWasSent";
import { useDispatch, useSelector } from "types/store";
import { getTone } from "containers/ChatTone/reducer";
import { getCorpus } from "containers/LanguageModelArtifact/reducer";
import { hasOutputContent, getMessageContentReferenceData, getSplitMessageOutputContent, isReasoningStep, getSplitMessageOutputContentFromMessage } from "types/chat_conversation";
import { customMapper, isOptionType, selectOnChangeWrapper } from "utils/select";
import { isColumn } from "utils/insight/properties";
import { keysOf } from "utils/collect";
import { getAnalyticsReferenceChartDatasetId, getAnalyticsReferenceChartReportId, getAnalyticsReferenceChartValue, isAnalyticsMetricReferenceChart, isAnalyticsMultiReferenceChart, isAnalyticsReferenceChart, isAnalyticsReferenceValueChart, isDocumentReference, isExactDocumentReference, isConceptDocumentReference, isNLQValueReferenceChart } from "types/chat";
import { UsefulVariables } from "components/Tiles/Sense/DataReadinessPanel";
import { getAiReadyMetrics } from "containers/Setup/reducer";
import { getColorFromStatus } from "components/Tiles/Sense/SensePieChart";
import ContextSelectionButtons from "components/NewChat/ContextSelectionButtons";
import ContextSelectionPanel from "components/NewChat/ContextSelectionPanel";
import { addOutputFeedbackItem, fetchChatMessageDetails, getChatMessageDetails } from "containers/ChatDetails/reducer";
import ChatCapabilityList from "components/ChatGPT/ChatCapabilityList";
import * as aibleAnywhereReducer from "containers/AibleAnywhere/reducer";
import * as setupReducer from "containers/Setup/reducer";
import MarkdownTypewriter from "aible/MarkdownTypewriter/MarkdownTypewriter";
import InProgressStepsMessage from "components/ChatGPT/InProgressStepsMessage";
import SearchTemplateRecommendations from "components/Templates/SearchTemplateRecommendations";
import { Dialog, DialogHeader, DialogContent, DialogTitle, DialogFooter } from "@/aible/Dialog/Dialog";
import RatingInput from "components/ChatGPT/RatingInput";
import { Cell, Pie, PieChart } from "recharts";
import { calculateDateValues } from "@/components/Tiles/Sense/ActionsPanel";
import magnifyingGlassChart from "images/magnifying_glass_chart.svg";
import DashboardFocusModal from "@/components/Next/Dashboard/DashboardFocusModal";
import AttachFile from "components/NewChat/AttachFile";
import { updateTileState } from "containers/Sense/reducer";
import { delay } from "@/utils/promise";
import { TemplateOptimize } from "../Templates/VideoTemplate";
import { getRatingsById } from "@/containers/Ratings/reducer";
import AddModelFeedback from "components/ChatGPT/AddModelFeedback";
import OptimizeStrategyCard from "components/ChatGPT/OptimizeStrategyCard";
import { ToolCallList } from "components/ChatGPT/ToolCallDisplay";
import { RightPanel as TemplateRightPanel } from "components/View/TemplatesView";
import IconVideoOptionsGray from "images/video_options_gray.svg";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import OptimizeConfigureButton from "components/ChatGPT/OptimizeConfigureButton";
let accessToken = "";
let embedUrl = "";
const TOOL_CALLS_DISPLAY_OPTIONS = ["Hide work", "Show items", "Show full details"];
const TOOL_CALLS_DISPLAY_MODE_ICONS = {
    "Hide work": hideWorkIcon,
    "Show items": showWorkIcon,
    "Show full details": showFullWorkIcon
};
const { Option } = components;
const DEBUG_ENABLED = false;
function debug(x) {
    if (DEBUG_ENABLED) {
        console.log(x);
    }
}
const IconOption = (props) => (React.createElement(Option, { ...props },
    React.createElement("img", { src: props.data.icon, style: { width: "14px", height: "14px", marginRight: "5px" }, alt: props.data.label }),
    props.data.label));
const MultiValueLabel = (props) => {
    return (React.createElement(components.MultiValueLabel, { ...props },
        React.createElement("img", { src: props.data.icon, style: { width: "14px", height: "14px", marginRight: "5px" }, alt: props.data.label }),
        props.data.label));
};
const DataAsTable = ({ data, listItem, message }) => {
    if (data === undefined) {
        return React.createElement("div", null);
    }
    const headers = Object.keys(data[0] ?? {});
    const format = (cell, isSelected = false) => {
        if (isSelected) {
            return React.createElement("span", { style: { fontWeight: "bolder" } }, format(cell));
        }
        if (cell == null) {
            return "null";
        }
        else if (Array.isArray(cell)) {
            return `[${cell.map((c) => format(c)).join(", ")}]`;
        }
        else if (typeof cell == "number") {
            return cell.toLocaleString();
        }
        else {
            return cell.toString();
        }
    };
    const selectedValues = listItem?.values ?? [];
    const selectedRows = new Set(selectedValues.map((x) => x[0]));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.sqlChart, style: { marginBottom: "20px", width: "100%" } },
            React.createElement(SqlBarChart, { data: data, message: message, isEditChart: false })),
        data?.length > 1 && (React.createElement("div", null,
            React.createElement("table", null,
                React.createElement("tr", null, headers.map((n, i) => (React.createElement("th", { key: i }, n)))),
                data.map((row, i) => (React.createElement("tr", { key: i }, headers.map((h) => (React.createElement("td", { key: h }, format(row[h], selectedRows.has(i) && selectedValues.some((value) => value[1] == row[i])))))))))))));
};
const RenderReasoningStep = ({ executionId, resultId, children, message, reasoningStep, onRetryWithFeedback, hideResponseChunkRetry, thinkingText }) => {
    const dispatch = useDispatch();
    const chatMessageDetail = useSelector((state) => getChatMessageDetails(state, executionId));
    const step = reasoningStep.index !== undefined ? `: Step ${reasoningStep.index + 1}` : "";
    const label = reasoningStep.type == "think" ? `Thinking${step}` : "Answer";
    const stepElement = (React.createElement("div", { className: styles.chatMessageReasoning },
        React.createElement("div", { className: styles.reasoningThinking },
            React.createElement("div", { style: { fontWeight: "bold" } }, label),
            React.createElement(ReasoningStepContainer, { executionId: executionId, resultId: resultId, feedback: reasoningStep, thinkingText: thinkingText }, children))));
    const result = chatMessageDetail?.results?.find((r) => r.id == resultId);
    const questionIndex = dispatch(chatGPTReducer.getQuestionIndexFromMessage(message));
    const question = useSelector((state) => chatGPTReducer.getConversationMessage(state, questionIndex ?? 0));
    const userMPrompt = question?.isQuestion ? question.userPrompt : undefined;
    const userPrompt = useSelector((state) => chatGPTReducer.getPrompt(state));
    const extraFeedback = useSelector((state) => chatGPTReducer.getReasoningFeedbackText(state, message?.messageIndex));
    const hintsArray = useSelector((state) => chatGPTReducer.getReasoningHintsArray(state, message?.messageIndex));
    const userID = useSelector((state) => loginReducer.getUserID(state));
    const resultData = result?.data;
    const userOutputFeedback = (resultData?.output_feedback ?? []).find((f) => f.user_id == userID);
    const currFeedbackItems = userOutputFeedback
        ? userOutputFeedback?.feedback_items?.map((fItem) => fItem?.comment).filter((i) => i !== undefined)
        : undefined;
    const currFeedbackString = currFeedbackItems ? currFeedbackItems.join("\n\n") : undefined;
    const hasExtraFeedback = extraFeedback?.length > 0;
    const reasoningFeedbackIncludeInChat = useSelector((state) => chatGPTReducer.getReasoningFeedbackIncludeInChat(state));
    let retHintsArray = hintsArray;
    if (!reasoningFeedbackIncludeInChat) {
        retHintsArray = currFeedbackItems ?? [];
    }
    const latestHint = currFeedbackString;
    const introPromptAugment = hasExtraFeedback
        ? "\n\n" + (reasoningFeedbackIncludeInChat ? extraFeedback : "\nHint:\n" + latestHint)
        : undefined;
    const userPromptAugment = latestHint ? "\n\nHint:\n" + latestHint : undefined;
    const blueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    if (!reasoningStep.isLastThinkingStep) {
        return stepElement;
    }
    return (React.createElement("div", null,
        stepElement,
        userOutputFeedback !== undefined && !hideResponseChunkRetry && (React.createElement("div", { className: styles.reasonRetry },
            React.createElement(Button, { type: "primary", onClick: () => {
                    // Removing fewshot turning on with retry question
                    // dispatch(nextReducer.updateIsFewShotEnabled(nextId, true));
                    if (blueprintId === "AGENT_IQ" || blueprintId === "AGENT_IQ_TEAM") {
                        const retUserPrompt = userPrompt === undefined || userPrompt === null || userPrompt === "" ? question?.text : userPrompt;
                        dispatch(chatGPTReducer.handleAgentIQ(retUserPrompt + "\n\nHint:\n" + latestHint, false, blueprintId === "AGENT_IQ_TEAM" ? "reasoning-team" : "reasoning"));
                    }
                    else if (onRetryWithFeedback !== undefined) {
                        onRetryWithFeedback(extraFeedback);
                    }
                    else {
                        dispatch(chatGPTReducer.handleAskGPT(userMPrompt, undefined, undefined, undefined, undefined, !userMPrompt, introPromptAugment, true, executionId, retHintsArray, introPromptAugment, userPromptAugment));
                    }
                } }, "Retry Question with Feedback")))));
};
function getHighlightType(listItem) {
    if ((isAnalyticsMultiReferenceChart(listItem) && listItem.charts.every(isAnalyticsMetricReferenceChart)) ||
        isConceptDocumentReference(listItem)) {
        return "grey";
    }
    else if (isAnalyticsMetricReferenceChart(listItem) ||
        isExactDocumentReference(listItem) ||
        (isNLQValueReferenceChart(listItem) && listItem.values.length == 1)) {
        return "blue";
    }
    return "none";
}
const HIGHLIGHT_STYLES = {
    blue: styles.hoverLink,
    grey: styles.hoverLinkGrey,
    none: styles.hoverLinkNoHighlight
};
const ResponseChunkFragmentData = ({ message, index, resultId, executionId, chunk, hideResponseChunkRetry }) => {
    const dispatch = useDispatch();
    if (isReasoningStep(chunk)) {
        const child = (React.createElement(MarkdownPanel, { overrides: CHAT_MARKDOWN_OVERRIDES, renderLeaf: (leaf) => (React.createElement(ResponseChunks, { message: message, index: index, chunks: [leaf], resultId: resultId, executionId: executionId })) }, parseMarkdownGeneric(chunk.chunks
            .map((c) => typeof c === "string"
            ? c.replace(`<${chunk.type}>`, "").replace(`</${chunk.type}>`, "")
            : {
                ...c,
                text: c.text?.replace(`<${chunk.type}>`, "")?.replace(`</${chunk.type}>`, "")
            })
            .map((c, i) => typeof c !== "string" ? c : i == 0 ? c.trimStart() : i == chunk.chunks.length - 1 ? c.trimEnd() : c), (t) => t.text, (t, x) => ({ ...t, text: x }))));
        if (resultId === undefined || executionId === undefined) {
            return child;
        }
        return (React.createElement(RenderReasoningStep, { executionId: executionId, resultId: resultId, reasoningStep: chunk, message: message, hideResponseChunkRetry: hideResponseChunkRetry, thinkingText: chunk?.text }, child));
    }
    return (React.createElement("span", { className: styles.idBaseText, onMouseEnter: () => dispatch(chatGPTReducer.handleHoverEnter(message, chunk)), onMouseLeave: () => dispatch(chatGPTReducer.handleHoverLeave()), onClick: () => {
            dispatch(chatGPTReducer.handleShowChartSelect(message, index, chunk));
            dispatch(chatGPTReducer.handleHoverLeave());
        } },
        React.createElement("a", { className: HIGHLIGHT_STYLES[getHighlightType(chunk)] },
            React.createElement(MarkdownPanel, { overrides: CHAT_MARKDOWN_OVERRIDES }, parseMarkdownLine([chunk.text ?? ""])))));
};
const ResponseChunkFragment = ({ chunk, hideResponseChunkRetry, ...restProps }) => {
    if (typeof chunk !== "string") {
        return React.createElement(ResponseChunkFragmentData, { ...restProps, chunk: chunk, hideResponseChunkRetry: hideResponseChunkRetry });
    }
    return React.createElement("span", null, chunk);
};
const ResponseChunks = ({ chunks, hideResponseChunkRetry, ...restProps }) => {
    debug("Render: ResponseChunks");
    return (React.createElement(React.Fragment, null, chunks?.map((chunk, i) => (React.createElement(ResponseChunkFragment, { key: i, chunk: chunk, ...restProps, hideResponseChunkRetry: hideResponseChunkRetry })))));
};
const ResponseWithIds = ({ message, index, hideThinkingSteps, renderChunksAsStreaming }) => {
    debug("Render: ResponseWithIds");
    const dispatch = useDispatch();
    const originalMessage = useSelector((state) => chatGPTReducer.getConversationMessage(state, message?.questionIndex ?? -1));
    const oPrompt = originalMessage?.userText;
    const isSuggestQuestions = oPrompt &&
        oPrompt.indexOf("Give me 2 relevant questions to ask my dataset.") !== -1 &&
        message?.text &&
        message?.text?.indexOf("2.") !== -1;
    const questions = isSuggestQuestions ? message?.text?.split("2.") : undefined;
    const executionId = (message.contentGenerationIds ?? [])[0];
    const chatMessageDetail = useSelector((state) => getChatMessageDetails(state, executionId));
    const userID = useSelector((state) => loginReducer.getUserID(state));
    const result = chatMessageDetail?.results.find((r) => r.id === message.response_data?.result_id);
    let chunks = getSplitMessageOutputContentFromMessage(message, result, userID);
    const isReasoningThinkChunk = (chunk) => {
        if (typeof chunk === "string") {
            return false;
        }
        return "type" in chunk && chunk.type === "think";
    };
    if (hideThinkingSteps) {
        chunks = chunks.filter((chunk) => !isReasoningThinkChunk(chunk));
    }
    const [renderChunks, updateRenderChunks] = useState([]);
    const [currentChunkIndex, updateCurrentChunkIndex] = useState(0);
    const [currentStringIndex, updateCurrentStringIndex] = useState(0);
    const currentChunk = chunks[currentChunkIndex];
    const chunkDelay = 250;
    const stringChunkDelay = 100;
    const stringChunkSize = 20;
    const incrementChunk = () => {
        // Now check against chunks to make sure updated chunk state updates previous chunks and not just appends new state
        const previousChunks = chunks?.slice(0, currentChunkIndex);
        updateRenderChunks(previousChunks);
        // Only increment index if there's more chunks
        if (currentChunkIndex < chunks?.length - 1) {
            updateCurrentChunkIndex((prevIndex) => prevIndex + 1);
        }
    };
    useEffect(() => {
        let delayTimer;
        if (!renderChunksAsStreaming) {
            return () => clearTimeout(delayTimer);
        }
        if (currentChunkIndex < chunks?.length) {
            if (!(typeof currentChunk === "string")) {
                delayTimer = setTimeout(incrementChunk, chunkDelay);
            }
            else {
                const strChunks = [];
                // Creates the strChunks from currentChunk
                for (let i = 0; i < currentChunk?.length; i += stringChunkSize) {
                    strChunks.push(currentChunk.slice(i, i + stringChunkSize));
                }
                if (currentStringIndex < strChunks.length) {
                    delayTimer = setTimeout(() => {
                        // Now accumulate all chunks up to current index instead of appending the latest snippet to previous state
                        const retStringChunks = strChunks.slice(0, currentStringIndex + 1).join("");
                        // For updating current chunks with all previous chunks and the current accumulator of string chunks
                        const retChunks = [...chunks.slice(0, currentChunkIndex), retStringChunks];
                        // Only increment if there's more
                        if (currentStringIndex < strChunks.length - 1) {
                            updateCurrentStringIndex((prevIndex) => prevIndex + 1);
                        }
                        updateRenderChunks(retChunks);
                    }, stringChunkDelay);
                }
                else if (currentChunkIndex < chunks?.length - 1) {
                    // Only if there's more chunks and strIndex is at the end
                    updateCurrentStringIndex(0);
                    updateCurrentChunkIndex((prevIndex) => prevIndex + 1);
                    delayTimer = setTimeout(incrementChunk, chunkDelay);
                }
            }
        }
        return () => clearTimeout(delayTimer);
    }, [renderChunks, chunks, renderChunksAsStreaming]);
    return (React.createElement("div", null,
        React.createElement("div", null, isSuggestQuestions && questions ? (React.createElement("div", null, questions.map((q, i) => (React.createElement(Button, { key: "questions_" + i, onClick: () => dispatch(chatGPTReducer.askChatGPTNoAugment(q)) }, i === 1 ? "2." + q : q))))) : (React.createElement(MarkdownPanel, { renderLeaf: (leaf) => (React.createElement(ResponseChunks, { message: message, index: index, chunks: [leaf], resultId: result?.id, executionId: executionId })), overrides: CHAT_MARKDOWN_OVERRIDES }, parseMarkdownGeneric(renderChunksAsStreaming ? renderChunks : chunks, (t) => (isReasoningStep(t) ? t.chunks.map((c) => (typeof c === "string" ? c : c.text)).join("") : t.text), (t, x) => ({ ...t, text: x }), (t) => isReasoningStep(t)
            ? [t.chunks.map((c) => (typeof c === "string" ? c : c.text)).join("")]
            : (t.text?.split("\n") ?? [])))))));
};
const SQLConfirmation = ({ message, index }) => {
    debug("Render: SQLConfirmation");
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const backgroundColorDarkMode = useSelector((state) => chatGPTReducer.getBackgroundColorDarkMode(state));
    const [openSQLIndex, updateOpenSQLIndex] = useState();
    const shouldHaveFeedback = !isEnabled("spark-agents-templates-view") && !message.isError;
    const backgroundColorDarkColor = "#EFECF6";
    const aDataset = useSelector((state) => homeReducer.getDataset(state, message?.datasetId));
    const mModelId = message?.model;
    const mModel = MODEL_OPTIONS?.[mModelId ?? ""];
    const mBlueprintId = message?.analytics?.blueprintId;
    const mBlueprint = useSelector((state) => viewReducer.getChatBlueprint(state, mBlueprintId, true));
    const mChatToneId = message?.chatTone;
    const mChatTone = useSelector((state) => getTone(state, mChatToneId));
    const contentGenerationIds = message?.contentGenerationIds;
    const contentGenerationAccount = message?.contentGenerationAccount;
    const hasContentGenerationIds = contentGenerationIds && contentGenerationIds?.length > 0;
    const [isFetchingDetails, updateIsFetchingDetails] = useState({});
    const updateFetchingId = (id, bool) => {
        updateIsFetchingDetails({
            ...isFetchingDetails,
            [id]: bool
        });
    };
    const hasCustomIcon = chatApp?.wizard?.base64StringBot !== undefined && chatApp?.wizard?.base64StringBot !== "";
    // Checks and state for showing the feedback/retry when user does not have reasoning or response had no reasoning chunks.
    // Also checks that current user has thumbs downed.
    const [isCommenting, updateIsCommenting] = useState(false);
    const executionId = message.contentGenerationIds?.[0];
    const execution = useSelector((state) => getChatMessageDetails(state, executionId));
    const userID = useSelector((state) => loginReducer.getUserID(state));
    const executionRatings = useSelector((state) => executionId && !isNaN(Number(executionId))
        ? getRatingsById(state, "CONTENT_GENERATION_EXECUTION", Number(executionId))
        : {});
    const foundDislike = Object.values(executionRatings).find((rating) => rating.score == "DISLIKE" && rating.created_by.id === userID);
    const userHasDisliked = foundDislike !== undefined;
    const result = execution?.results.find((r) => r.id === message.response_data?.result_id);
    const chunks = getSplitMessageOutputContentFromMessage(message, result, userID);
    const noReasoningChunks = !chunks?.some((c) => isReasoningStep(c));
    const isThinkingOff = !isEnabled("chat-reason") || noReasoningChunks;
    return (React.createElement("div", { className: styles.chatMessage, style: {
            background: chatApp?.wizard?.backgroundColor !== undefined ? "none" : "#FFFFFF"
        }, "data-msg-index": message?.messageIndex },
        React.createElement("div", { className: styles.chatBody },
            React.createElement(OverlayTrigger, { placement: "top", trigger: mModelId !== undefined ? ["hover"] : [], rootClose: true, overlay: React.createElement(Popover, { id: "popover-positioned-top" },
                    React.createElement("div", { className: styles.responseSettingsPopover },
                        React.createElement("span", null, "Chat Settings: "),
                        React.createElement("span", null, `${mBlueprint?.name} agent template `),
                        aDataset !== undefined && React.createElement("span", null, `and ${aDataset?.label} `),
                        React.createElement("span", null, `using ${mModel?.label} `),
                        mChatToneId && React.createElement("span", null, `and ${mChatTone?.name} tone`))) },
                React.createElement("div", { className: styles.userIcon, style: { background: hasCustomIcon ? "#94A3B8" : "#3E1270" } },
                    React.createElement("img", { className: hasCustomIcon ? styles.userIconImageCustom : styles.userIconImage, src: hasCustomIcon ? chatApp?.wizard?.base64StringBot : aibleBadge }))),
            React.createElement("div", { className: styles.messageBody },
                React.createElement("div", null, hasOutputContent(message) ? (React.createElement(ResponseWithIds, { message: message, index: 0 })) : (React.createElement(MarkdownPanel, { overrides: {
                        p: {
                            style: {
                                fontSize: "14px",
                                lineHeight: "25px",
                                minHeight: "25px"
                            }
                        }
                    } }, message.userText
                    ? typeof message.userText === "string"
                        ? message.userText
                        : JSON.stringify(message.userText)
                    : typeof message.text === "string"
                        ? message.text
                        : JSON.stringify(message.text)))),
                hasContentGenerationIds &&
                    contentGenerationIds.map((id) => {
                        return (React.createElement(SeeWhatWasSent, { contentGenerationId: id, accountId: contentGenerationAccount, key: "seeWhatWasSent__" + id, isFetchingDetails: isFetchingDetails, updateFetchingId: updateFetchingId }));
                    }),
                React.createElement("div", { className: styles.chatActions }, shouldHaveFeedback && React.createElement(Feedback, { message: message, index: index, updateIsCommenting: updateIsCommenting })),
                !message?.isStreamed && userHasDisliked && isThinkingOff && (React.createElement("div", null,
                    React.createElement(AddModelFeedback, { message: message, executionId: executionId, isCommenting: isCommenting, updateIsCommenting: updateIsCommenting }))),
                React.createElement("div", { className: styles.tokenDateInfo, style: {
                        color: backgroundColorDarkMode ? backgroundColorDarkColor : "#7e7d9a"
                    } },
                    (message?.response_data?.usage !== undefined || message?.contentGenerationIds) &&
                        !message?.isCachedResponse && (React.createElement(MessageCost, { message: message, isFetchingDetails: isFetchingDetails, updateFetchingId: updateFetchingId })),
                    React.createElement("div", { className: styles.messageDate },
                        message?.isCachedResponse
                            ? `Cached response generated ${moment.utc(message.responseDate).fromNow()}`
                            : moment.utc(message.date).fromNow(),
                        message?.cachedPrompt !== undefined && (React.createElement("div", { style: {
                                display: "flex",
                                lineHeight: "100%",
                                alignItems: "center"
                            } },
                            React.createElement("div", null, "Response generated from a similar prompt"),
                            React.createElement(OverlayTrigger, { placement: "top", trigger: ["hover"], rootClose: true, overlay: React.createElement(Popover, { id: "popover-positioned-top", title: React.createElement("strong", { style: { fontSize: "13px" } }, "Cached Response Prompt") }, message?.cachedPrompt) },
                                React.createElement("div", { className: styles.cacheTooltip },
                                    React.createElement(FontAwesomeIcon, { icon: faInfo }))))))),
                React.createElement("div", { className: styles.sqlQuery, style: openSQLIndex === index
                        ? {
                            display: "block",
                            paddingBottom: "16px"
                        }
                        : { display: "none" } },
                    React.createElement("div", { className: styles.sqlQueryTitleMsg }, "Aible automatically generated the query below to find the answer to your natural language question so you don't have to learn to speak code (SQL)."),
                    message?.sqlQueryPrompt ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.sqlQueryHeader }, "SQL Generation Prompt:"),
                        React.createElement("div", { className: styles.sqlQueryContent }, message?.sqlQueryPrompt))) : null,
                    React.createElement("div", { className: styles.sqlQueryHeader }, "Generated Query:"),
                    React.createElement("div", { className: styles.sqlQueryContent }, message?.sqlQuery),
                    message?.data && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.sqlQueryHeader }, "Query Data:"),
                        React.createElement("div", { className: styles.sqlQueryContent },
                            React.createElement(DataAsTable, { data: message?.data, message: message })))),
                    message?.sqlLlmPrompt && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.sqlQueryHeader }, "LLM System Message:"),
                        React.createElement("div", { className: styles.sqlQueryContent }, message?.sqlLlmPrompt))))))));
};
const Settings = () => {
    debug("Render: Settings");
    return React.createElement(ChatGPTSettings, null);
};
const DocSumContent = ({ listItem }) => {
    debug("Render: DocSumContent");
    const content = listItem?.document?.page_content;
    if (!content) {
        return React.createElement(React.Fragment, null);
    }
    const casedContent = content.toLowerCase();
    const casedText = listItem.text?.toLowerCase();
    const startIndex = casedText === undefined ? -1 : casedContent.indexOf(casedText);
    if (startIndex >= 0) {
        const first = content.substring(0, startIndex);
        const text = typeof listItem.text === "string" ? listItem.text : JSON.stringify(listItem.text);
        const last = content.substring(startIndex + text.length);
        return (React.createElement(React.Fragment, null,
            React.createElement("span", null, first),
            React.createElement("span", { className: styles.hoverLink }, text),
            React.createElement("span", null, last)));
    }
    return React.createElement(MarkdownPanel, { overrides: CHAT_MARKDOWN_OVERRIDES }, listItem?.document?.page_content);
};
const HoverItem = ({ message, listItem, isClose }) => {
    debug("Render: HoverItem");
    const dispatch = useDispatch();
    const isTemplate = location.pathname.indexOf("chatTemplate") !== -1;
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const isSmallScreen = useSelector((state) => viewReducer.getIsSmallScreen(state));
    let isShowChartIndex = useSelector((state) => chatGPTReducer.getShowChart(state).isShowChartIndex ?? 0);
    const isHoverChartIndex = useSelector((state) => chatGPTReducer.getHoverChart(state).isHoverChartIndex ?? 0);
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const { fChart, fChartValue } = useSelector((state) => chatGPTReducer.getHoverChartFoundChart(state, listItem));
    const isMultipleCharts = isAnalyticsMultiReferenceChart(listItem);
    if (!isClose) {
        isShowChartIndex = isHoverChartIndex ?? 0;
    }
    if (isShowChartIndex >= (isMultipleCharts ? listItem.charts.length : 0)) {
        isShowChartIndex = 0;
    }
    const [showCreateFocusModal, setShowCreateFocusModal] = useState(false);
    const [selectedFocusedChart, setSelectedFocusedChart] = useState(undefined);
    const handleCloseFocusedModal = () => {
        setShowCreateFocusModal(false);
        setSelectedFocusedChart(undefined);
    };
    const handleOpenFocusedModal = (chart) => {
        setShowCreateFocusModal(true);
        setSelectedFocusedChart(chart);
    };
    const isDocumentSummarization = isDocumentReference(listItem);
    const isNQL = isNLQValueReferenceChart(listItem);
    const isChart = fChart !== undefined || isAnalyticsReferenceChart(listItem);
    const isValidRender = isChart || isDocumentSummarization || isMultipleCharts || isNQL;
    if (!isValidRender) {
        return React.createElement(React.Fragment, null);
    }
    const analyticsReferenceChart = isMultipleCharts
        ? listItem.charts[isShowChartIndex]
        : isAnalyticsReferenceChart(listItem)
            ? listItem
            : undefined;
    const referenceNextId = (analyticsReferenceChart === undefined ? nextId : getAnalyticsReferenceChartReportId(analyticsReferenceChart)) ??
        nextId;
    const badStyle = () => {
        if (window?.looker_API !== undefined) {
            return {};
        }
        if (isTemplate) {
            return { height: "calc(100vh - 80px)", top: "70px" };
        }
        return { height: "calc(100vh - 130px)", top: "120px" };
    };
    const linkedComparisonProjects = useSelector((state) => nextReducer.getLinkedComparisonProjects(state, nextId)) ?? {};
    const isLinkedComparisonCreating = useSelector((state) => nextReducer.getIsLinkedComparisonCreating(state, nextId)) ?? {};
    const canCreateFocused = Object.keys(linkedComparisonProjects).length === 0 || nextId === linkedComparisonProjects?.["@_Original_@"];
    const isCreating = fChart?.title && isLinkedComparisonCreating?.[fChart.title] === true;
    const focusNextId = fChart?.title ? linkedComparisonProjects?.[fChart.title] : undefined;
    const tField = listItem?.charts?.[isShowChartIndex]?.metadata?.properties?.[1]?.column ??
        listItem?.metadata?.properties?.[1]?.column;
    const tValue = listItem?.charts?.[isShowChartIndex]?.metadata?.properties?.[1]?.value ??
        listItem?.metadata?.properties?.[1]?.value;
    const sField = listItem?.charts?.[isShowChartIndex]?.metadata?.properties?.[0]?.column ??
        listItem?.metadata?.properties?.[0]?.column;
    const sValue = listItem?.charts?.[isShowChartIndex]?.value ?? listItem?.value;
    return (React.createElement("div", { className: styles.hoverGraph + " " + (isClose ? styles.noBorders : ""), style: isSmallScreen
            ? { pointerEvents: "all", zIndex: 333, height: "100%" }
            : isClose
                ? { pointerEvents: "all", zIndex: 333, ...badStyle() }
                : { ...badStyle() } },
        isMultipleCharts && (listItem.charts?.length ?? 0) > 1 && (React.createElement("div", { className: styles.matchedItemSelectorWrapper },
            React.createElement("div", null, `ChatAible has identified ${listItem.charts?.length} potential matches`),
            React.createElement("div", { className: styles.matchedItemSelectorButtons },
                React.createElement(ButtonGroup, { style: { flexWrap: "wrap" } }, (listItem.charts ?? []).map((c, i) => {
                    const chartTitle = `Chart ${i + 1}`;
                    return (React.createElement(Tooltip, { key: "show_chart_" + i, trigger: ["hover"], overlay: chartTitle },
                        React.createElement(Button, { type: "secondary", onClick: () => dispatch(chatGPTReducer.updateShowChart({
                                isShowChartIndex: i
                            })), className: styles.matchedItemSelectorButton, style: {
                                // maxWidth: `calc(100% / ${listItem.charts.length})`,
                                padding: "9px 10px",
                                minWidth: "4.5%"
                            }, active: i === isShowChartIndex }, i + 1)));
                }))))),
        isClose === true && (React.createElement("div", { className: styles.hoverClose },
            isEnabled("focused_whats_changed") && isEnabled("focused_whats_changed-chat") && (React.createElement(Button, { onClick: focusNextId !== undefined
                    ? () => {
                        if (fChart?.title !== undefined) {
                            dispatch(nextReducer.openComparisonProject(linkedComparisonProjects?.[fChart.title]));
                        }
                    }
                    : isCreating
                        ? () => {
                            return;
                        }
                        : canCreateFocused
                            ? () => handleOpenFocusedModal(fChart)
                            : () => {
                                return;
                            }, style: { padding: "6px 15px" }, disabled: isCreating || !canCreateFocused }, isCreating ? (React.createElement(LoadingIndicator, { style: {
                    height: "20px",
                    width: "20px",
                    right: "9px",
                    bottom: "8px",
                    margin: "0px",
                    transform: "scale(0.4)"
                } })) : (React.createElement("img", { src: magnifyingGlassChart, style: { width: "20px", height: "20px" } })))),
            React.createElement(Button, { onClick: () => dispatch(nextReducer.initDashboardAndOpen()) }, "Dashboard"),
            React.createElement(Button, { onClick: () => dispatch(chatGPTReducer.updateShowChart({
                    isShowChart: undefined,
                    isShowChartIndex: undefined
                })) }, "Close"))),
        message?.blueprintId === "CHATAIBLE_BENCHMARK" && tValue !== undefined && false ? (React.createElement(InfoChartContainer, { id: nextId, rankIndex: 0, field: tField, value: tValue, focusColumn: sField, focusValue: sValue, 
            /*
              onExpand={(expandChart, expandHighlightProps) =>
                this.setState({
                  expandChart: expandChart,
                  expandHighlightProps: expandHighlightProps
                })
              }
              */
            barTooltipPosition: "top", isChat: true })) : isDocumentSummarization ? (React.createElement("div", { className: styles.docSumHoverWrapper },
            React.createElement("div", { className: styles.docSumHoverTitle }, listItem?.document?.metadata?.source ? listItem?.document?.metadata?.source : "Page Content:"),
            listItem?.document?.metadata?.page !== undefined && (React.createElement("div", { className: styles.docSumPageText }, `PAGE ${isNaN(listItem?.document?.metadata?.page)
                ? listItem?.document?.metadata?.page
                : Number(listItem?.document?.metadata?.page) + 1}`)),
            React.createElement("div", { className: styles.docSumHoverTextContent },
                React.createElement(DocSumContent, { listItem: listItem })))) : isNQL ? (React.createElement("div", { className: styles.nlqHoverWrapper },
            React.createElement("div", { className: styles.expansionTitle }, "Query Data:"),
            React.createElement("div", { className: styles.docSumHoverContent },
                React.createElement(DataAsTable, { data: message?.data, listItem: listItem, message: message })))) : analyticsReferenceChart !== undefined ? (React.createElement("div", { className: styles.panelChartWrapper, style: analyticsReferenceChart.metadata.type === "Difference" ? { flex: 0.95, whiteSpace: "nowrap" } : {} },
            React.createElement(NextChartContainer, { id: referenceNextId !== undefined && referenceNextId !== "new" ? referenceNextId : nextId, chart: {
                    metadata: analyticsReferenceChart.metadata
                }, datasetId: getAnalyticsReferenceChartDatasetId(analyticsReferenceChart), highlightProps: fChartValue, showLeakage: true, showTooltip: true, isChatGPT: true, isComparisonDashboard: analyticsReferenceChart.metadata.type === "Difference", isOpenShell: chatType === "OPENSHELL" }))) : (React.createElement(React.Fragment, null)),
        React.createElement(DashboardFocusModal, { id: referenceNextId !== undefined && referenceNextId !== "new" ? referenceNextId : nextId, handleClose: handleCloseFocusedModal, chart: selectedFocusedChart, open: showCreateFocusModal })));
};
const ChatTabs = () => {
    debug("Render: ChatTabs");
    const dispatch = useDispatch();
    const conversation = useSelector((state) => chatGPTReducer.getConversation(state));
    const chatsByQuestion = {};
    keysOf(conversation)
        .map((c, i) => ({ ...conversation[c], index: i }))
        .filter((c) => c.questionIndex !== undefined || c.isQuestion)
        .forEach((c, i) => {
        const retIndex = c.questionIndex !== undefined ? c.questionIndex : i + 1;
        if (chatsByQuestion[retIndex] === undefined) {
            chatsByQuestion[retIndex] = [];
        }
        chatsByQuestion[retIndex].push(c);
    });
    const retFilterIndex = useSelector((state) => chatGPTReducer.getRetFilterIndex(state));
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.chatHistoryHeader },
            React.createElement("div", null, "Topic"),
            React.createElement("div", null, "Hide in Dashboard")),
        React.createElement("div", null, chatsByQuestion &&
            keysOf(chatsByQuestion).map((cKey) => {
                const fQuestionIndex = chatsByQuestion[cKey]?.find((f) => f?.questionIndex !== undefined)?.questionIndex;
                const lastMessage = chatsByQuestion[cKey][chatsByQuestion[cKey].length - 1];
                const charts = getMessageContentReferenceData(lastMessage).flatMap((listItem) => {
                    if (isAnalyticsReferenceChart(listItem)) {
                        return [listItem];
                    }
                    else if (isAnalyticsMultiReferenceChart(listItem)) {
                        return listItem.charts;
                    }
                    else {
                        return [];
                    }
                });
                return fQuestionIndex === undefined ? (React.createElement("div", null)) : (React.createElement("div", { className: styles.chatHistoryRow },
                    React.createElement("a", { className: styles.chatHistoryLink, style: retFilterIndex === fQuestionIndex ? { fontWeight: "bold" } : {}, onClick: () => dispatch(chatGPTReducer.updateFilterChatQuestionIndex(fQuestionIndex)) },
                        React.createElement("span", null,
                            chatsByQuestion[cKey]?.[0]?.prompt
                                ? chatsByQuestion[cKey]?.[0]?.prompt
                                : chatsByQuestion[cKey]?.[0]?.userText
                                    ? chatsByQuestion[cKey]?.[0]?.userText
                                    : "Summarizing with ChatAible",
                            (lastMessage?.data?.length ?? 0) > 0 && (React.createElement("span", { className: styles.chatHistoryChartsBadge }, `${lastMessage?.data?.length} Data Points`)),
                            charts?.length > 0 && (React.createElement("span", { className: styles.chatHistoryChartsBadge }, `${charts?.length} Charts`)))),
                    React.createElement("div", { className: styles.chatHistoryHide },
                        React.createElement("input", { className: styles.chatHistoryCheckbox, type: "checkbox", checked: lastMessage?.isHidden === true, onChange: () => {
                                if (lastMessage == undefined || lastMessage.index === undefined) {
                                    return;
                                }
                                if (lastMessage?.isHidden === true) {
                                    dispatch(chatGPTReducer.updateMessage(lastMessage?.index, {
                                        ...lastMessage,
                                        isHidden: false
                                    }));
                                }
                                else {
                                    dispatch(chatGPTReducer.updateMessage(lastMessage?.index, {
                                        ...lastMessage,
                                        isHidden: true
                                    }));
                                }
                            } }))));
            }))));
};
const PanelReport = () => {
    debug("Render: PanelReport");
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const insightCombinationCount = useSelector((state) => nextReducer.getInsightCombinationCount(state, undefined, datasetId));
    const datasetSource = useSelector((state) => homeReducer.getDatasetSource(state, datasetId));
    const comparisonOptions = useSelector((state) => nextReducer.getComparisonOptions(state, nextId));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const isChatTabs = useSelector((state) => chatGPTReducer.getIsChatTabs(state));
    const datasetOutcome = dataset?.outcome ?? "the outcome";
    const datasetTitle = dataset?.label;
    const datasetCombinations = insightCombinationCount;
    const isWhatsChanged = chatType === "WHATS_CHANGED" && comparisonOptions?.dateField;
    return (React.createElement("div", { className: styles.rightPanelReport }, isChatTabs ? (React.createElement(ChatTabs, null)) : (React.createElement("div", null,
        React.createElement("div", { className: styles.rightPanelContent },
            React.createElement("div", { className: styles.muscleChart }, isWhatsChanged ? (React.createElement("div", { className: styles.treemapChart },
                React.createElement(ComparisonChartContainer, { id: nextId, isNextReport: true }))) : (React.createElement(LeakageChartContainer, { id: nextId, isSense: true })))),
        React.createElement("div", { className: styles.rightPanelHeader }, `ChatAible has automatically analyzed your ${datasetTitle ? datasetTitle + " " : ""}data ${datasetSource ? `from ${datasetSource} ` : ""}${datasetCombinations && !isWhatsChanged
            ? `across ${numeral(datasetCombinations).format("0,0")} variable combinations (including group by and drill down charts)`
            : ""}`),
        React.createElement("div", { className: styles.rightPanelSubheader }, dataset?.outcome === undefined
            ? `No outcome column has been selected for this dataset. Natural Language Queries do not require a defined outcome, but selecting an outcome will display key drivers for that outcome and enable further analysis of the dataset.`
            : isWhatsChanged
                ? `This chart outlines the changes in behavior from the time period between ` +
                    `${comparisonOptions?.referenceStart} and ${comparisonOptions?.referenceEnd} to the time period between ` +
                    `${comparisonOptions?.currentStart} and ${comparisonOptions?.currentEnd}. ` +
                    `The size of the areas represents the percentage point change in behavior normalized by the percentage change in population.`
                : `This chart outlines the key drivers of ${datasetOutcome}. The outside arc represents how strongly a specific variable affects ${datasetOutcome}. The bridges across represent how strongly a combination of variables affect ${datasetOutcome}.`)))));
};
const RightPanelBody = () => {
    debug("Render: RightPanelBody");
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const isSmallScreen = useSelector((state) => viewReducer.getIsSmallScreen(state));
    const hasAnalyticsChat = useSelector((state) => chatGPTReducer.getHasAnalyticsChat(state));
    const isShowChart = useSelector((state) => chatGPTReducer.getShowChart(state).isShowChart);
    const hoverMessage = useSelector((state) => chatGPTReducer.getHoverChart(state).message);
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    if ((dataset === undefined && (isShowChart === undefined || !isDocumentReference(isShowChart))) ||
        (isSmallScreen && isShowChart === undefined) ||
        (dataset !== undefined &&
            ((!(typeof chatApp?.id === "number" && !isNaN(chatApp?.id)) && !hasAnalyticsChat) ||
                (!(typeof chatApp?.id === "number" && !isNaN(chatApp?.id)) && chatType !== "AIBLE")) &&
            isShowChart === undefined)) {
        return null;
    }
    return isShowChart !== undefined ? (React.createElement(HoverItem, { message: hoverMessage, listItem: isShowChart, isClose: true })) : (React.createElement(PanelReport, null));
};
const RightPanel = () => {
    debug("Render: RightPanel");
    const showSettings = useSelector((state) => chatGPTReducer.getShowSettings(state));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const agentIQRightPanel = useSelector((state) => chatGPTReducer.getAgentIQRightPanel(state));
    const isSmallScreen = useSelector((state) => viewReducer.getIsSmallScreen(state));
    const IS_SIMPLE_MODE = true;
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const [isHideTransforms, setIsHideTransforms] = useState(false);
    const hasTransform = agentIQRightPanel?.transformed_dataset_id !== undefined ||
        agentIQRightPanel?.dataset_transform !== undefined ||
        agentIQRightPanel?.dataset_transform_join !== undefined;
    const forceShowRight = hasTransform;
    if (!forceShowRight && IS_SIMPLE_MODE && !showSettings && chatType !== "DOCUMENT") {
        return React.createElement(React.Fragment, null);
    }
    if (chatType === "OPENSHELL") {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: styles.rightPanelWrapper, style: isHideTransforms === true && !showSettings
            ? { width: "0%" }
            : !forceShowRight && showSettings === false && chatType === "DOCUMENT"
                ? { width: "0%" }
                : forceShowRight && isSmallScreen
                    ? { position: "relative", width: "40%" }
                    : {} },
        isHideTransforms !== true && hasTransform ? (React.createElement("div", { className: styles.rightCloseTransform },
            React.createElement(Button, { onClick: () => setIsHideTransforms(true), style: { padding: "4px" } }, "Close Transform"))) : isHideTransforms === true && hasTransform ? (React.createElement("div", { className: styles.rightCloseTransform },
            React.createElement(Button, { onClick: () => setIsHideTransforms(false), style: { padding: "4px" } }, "Open Transform"))) : (React.createElement("div", null)),
        showSettings ? (React.createElement(Settings, null)) : datasetId !== undefined && datasetId !== "new" ? (React.createElement(RightPanelBody, null)) : isHideTransforms === true ? (React.createElement(RightPanelBody, null)) : agentIQRightPanel?.transformed_dataset_id !== undefined ? (React.createElement(SimpleDatasetTile, { datasetId: agentIQRightPanel?.transformed_dataset_id })) : agentIQRightPanel?.dataset_transform !== undefined ? (React.createElement(SimpleDatasetTransform, { dataset_transform: agentIQRightPanel?.dataset_transform })) : agentIQRightPanel?.dataset_transform_join !== undefined ? (React.createElement(SimpleDatasetTransformJoin, { dataset_transform_join: agentIQRightPanel?.dataset_transform_join })) : (React.createElement(RightPanelBody, null))));
};
const PowerBISettings = () => {
    debug("Render: PowerBISettings");
    const dispatch = useDispatch();
    const [workspaceId, updateWorkspaceId] = useState(localStorage.getItem("powerbi_workspace_id") ?? "");
    const [clientId, updateClientId] = useState(localStorage.getItem("powerbi_client_id") ?? "");
    const [datasetId, updateDatasetId] = useState(localStorage.getItem("powerbi_dataset_id") ?? "");
    const [reportId, updateReportId] = useState(localStorage.getItem("powerbi_report_id") ?? "");
    return (React.createElement("div", { className: styles.chatSettings },
        React.createElement("div", { className: styles.settingsTitle }, "Power BI IDs"),
        "Blank Report ID",
        React.createElement("div", { className: styles.setting },
            React.createElement(LineInput, { value: reportId, onChange: updateReportId })),
        "Dataset ID",
        React.createElement("div", { className: styles.setting },
            React.createElement(LineInput, { value: datasetId, onChange: updateDatasetId })),
        React.createElement("div", { className: styles.setting },
            "Workspace ID",
            React.createElement(LineInput, { value: workspaceId, onChange: updateWorkspaceId })),
        React.createElement("div", { className: styles.setting },
            "Client ID",
            React.createElement(LineInput, { value: clientId, onChange: updateClientId })),
        React.createElement("div", null,
            React.createElement(Button, { type: "primary", onClick: () => {
                    localStorage.setItem("powerbi_report_id", reportId);
                    localStorage.setItem("powerbi_dataset_id", datasetId);
                    localStorage.setItem("powerbi_workspace_id", workspaceId);
                    localStorage.setItem("powerbi_client_id", clientId);
                    dispatch(chatGPTReducer.updateIsShowPowerBISettings(false));
                } }, "Save"),
            React.createElement(Button, { type: "secondary", style: { marginLeft: "20px" }, onClick: () => dispatch(chatGPTReducer.updateIsShowPowerBISettings(false)) }, "Close"))));
};
const IsSuggestQuestionsResponse = ({ message }) => {
    debug("Render: IsSuggestQuestionsResponse");
    const dispatch = useDispatch();
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("div", null,
                message?.jsonQuestions?.["Intro_Summary"] && React.createElement("div", null, message?.jsonQuestions?.["Intro_Summary"]),
                message?.jsonQuestions && (React.createElement("div", { className: styles.suggestedQuestionsContainer }, keysOf(message.jsonQuestions)
                    .filter((c) => c !== "Intro_Summary" && message.jsonQuestions?.[c] !== "")
                    .map((q, i) => (React.createElement("div", { key: i, className: styles.suggestedQuestionsButtonWrapper },
                    React.createElement(Button, { onClick: () => {
                            dispatch(chatGPTReducer.handleAskGPT(message.jsonQuestions?.[q])).then(() => dispatch(chatGPTReducer.suggestQuestions(message.jsonQuestions?.[q])));
                        } }, message.jsonQuestions?.[q]))))))),
            React.createElement("div", { style: { marginTop: "20px" } },
                message?.rcJsonQuestions?.["Intro_Summary"] && React.createElement("div", null, message?.rcJsonQuestions?.["Intro_Summary"]),
                message?.rcJsonQuestions && (React.createElement("div", { className: styles.suggestedQuestionsContainer }, keysOf(message.rcJsonQuestions)
                    .filter((c) => c !== "Intro_Summary" && message.jsonQuestions?.[c] !== "")
                    .map((q, i) => (React.createElement("div", { key: i, className: styles.suggestedQuestionsButtonWrapper },
                    React.createElement(Button, { onClick: () => dispatch(chatGPTReducer.handleAskGPT(message.rcJsonQuestions?.[q])) }, message.rcJsonQuestions?.[q]))))))))));
};
const SavedPreferredHints = ({ message, isChatTemplate }) => {
    debug("Render: SavedPreferredHints");
    const dispatch = useDispatch();
    const questionIndex = dispatch(chatGPTReducer.getQuestionIndexFromMessage(message));
    const question = useSelector((state) => chatGPTReducer.getConversationMessage(state, questionIndex ?? 0));
    const mPrompt = question?.isQuestion ? question.userText : undefined;
    const [selectedHints, updateSelectedHints] = useState([]);
    const originalPrompt = message?.prompt ? message.prompt : "Summarizing with ChatAible";
    const addedHints = selectedHints?.length > 0 ? "\n\nHint:\n" + selectedHints.reduce((a, b) => a + b + "\n\n", "") : "";
    const activePrompt = originalPrompt + addedHints;
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("div", { className: styles.savedHintsContainer },
                "Aible found potential matches for hints on similar questions with positive feedback.\nHere are some hints you may add to your question and continue when ready:",
                React.createElement("div", { className: styles.savedHintsList }, message?.savedHints &&
                    message?.savedHints?.length > 0 &&
                    message.savedHints.map((hint, i) => (React.createElement("div", { key: `savedHint__${i}__${hint}`, className: styles.suggestedQuestionsButtonWrapper },
                        React.createElement(Button, { className: styles.savedHintsButton, active: selectedHints.indexOf(hint) !== -1, onClick: () => {
                                const retHints = [...selectedHints];
                                if (retHints.indexOf(hint) === -1) {
                                    retHints.push(hint);
                                }
                                else {
                                    const spliceIndex = retHints.indexOf(hint);
                                    retHints.splice(spliceIndex, 1);
                                }
                                updateSelectedHints(retHints);
                            } }, selectedHints.indexOf(hint) !== -1 ? `Remove hint: ${hint}` : `Add hint: ${hint}`))))),
                React.createElement("div", { className: styles.savedHintsContinueAction },
                    React.createElement("div", { className: styles.savedHintsContinueLabel }, "Continue with this question?"),
                    React.createElement(Button, { className: styles.savedHintsButton, onClick: () => {
                            if (message?.prompt === undefined) {
                                dispatch(chatGPTReducer.handleAskGPT(undefined, undefined, undefined, undefined, isChatTemplate, true, addedHints, true, undefined, undefined));
                            }
                            else {
                                dispatch(chatGPTReducer.handleAskGPT(activePrompt, undefined, undefined, undefined, isChatTemplate, undefined, undefined, true, undefined, undefined));
                            }
                        } }, activePrompt))))));
};
const SavedSuggestedQuestions = ({ message }) => {
    debug("Render: SavedSuggestedQuestions");
    const dispatch = useDispatch();
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("div", { className: styles.savedHintsContainer },
                "There are saved suggested questions on this usecase. You can start from here by clicking on a question to ask:",
                React.createElement("div", { className: styles.savedHintsList }, message?.savedSuggestedQuestions &&
                    message?.savedSuggestedQuestions?.length > 0 &&
                    message.savedSuggestedQuestions.map((question, i) => (React.createElement("div", { key: `savedSuggestedQuestion__${i}__${question}`, className: styles.suggestedQuestionsButtonWrapper },
                        React.createElement(Button, { className: styles.savedHintsButton, onClick: () => {
                                dispatch(chatGPTReducer.handleAskGPT(question));
                            } }, question)))))))));
};
const LeakageInfo = ({ message, skipRedirect }) => {
    debug("Render: LeakageInfo");
    const dispatch = useDispatch();
    const [multipleLeakage, updateMultipleLeakage] = useState({});
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const rawLeakageRecommendations = message?.leakageJSON ?? [];
    const leakageRecommendations = [...rawLeakageRecommendations].sort((lDataA, lDataB) => {
        return lDataB.abs_correlation - lDataA.abs_correlation;
    });
    return (React.createElement("div", { className: styles.autoImport, id: "leakge_info_message" },
        React.createElement("div", { className: styles.tableSelect }, leakageRecommendations.map((l_data, i) => {
            return (React.createElement("div", { className: styles.askDataHolder, style: { width: "100%" }, onClick: () => {
                    console.log("l_data", l_data);
                    updateMultipleLeakage({
                        ...multipleLeakage,
                        [l_data?.name]: !multipleLeakage?.[l_data?.name]
                    });
                }, key: "leakage_info_" + i },
                React.createElement("div", { className: styles.tableItem },
                    React.createElement("input", { type: "checkbox", checked: multipleLeakage?.[l_data?.name] === true, style: { marginRight: "10px" } }),
                    React.createElement("div", { className: styles.tableDataset },
                        React.createElement("div", { className: styles.tableDatasetItem },
                            React.createElement("div", { style: {
                                    display: "flex",
                                    flexGrow: 1,
                                    textAlign: "left"
                                } },
                                React.createElement("div", { style: { color: "#666" } }, l_data?.name))),
                        React.createElement("div", { style: { width: "100%" } }, l_data?.abs_correlation !== undefined && (React.createElement("div", { className: styles.analyticsPanelBarOuter },
                            React.createElement("div", { className: styles.analyticsPanelBarInner, style: {
                                    width: Math.min(100, l_data?.abs_correlation * 100) + "%",
                                    background: "#F8CD7E"
                                } })))),
                        l_data?.description !== undefined && (React.createElement("div", { className: styles.foundDatasetDescription }, l_data?.description))))));
        })),
        React.createElement("div", { className: styles.leakageButton, style: { whiteSpace: "nowrap", paddingLeft: "16px" } }, leakageRecommendations?.length ? (React.createElement(React.Fragment, null,
            React.createElement(Button, { type: "primary", onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    dispatch(chatGPTReducer.removeLeakage(message?.datasetId ?? datasetId, multipleLeakage, skipRedirect));
                }, disabled: Object.keys(multipleLeakage).reduce((a, b) => a && multipleLeakage[b] === false, true), style: { padding: "4px" } }, "Ignore the selected fields and re-run analysis"),
            React.createElement(Button, { onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (chatType !== "AIBLE") {
                        dispatch(chatGPTReducer.selectBlueprint(chatGPTReducer.CHATAIBLE_BLUEPRINTS.CHATAIBLE_ANALYTICS.id));
                    }
                    dispatch(nextReducer.updateSimpleFlowStep(nextId, "EXPLORE"));
                    dispatch(nextReducer.updateSimpleFlowStepDisplay(nextId, "EXPLORE"));
                }, style: { padding: "4px", marginLeft: "10px" } }, leakageRecommendations?.length ? "Continue Without Ignoring" : "Continue"))) : null)));
};
const AskMultipleDatasets = ({ message, isModal, updateIsMultiDataModal }) => {
    debug("Render: AskMultipleDatasets");
    const dispatch = useDispatch();
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const blueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const getDatasetById = (dId) => dispatch((dispatch, getState) => homeReducer.getDataset(getState(), dId));
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const multiDatasets = useSelector((state) => chatGPTReducer.getMultiDatasets(state));
    const blueprintOptions = useSelector((state) => viewReducer.getChatBlueprintOptions(state));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const multiDatasets_Options = useSelector((state) => chatGPTReducer.getMultiDatasets_Options(state));
    const schemaMonitors = useSelector((state) => getSchemaMonitors(state));
    const prompt = useSelector((state) => chatGPTReducer.getPrompt(state));
    const datasets = useSelector((state) => viewReducer.getDatasets(state));
    const simpleFlowStep = useSelector((state) => nextReducer.getSimpleFlowStep(state, nextId));
    const [multipleDocuments, updateMultipleDocuments] = useState({});
    const [multipleDatasets_NLQ, updateMultipleDatasets_NLQ] = useState({});
    const [savedPreviousState, updateSavedPreviousState] = useState();
    const [multiPrompt, updateMultiPrompt] = useState();
    const [isDataAsking, updateIsDataAsking] = useState(false);
    const retDatasets = message?.askChatGPT_MultipleDatasets ?? [];
    const retDocuments = message?.askChatGPT_MultipleDocuments ?? [];
    const activeDatasets = [...multiDatasets];
    const hasDatasetSelected = !activeDatasets?.length && !isNaN(datasetId);
    const hasOneActive = activeDatasets.length > 0 ||
        keysOf(multipleDocuments).filter((d) => multipleDocuments[d]).length > 0 ||
        keysOf(multipleDatasets_NLQ).filter((d) => multipleDatasets_NLQ[d]).length > 0;
    const singleDataset = activeDatasets.length === 1 && retDocuments.length === 0 ? activeDatasets[0] : false;
    const ALLOW_MULTIPLE_DATASETS = isEnabled("multi-document-dataset");
    const datasetBlueprintOptions = [
        ...(blueprintOptions?.dataset ?? []).map((d) => ({
            label: d.name,
            id: d.id,
            value: d.id,
            blueprintId: d.blueprintId
        }))
    ];
    const documentBlueprintOptions = [
        ...(blueprintOptions?.dataset ?? []).map((d) => ({
            label: d.name,
            id: d.id,
            value: d.id,
            blueprintId: d.blueprintId
        }))
    ];
    const bothData = [...(retDatasets ?? []), ...(retDocuments ?? [])]
        .sort((a, b) => (a?.rank - b?.rank < 0 ? -1 : a?.rank === b?.rank ? 0 : 1))
        // Only going to show the top 15 total results.
        .slice(0, 15);
    const resetSuggestedColumns = () => dispatch(nextReducer.updateSuggestedColumns(nextId, undefined));
    const resetDataLeakageMessage = () => dispatch(nextReducer.updateDataLeakageMessage(nextId, undefined));
    const resetSimpleFlowStep = () => dispatch(nextReducer.updateSimpleFlowStep(nextId, undefined));
    const resetSimpleFlowStepDisplay = () => dispatch(nextReducer.updateSimpleFlowStepDisplay(nextId, undefined));
    const handleReset = () => {
        resetSuggestedColumns();
        resetDataLeakageMessage();
        resetSimpleFlowStep();
        resetSimpleFlowStepDisplay();
    };
    const [mutliType, setMultiType] = useState("Datasets");
    const chatApps = useSelector((state) => viewReducer.getChatApps(state));
    const retChatApps = (chatApps ?? []).filter((c) => (bothData ?? []).find((b) => b.id === c?.wizard?.datasetId) !== undefined);
    const multiChatApps = useSelector((state) => chatGPTReducer.getMultiChatApps(state));
    const multi_SummarizePrompt = useSelector((state) => chatGPTReducer.getMulti_SummarizePrompt(state));
    const activeMultiDataMessageIndex = useSelector((state) => chatGPTReducer.getActiveMultiDataMessageIndex(state));
    return (React.createElement("div", { className: styles.autoImport, id: "multi_data_options_message" },
        isModal === true && (React.createElement("div", { className: styles.multiDSearch },
            React.createElement("div", { style: { width: "400px", marginRight: "10px" } },
                React.createElement(LineInput, { style: { width: "100%" }, value: multiPrompt ?? multiDatasets_Options?.userPrompt, onChange: updateMultiPrompt })),
            React.createElement("div", null,
                React.createElement(Button, { onClick: () => dispatch(chatGPTReducer.askForDataset(multiPrompt)) }, "Update Search")))),
        mutliType === "Datasets" ? (React.createElement("div", { className: styles.tableSelect },
            bothData.map((t_data, i) => {
                // Dataset
                if (t_data?.labels !== undefined) {
                    const savedDataset = t_data;
                    const liveDataset = getDatasetById(t_data?.id);
                    const dataset = {
                        ...savedDataset,
                        ...liveDataset
                    };
                    const dName = dataset?.name;
                    const datasetSourceDisplay = homeReducer.getDatasetSourceDisplay(dataset, schemaMonitors);
                    const datasetTypeLabel = datasetSourceDisplay.label;
                    const datasetIconGray = datasetSourceDisplay.iconGray;
                    const isActive = (ALLOW_MULTIPLE_DATASETS &&
                        multiDatasets.find((d) => d.id === dataset?.id && d.isNLQ !== true) !== undefined) ||
                        (!ALLOW_MULTIPLE_DATASETS && datasetId == dataset?.id);
                    const isActive_NLQ = ALLOW_MULTIPLE_DATASETS &&
                        multiDatasets.find((d) => d.id === dataset?.id && d.isNLQ === true) !== undefined;
                    const columns = dataset && dataset.labels ? dataset.labels : false;
                    const columnCount = columns ? columns.length : 0;
                    const rowCount = dataset.rowCount ? dataset.rowCount : 0;
                    const foundDataOption = multiDatasets.find((d) => d.id === dataset?.id);
                    const retDataOption = foundDataOption !== undefined
                        ? datasetBlueprintOptions.find((bp) => bp.id === foundDataOption.blueprintId)
                        : undefined;
                    const handleClick = () => {
                        handleReset();
                        if (ALLOW_MULTIPLE_DATASETS) {
                            const retMultiDatasets = [...multiDatasets];
                            if (multiDatasets.findIndex((f) => f.id === dataset?.id) !== -1) {
                                dispatch(chatGPTReducer.updateMultiDatasets(retMultiDatasets.filter((d) => d?.id !== dataset?.id)));
                            }
                            else {
                                if (dataset?.outcome === undefined) {
                                    retMultiDatasets.push({
                                        label: dataset.name,
                                        value: dataset.id + "_" + "CHATAIBLE_SQL",
                                        id: dataset.id,
                                        blueprintId: "CHATAIBLE_SQL",
                                        parentBlueprintId: "CHATAIBLE_SQL",
                                        icon: multiNLQIcon
                                    });
                                }
                                else {
                                    retMultiDatasets.push({
                                        label: dataset.name,
                                        value: dataset.id + "_" + "CHATAIBLE_ANALYTICS",
                                        id: dataset.id,
                                        blueprintId: "CHATAIBLE_ANALYTICS",
                                        parentBlueprintId: "CHATAIBLE_ANALYTICS",
                                        icon: multiAnalyticsIcon
                                    });
                                }
                                dispatch(chatGPTReducer.updateMultiDatasets(retMultiDatasets.filter((d) => d !== undefined && d !== null)));
                                if ((prompt === undefined || prompt === "") && message?.user_prompt !== undefined) {
                                    dispatch(chatGPTReducer.updatePrompt(message?.user_prompt));
                                }
                            }
                        }
                        else {
                            if (hasDatasetSelected) {
                                //return;
                            }
                            if (!hasOneActive && savedPreviousState === undefined) {
                                updateSavedPreviousState({
                                    blueprintId: blueprintId,
                                    datasetId: datasetId
                                });
                            }
                            else if (hasOneActive && isActive && savedPreviousState !== undefined) {
                                dispatch(chatGPTReducer.selectBlueprint(savedPreviousState?.blueprintId));
                                dispatch(nextReducer.updateDatasetId(nextId, savedPreviousState?.datasetId ?? "new"));
                                updateSavedPreviousState(undefined);
                            }
                            if (hasOneActive) {
                                updateMultipleDocuments({});
                            }
                            if (isActive) {
                                dispatch(chatGPTReducer.updateShowTemplateRecommendations(false));
                                dispatch(chatGPTReducer.updateActiveMultiDataMessageIndex(undefined));
                                dispatch(nextReducer.updateDatasetId(nextId, "new"));
                                dispatch(chatGPTReducer.updatePrompt(""));
                                dispatch(chatGPTReducer.updateShouldInit(false));
                            }
                        }
                    };
                    const handleSelect = () => {
                        dispatch(nextReducer.updateDatasetId(nextId, dataset.id));
                        if (!liveDataset || !liveDataset?.pivot_tables) {
                            dispatch(homeReducer.fetchDataset(dataset.id, undefined, true));
                        }
                        dispatch(chatGPTReducer.resetChatAppBlueprint());
                        handleReset();
                        if (artifactId && !isNaN(artifactId)) {
                            dispatch(chatGPTReducer.updateArtifactId(undefined));
                        }
                        dispatch(chatGPTReducer.updatePrompt(message?.user_prompt ?? prompt));
                        dispatch(chatGPTReducer.updateShowTemplateRecommendations(true));
                        if (activeMultiDataMessageIndex !== message?.messageIndex) {
                            dispatch(chatGPTReducer.updateActiveMultiDataMessageIndex(message?.messageIndex));
                        }
                        dispatch(chatGPTReducer.updateShouldInit(true));
                    };
                    return (React.createElement("div", { className: styles.askDataHolder, key: "dataset_" + dataset?.id, onClick: () => {
                            handleClick();
                            if (!((isActive && chatType === "SQL") || isActive_NLQ)) {
                                handleSelect();
                                if (chatType !== "SQL") {
                                    dispatch(chatGPTReducer.selectBlueprint(CHATAIBLE_SQL.id));
                                    dispatch(nextReducer.updateIsKPISelectionOpen(nextId, false));
                                }
                            }
                        } },
                        React.createElement("div", { className: styles.tableItem + " " + (isActive || isActive_NLQ ? styles.tableItemActive : ""), key: "multiple_data_" + i },
                            React.createElement("div", { className: styles.tableDataset },
                                React.createElement("div", { className: styles.tableDatasetItem, style: { marginBottom: "10px" } },
                                    React.createElement("div", { className: styles.tableIcon },
                                        React.createElement("img", { src: isActive ? datasetIconGray : datasetIconGray, alt: datasetTypeLabel })),
                                    React.createElement("div", { className: styles.datasetLabel },
                                        React.createElement("div", { className: styles.tableLabel }, dName),
                                        dataset?.rank !== undefined && dataset?.rank !== 9999 && (React.createElement("div", { className: styles.foundDatasetRank }, dataset?.rank === 1
                                            ? "Best Match"
                                            : dataset?.rank === 2
                                                ? "2nd Best Match"
                                                : dataset?.rank === 3
                                                    ? "3rd Best Match"
                                                    : dataset?.rank + "th Best Match")))),
                                dataset?.description !== undefined && (React.createElement("div", { className: styles.foundDatasetDescription }, dataset?.description)),
                                React.createElement("div", { className: styles.tableDatasetItem, style: { marginTop: "10px" } },
                                    React.createElement("div", { className: styles.tableDatasetDetails, style: { flexGrow: 1 } },
                                        dataset?.id !== undefined && (React.createElement(TileItem, { icon: "dataset", className: styles.tableDatasetDetailItem }, "ID: " + dataset?.id)),
                                        dataset?.outcome !== undefined && rowCount > 0 && (React.createElement(TileItem, { icon: isActive ? "rows" : "rows", className: styles.tableDatasetDetailItem },
                                            dataset?.outcome !== undefined && (React.createElement("span", null, (rowCount > 1000 ? numeral(rowCount).format("0.0a") : rowCount) + " Rows, ")),
                                            (columnCount > 1000 ? numeral(columnCount).format("0.0a") : columnCount) + " Columns")))))),
                        ALLOW_MULTIPLE_DATASETS && (React.createElement("div", { className: styles.multiAskOptions },
                            React.createElement(Select, { options: datasetBlueprintOptions, value: retDataOption !== undefined ? retDataOption : datasetBlueprintOptions?.[0], onChange: (val) => {
                                    if (!isOptionType(val)) {
                                        return;
                                    }
                                    console.log("wat is val", val);
                                    const retMultiDatasets = [...multiDatasets.filter((d) => d.id !== dataset.id)];
                                    if (val.value !== "None") {
                                        retMultiDatasets.push({
                                            label: (isNaN(val?.value) ? "" : "(" + val?.label + ") ") + dataset.name,
                                            value: dataset.id + "_" + val?.value,
                                            id: dataset.id,
                                            blueprintId: val?.value,
                                            parentBlueprintId: val.blueprintId,
                                            icon: val?.blueprintId === "CHATAIBLE_ANALYTICS" ? multiAnalyticsIcon : multiNLQIcon
                                        });
                                    }
                                    dispatch(chatGPTReducer.updateMultiDatasets(retMultiDatasets));
                                } })))));
                }
                // Document
                else {
                    const doc = t_data;
                    const dName = doc?.name;
                    const isActive = (ALLOW_MULTIPLE_DATASETS && multiDatasets.find((d) => d?.id === doc?.id) !== undefined) ||
                        (!ALLOW_MULTIPLE_DATASETS && artifactId === doc.id);
                    const foundDocOption = multiDatasets.find((d) => d.id === doc?.id);
                    const retDocOption = foundDocOption !== undefined
                        ? documentBlueprintOptions.find((bp) => bp.id === foundDocOption.blueprintId)
                        : undefined;
                    return (React.createElement("div", { className: styles.askDataHolder, key: "document_" + doc?.id, onClick: () => {
                            if (!ALLOW_MULTIPLE_DATASETS) {
                                if (!hasOneActive && savedPreviousState === undefined) {
                                    updateSavedPreviousState({
                                        blueprintId: blueprintId,
                                        datasetId: datasetId
                                    });
                                }
                                else if (hasOneActive && isActive && savedPreviousState !== undefined) {
                                    dispatch(chatGPTReducer.selectBlueprint(savedPreviousState?.blueprintId));
                                    dispatch(nextReducer.updateDatasetId(nextId, savedPreviousState?.datasetId ?? "new"));
                                    updateSavedPreviousState(undefined);
                                }
                                if (hasOneActive) {
                                    updateMultipleDatasets_NLQ({});
                                }
                                if (isActive) {
                                    dispatch(chatGPTReducer.updateShowTemplateRecommendations(false));
                                    dispatch(chatGPTReducer.updateActiveMultiDataMessageIndex(undefined));
                                    dispatch(chatGPTReducer.updateArtifactId(undefined));
                                    dispatch(chatGPTReducer.updatePrompt(""));
                                }
                                else {
                                    if (chatType !== "DOCUMENT") {
                                        dispatch(chatGPTReducer.selectBlueprint(CHATAIBLE_DOCUMENT_SUMMARIZATION.id));
                                    }
                                    dispatch(chatGPTReducer.updateArtifactId(doc?.id));
                                    if (!isNaN(savedPreviousState ? savedPreviousState?.datasetId : datasetId)) {
                                        dispatch(nextReducer.updateDatasetId(nextId, "new"));
                                    }
                                    dispatch(chatGPTReducer.updatePrompt(message?.user_prompt ?? prompt));
                                    dispatch(chatGPTReducer.updateShowTemplateRecommendations(true));
                                    if (activeMultiDataMessageIndex !== message?.messageIndex) {
                                        dispatch(chatGPTReducer.updateActiveMultiDataMessageIndex(message?.messageIndex));
                                    }
                                }
                            }
                        } },
                        React.createElement("div", { className: styles.tableItem + " " + (isActive ? styles.tableItemActive : ""), key: "multiple_data_" + i, onClick: isEnabled("multi-document-dataset")
                                ? () => {
                                    const retMultiDatasets = [...multiDatasets];
                                    if (multiDatasets.findIndex((f) => f.value === doc?.id) !== -1) {
                                        delete retMultiDatasets[multiDatasets.findIndex((f) => f.value === doc?.id)];
                                    }
                                    else {
                                        retMultiDatasets.push({
                                            label: doc?.name,
                                            value: doc?.id,
                                            isDocument: true,
                                            id: doc.id,
                                            icon: multiDocIcon,
                                            blueprintId: "CHATAIBLE_DOCUMENT_SUMMARIZATION",
                                            parentBlueprintId: "CHATAIBLE_DOCUMENT_SUMMARIZATION"
                                        });
                                        if (prompt === undefined || prompt === "") {
                                            dispatch(chatGPTReducer.updatePrompt(message?.user_prompt ?? prompt));
                                        }
                                    }
                                    dispatch(chatGPTReducer.updateMultiDatasets(retMultiDatasets.filter((d) => d !== undefined && d !== null)));
                                }
                                : () => null },
                            React.createElement("div", { className: styles.tableDataset },
                                React.createElement("div", { className: styles.tableDatasetItem },
                                    React.createElement("div", { className: styles.tableIcon },
                                        React.createElement("img", { src: documentSetIconGray })),
                                    React.createElement("div", { style: { flexGrow: 1, textAlign: "left" } },
                                        React.createElement("div", { className: styles.tableLabel }, dName))),
                                doc?.rank !== undefined && doc?.rank !== 9999 && (React.createElement("div", { className: styles.foundDatasetRank }, doc?.rank === 1
                                    ? "Best Match"
                                    : doc?.rank === 2
                                        ? "2nd Best Match"
                                        : doc?.rank === 3
                                            ? "3rd Best Match"
                                            : doc?.rank + "th Best Match")),
                                doc?.description !== undefined && (React.createElement("div", { className: styles.foundDatasetDescription }, doc?.description)))),
                        ALLOW_MULTIPLE_DATASETS && (React.createElement("div", { className: styles.multiAskOptions },
                            React.createElement(Select, { options: documentBlueprintOptions, value: retDocOption !== undefined ? retDocOption : documentBlueprintOptions?.[0], onChange: (val) => {
                                    if (!isOptionType(val)) {
                                        return;
                                    }
                                    console.log("wat is val", val);
                                    const retMultiDatasets = [...multiDatasets.filter((d) => d.id !== doc.id)];
                                    if (val.value !== "None") {
                                        retMultiDatasets.push({
                                            label: (isNaN(val?.id) ? "" : "(" + val?.label + ") ") + doc.name,
                                            value: doc.id + "_" + val?.id,
                                            id: doc.id,
                                            isDocument: true,
                                            parentBlueprintId: val.blueprintId,
                                            blueprintId: val?.id,
                                            icon: multiDocIcon
                                        });
                                    }
                                    dispatch(chatGPTReducer.updateMultiDatasets(retMultiDatasets));
                                } })))));
                }
            }),
            ALLOW_MULTIPLE_DATASETS && (React.createElement("div", { className: styles.multipleActions },
                hasOneActive && (React.createElement(Button, { type: "secondary", onClick: () => {
                        updateIsDataAsking(true);
                        updateIsMultiDataModal?.(false);
                        if (singleDataset) {
                            dispatch(chatGPTReducer.initFromDataset(singleDataset?.id, message?.user_prompt)).then(() => {
                                updateIsDataAsking(false);
                            });
                        }
                        else {
                            dispatch(chatGPTReducer.askChatGPT_MultipleDatasets_Helper(message?.user_prompt)).then(() => {
                                updateIsDataAsking(false);
                            });
                        }
                        return Promise.resolve();
                    }, isLoading: isAsking, style: { margin: "0px 10px 0px -5px" } }, "Agentic Analytics Chat")),
                React.createElement(Button, { onClick: () => updateIsMultiDataModal?.(false), type: "secondary" }, "Update Selections"))))) : mutliType === "Chat Apps" ? (React.createElement("div", { className: styles.tableSelect },
            retChatApps.map((cApp, i) => {
                const cDataset = (datasets ?? []).find((d) => d.id === cApp?.wizard?.datasetId);
                return (React.createElement("div", { className: styles.askDataHolder, key: "chatapp_" + cApp?.id, onClick: () => {
                        dispatch(chatGPTReducer.updateMultiChatApps({
                            ...multiChatApps,
                            [cApp?.id]: !multiChatApps?.[cApp?.id]
                        }));
                    } },
                    React.createElement("div", { className: styles.tableItem + " " + (multiChatApps?.[cApp?.id] === true ? styles.tableItemActive : ""), key: "multiple_data_" + i, onClick: () => console.log("click chat app") },
                        React.createElement("div", { className: styles.tableDataset },
                            React.createElement("div", { className: styles.tableDatasetItem },
                                React.createElement("div", { style: { flexGrow: 1, textAlign: "left" } },
                                    React.createElement("div", { className: styles.tableLabel }, cApp?.name))),
                            cApp?.wizard?.description !== undefined && (React.createElement("div", { className: styles.foundDatasetDescription, style: { color: "#666" } }, cApp?.wizard?.description)),
                            React.createElement("div", { className: styles.tableDatasetItem, style: { marginTop: "10px" } },
                                React.createElement("div", { className: styles.tableDatasetDetails, style: { flexGrow: 1 } }, cApp?.wizard?.datasetId !== undefined && (React.createElement("div", { style: { color: "#666" } }, "Dataset: " + cDataset?.label + " (" + cApp?.wizard?.datasetId + ")"))))))));
            }),
            Object.keys(multiChatApps ?? {}).reduce((a, b) => a + (multiChatApps?.[b] === true ? 1 : 0), 0) > 1 && (React.createElement("div", { style: { marginTop: "10px" } },
                React.createElement("div", null, "Edit Multiple Summarize Prompt"),
                React.createElement("textarea", { className: styles.multi_SummarizePrompt, value: multi_SummarizePrompt, onChange: (val) => dispatch(chatGPTReducer.updateMulti_SummarizePrompt(val.currentTarget.value)) }))))) : (React.createElement("div", null))));
};
const MultiDataSelect = () => {
    debug("Render: MultiDataSelect");
    const dispatch = useDispatch();
    const conversation = useSelector((state) => chatGPTReducer.getConversation(state));
    const multiDatasets = useSelector((state) => chatGPTReducer.getMultiDatasets(state));
    const multiDatasets_Options = useSelector((state) => chatGPTReducer.getMultiDatasets_Options(state));
    const blueprintOptions = useSelector((state) => viewReducer.getChatBlueprintOptions(state));
    const isSummaryMulti = useSelector((state) => chatGPTReducer.getIsSummaryMulti(state));
    const multiDataMessages = keysOf(conversation)
        .filter((cKey) => conversation[cKey]?.askChatGPT_MultipleDatasets !== undefined ||
        conversation[cKey]?.askChatGPT_MultipleDocuments !== undefined)
        .map((cKey) => conversation[cKey]);
    const multiOptions = [];
    if (multiDatasets_Options !== undefined) {
        multiDatasets_Options.datasets.forEach((d) => {
            blueprintOptions?.dataset?.forEach((bOptions) => {
                multiOptions.push({
                    label: (isNaN(bOptions?.id) ? "" : "(" + bOptions?.name + ") ") + d.name,
                    value: d.id + "_" + bOptions?.id,
                    id: d.id,
                    blueprintId: bOptions?.id,
                    parentBlueprintId: bOptions.blueprintId,
                    icon: bOptions?.blueprintId === "CHATAIBLE_ANALYTICS" ? multiAnalyticsIcon : multiNLQIcon
                });
            });
        });
        multiDatasets_Options.documents.forEach((d) => {
            blueprintOptions?.dataset?.forEach((bOptions) => {
                multiOptions.push({
                    label: (isNaN(bOptions?.id) ? "" : "(" + bOptions?.name + ") ") + d.name,
                    value: d.id + "_" + bOptions?.id,
                    id: d.id,
                    isDocument: true,
                    blueprintId: bOptions?.id,
                    parentBlueprintId: bOptions.blueprintId,
                    icon: multiDocIcon
                });
            });
        });
    }
    else {
        multiDataMessages.forEach((m) => {
            m?.askChatGPT_MultipleDatasets?.forEach((d) => {
                blueprintOptions?.dataset?.forEach((bOptions) => {
                    multiOptions.push({
                        label: (isNaN(bOptions?.id) ? "" : "(" + bOptions?.name + ") ") + d.name,
                        value: d.id + "_" + bOptions?.id,
                        id: d.id,
                        blueprintId: bOptions?.id,
                        parentBlueprintId: bOptions.blueprintId,
                        icon: bOptions?.blueprintId === "CHATAIBLE_ANALYTICS" ? multiAnalyticsIcon : multiNLQIcon
                    });
                });
            });
            m?.askChatGPT_MultipleDocuments?.forEach((d) => {
                blueprintOptions?.dataset?.forEach((bOptions) => {
                    multiOptions.push({
                        label: (isNaN(bOptions?.id) ? "" : "(" + bOptions?.name + ") ") + d.name,
                        value: d.id + "_" + bOptions?.id,
                        id: d.id,
                        isDocument: true,
                        blueprintId: bOptions?.id,
                        parentBlueprintId: bOptions.blueprintId,
                        icon: multiDocIcon
                    });
                });
            });
        });
    }
    return (React.createElement("div", { className: styles.multiDataHolder },
        React.createElement("div", null, "I will scan"),
        React.createElement("div", { className: styles.multiDataSelect },
            React.createElement(Select, { options: multiOptions, isMulti: isEnabled("multi-document-dataset"), menuPlacement: "top", onChange: (val, e) => {
                    dispatch(chatGPTReducer.updateMultiDatasets(e?.option === undefined
                        ? val
                        : [...val.filter((m) => m.value === e.option.value || m.id !== e.option.id)]));
                }, value: multiDatasets, components: {
                    Option: IconOption,
                    MultiValueLabel: MultiValueLabel
                } })),
        React.createElement("div", null, "to answer your questons"),
        React.createElement("div", { className: styles.sumFlex },
            React.createElement("div", { style: { marginLeft: "10px", marginRight: "3px" } }, "Combine into one summary"),
            React.createElement("input", { type: "checkbox", onClick: () => dispatch(chatGPTReducer.updateIsSummaryMulti(!isSummaryMulti)), checked: isSummaryMulti }),
            React.createElement(Button, { style: { padding: "3px", marginLeft: "10px", fontWeight: "normal" }, onClick: () => dispatch(chatGPTReducer.updateIsMultiDataModal(true)) }, "View Data Selections"))));
};
const MaskedInputItem = ({ promptItem, index, isDisabled }) => {
    debug("Render: MaskedInputItem");
    const dispatch = useDispatch();
    const maskedFieldOptions = useSelector((state) => chatGPTReducer.getMaskedFieldOptions(state));
    const maskedPrompt = useSelector((state) => chatGPTReducer.getMaskedPrompt(state));
    return (React.createElement("div", { className: styles.maskedPromptItemWrapper, key: "prompt_" + index },
        promptItem?.map((mp, i) => {
            if (typeof mp === "string") {
                return (React.createElement("div", { className: styles.maskedPromptItemInput, key: `promptItem_${index}_${i}` },
                    React.createElement(LineInput, { style: { maxWidth: "unset" }, isSenseBox: true, value: mp, onChange: (val) => {
                            const retMaskedPrompt = maskedPrompt ? [...maskedPrompt] : [];
                            const retPromptItem = retMaskedPrompt[index] ?? ["", undefined, ""];
                            retMaskedPrompt[index] = [...retPromptItem];
                            retMaskedPrompt[index][i] = val;
                            dispatch(chatGPTReducer.parseAndUpdateMaskedPrompt(retMaskedPrompt));
                        }, isDisabled: isDisabled })));
            }
            return (React.createElement("div", { className: styles.maskedPromptItemSelect, key: `promptItem_${index}_${i}` },
                React.createElement(Select, { options: maskedFieldOptions, onChange: (val) => {
                        const emptySearch = val === undefined || val.length === 0;
                        const retMaskedPrompt = maskedPrompt ? [...maskedPrompt] : [];
                        const retPromptItem = retMaskedPrompt[index] ?? ["", undefined, ""];
                        retMaskedPrompt[index] = [...retPromptItem];
                        retMaskedPrompt[index][i] = emptySearch ? undefined : val;
                        dispatch(chatGPTReducer.parseAndUpdateMaskedPrompt(retMaskedPrompt));
                    }, menuPlacement: "top", value: mp, isMulti: true, placeholder: "Select Values", isDisabled: isDisabled })));
        }),
        React.createElement("div", { className: styles.maskedPromptItemActions }, index > 0 ? (React.createElement(Button, { style: { marginRight: "8px" }, onClick: () => {
                const retMaskedPrompt = maskedPrompt ? [...maskedPrompt] : [];
                retMaskedPrompt.splice(index, 1);
                dispatch(chatGPTReducer.parseAndUpdateMaskedPrompt(retMaskedPrompt));
            }, isSmall: true, disabled: isDisabled }, "Remove")) : (maskedPrompt?.length === 1 && (React.createElement(Button, { style: { marginRight: "8px" }, onClick: () => {
                const retMaskedPrompt = maskedPrompt ? [...maskedPrompt] : [];
                retMaskedPrompt[0] = ["", undefined, ""];
                dispatch(chatGPTReducer.parseAndUpdateMaskedPrompt(retMaskedPrompt));
            }, isSmall: true, disabled: isDisabled }, "Clear"))))));
};
const MaskedInput = ({ isDisabled }) => {
    debug("Render: MaskedInput");
    const dispatch = useDispatch();
    const maskedPrompt = useSelector((state) => chatGPTReducer.getMaskedPrompt(state));
    const retMaskedPrompt = maskedPrompt?.length ? maskedPrompt : [["", undefined, ""]];
    const allowAdd = true;
    return (React.createElement("div", { className: styles.maskedPromptWrapper },
        retMaskedPrompt?.map((promptItem, i) => {
            return React.createElement(MaskedInputItem, { key: i, promptItem: promptItem, index: i, isDisabled: isDisabled });
        }),
        allowAdd && (React.createElement(Button, { style: { margin: "0px auto" }, onClick: () => {
                const retMaskedPrompt = maskedPrompt
                    ? [...maskedPrompt, ["", undefined, ""]]
                    : [
                        ["", undefined, ""],
                        ["", undefined, ""]
                    ];
                dispatch(chatGPTReducer.parseAndUpdateMaskedPrompt(retMaskedPrompt));
            }, isSmall: true, disabled: isDisabled }, "+"))));
};
const RawInput = ({ isNoDataset, tempPrompt, updateTempPrompt, usecaseSelectorRef, inputBoxRef, tryChatTemplate }) => {
    const dispatch = useDispatch();
    const chatClearInput = useSelector((state) => chatGPTReducer.getChatClearInput(state));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const isEmailApp = useSelector((state) => chatGPTReducer.getIsEmailApp(state));
    const retEmailUser = useSelector((state) => chatGPTReducer.getRetEmailUser(state));
    const prompt = useSelector((state) => chatGPTReducer.getPrompt(state));
    const isSmallScreen = useSelector((state) => viewReducer.getIsSmallScreen(state));
    const promptPlaceholder = useSelector((state) => chatGPTReducer.getPromptPlaceholder(state, isNoDataset));
    const isDisabled = useSelector((state) => chatGPTReducer.getIsPromptInputDisabled(state));
    const isExecutiveSummary = useSelector((state) => chatGPTReducer.getIsExecutiveSummary(state));
    const canSummarize = isExecutiveSummary && !tempPrompt;
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const isNextSaving = useSelector((state) => nextReducer.getIsSavingReport(state, nextId));
    const blueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const agentIqTools = useSelector((state) => chatGPTReducer.getAgentIQTools(state));
    const disableQuestions = isAsking ||
        (isEmailApp && retEmailUser === undefined) ||
        isNextSaving ||
        isDisabled ||
        !(canSummarize || tempPrompt) ||
        (blueprintId === "AGENT_IQ" && !agentIqTools?.length);
    const isMac = viewReducer.getIsMac();
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const isWhatsChangedApp = chatType === "WHATS_CHANGED" && !tryChatTemplate;
    const isTemplate = location.pathname.indexOf("chatTemplate") !== -1;
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const agentSimpleAnalyticsView = useSelector((state) => viewReducer.getAgentSimpleAnalyticsView(state));
    const useAgentSimpleAnalytics = agentSimpleAnalyticsView;
    const isAnalyticsChat = chatType === "AIBLE" || chatType === "WHATS_CHANGED";
    const agentId = useSelector((state) => chatGPTReducer.getAgentId(state));
    const agent = useSelector((state) => agentId === undefined ? {} : aibleAnywhereReducer.getAibleAnywhere(state, agentId));
    return (React.createElement("textarea", { className: styles.chatPrompt, autoFocus: true, placeholder: agent?.inputPlaceholder && agent?.inputPlaceholder?.length > 0
            ? agent?.inputPlaceholder
            : isSmallScreen
                ? "Start chatting..."
                : promptPlaceholder, value: tempPrompt, onChange: (val) => updateTempPrompt(val.target.value), onBlur: () => {
            if (tempPrompt != prompt) {
                dispatch(chatGPTReducer.updatePrompt(tempPrompt, false));
            }
        }, disabled: isDisabled, onKeyDown: (e) => {
            if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                if (!disableQuestions) {
                    if (tempPrompt != prompt) {
                        dispatch(chatGPTReducer.updatePrompt(tempPrompt, false));
                    }
                    dispatch(chatGPTReducer.submitQuestion({
                        isChatTemplate: tryChatTemplate,
                        isSimpleAgentAnalytics: useAgentSimpleAnalytics && isAnalyticsChat
                    }));
                    dispatch(chatGPTReducer.updateShowBlueprintMessage(false));
                    if (chatClearInput) {
                        updateTempPrompt("");
                    }
                }
            }
            if ((isMac && e.metaKey && e.key === "e") || (!isMac && e.ctrlKey && e.key === "e")) {
                e.preventDefault();
                const usecaseSelector = usecaseSelectorRef?.current;
                if (usecaseSelector) {
                    usecaseSelector.focus();
                }
            }
            return;
        }, style: isSmallScreen
            ? { height: "32px", flex: "1", marginRight: "8px" }
            : isWhatsChangedApp
                ? { height: "40px" }
                : undefined, ref: inputBoxRef }));
};
const PromptInput = ({ isSenseMode, isNoDataset, updateIsHideChatBox, showMobileSelectors, updateShowMobileSelectors, usecaseSelectorRef, inputBoxRef, tryChatTemplate, nlqDashFooter }) => {
    debug("Render: PromptInput");
    const dispatch = useDispatch();
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const prompt = useSelector((state) => chatGPTReducer.getPrompt(state));
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const isSmallScreen = useSelector((state) => viewReducer.getIsSmallScreen(state));
    const useSecurityMasking = useSelector((state) => chatGPTReducer.getUseSecurityMasking(state));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const chatButtonDarkMode = useSelector((state) => chatGPTReducer.getChatButtonDarkMode(state));
    const modelId = useSelector((state) => chatGPTReducer.getModelId(state));
    const isSecondary = useSelector((state) => chatGPTReducer.isPromptInputSecondary(state));
    const isEmailApp = useSelector((state) => chatGPTReducer.getIsEmailApp(state));
    const isNextSaving = useSelector((state) => nextReducer.getIsSavingReport(state, nextId));
    const isDisabled = useSelector((state) => chatGPTReducer.getIsPromptInputDisabled(state));
    const isExecutiveSummary = useSelector((state) => chatGPTReducer.getIsExecutiveSummary(state));
    const isAskingSuggestQuestions = useSelector((state) => chatGPTReducer.getIsAskingSuggestQuestions(state));
    const chatClearInput = useSelector((state) => chatGPTReducer.getChatClearInput(state));
    const hasNoRetEmailUser = useSelector((state) => chatGPTReducer.getRetEmailUser(state) === undefined);
    const allowedAppUseCaseCount = useSelector((state) => chatAppReducer.getAllowedAppUseCases(state)?.length);
    const allowedAppDatasetCount = useSelector((state) => chatAppReducer.getAllowedAppDatasets(state)?.length);
    const allowedAppDocumentCount = useSelector((state) => chatAppReducer.getAllowedAppDocuments(state)?.length);
    const linkColorDarkMode = useSelector((state) => chatGPTReducer.getLinkColorDarkMode(state));
    const isChatDashboard = useSelector((state) => nextReducer.getActiveTab(state, nextId) === "NLQ Dashboard");
    const hasReplayPrompts = useSelector((state) => chatGPTReducer.getReplayPrompts(state)?.length > 0);
    const retEmailUser = useSelector((state) => chatGPTReducer.getRetEmailUser(state));
    const [tempPrompt, updateTempPrompt] = useState(chatClearInput ? "" : prompt);
    const canSummarize = isExecutiveSummary && !tempPrompt;
    // TODO: Remove chat app branding? We are taking out the chataible branding and updating the ask buttons to not use this.
    const buttonText = chatApp?.wizard?.chatButtonCompany ? `${chatApp?.wizard?.chatButtonCompany} AI` : "ChatAible";
    const chatButtonDarkColor = "#1F181C";
    const linkColorDarkColor = "#1F181C";
    const disableReplayAsk = useSelector((state) => chatGPTReducer.getDisableReplayAsk(state));
    const comparisonOptions = useSelector((state) => nextReducer.getComparisonOptions(state, nextId));
    const blueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const agentIqTools = useSelector((state) => chatGPTReducer.getAgentIQTools(state));
    const [showDaterange, setShowDaterange] = useState(false);
    const disableQuestions = isAsking ||
        (isEmailApp && retEmailUser === undefined) ||
        isNextSaving ||
        isDisabled ||
        !(canSummarize || tempPrompt) ||
        (chatType === "AIBLE" && dataset && dataset.outcome === undefined) ||
        (blueprintId === "AGENT_IQ" && !agentIqTools?.length);
    const isTemplate = location.pathname.indexOf("chatTemplate") !== -1;
    const showChatInputs = isEmailApp !== true;
    const agentId = useSelector((state) => chatGPTReducer.getAgentId(state));
    const agent = useSelector((state) => agentId === undefined ? {} : aibleAnywhereReducer.getAibleAnywhere(state, agentId));
    const isAskingAgent = useSelector((state) => chatGPTReducer.getIsAskingAgent(state));
    const chatTone = useSelector((state) => chatGPTReducer.getChatTone(state));
    const chatTones = useSelector((state) => chatGPTReducer.getChatToneOptions(state));
    const updateChatTone = (chatTone) => {
        dispatch(chatGPTReducer.updateChatTone(chatTone));
        document.querySelector("body")?.click();
    };
    const datasetFields = Object.values(dataset?.fields ?? {});
    const retDatasetFields = dataset?.ranked_fields ?? datasetFields;
    const datasetDateOptions = retDatasetFields.filter((f) => f.type === "date");
    const canShowDaterange = showDaterange &&
        (chatType === "WHATS_CHANGED" || chatType === "KPI_ANALYSIS") &&
        Boolean(datasetDateOptions?.length || comparisonOptions?.dateField) &&
        Boolean(dataset);
    const agentSimpleAnalyticsView = useSelector((state) => viewReducer.getAgentSimpleAnalyticsView(state));
    const useAgentSimpleAnalytics = agentSimpleAnalyticsView;
    const isAnalyticsChat = chatType === "AIBLE" || chatType === "WHATS_CHANGED";
    const useCache = useSelector((state) => chatGPTReducer.getMaxCacheAge(state) !== undefined);
    const toolCallsDisplayMode = useSelector((state) => chatGPTReducer.getToolCallsDisplayMode(state));
    const updateToolCallsDisplayMode = (mode) => {
        dispatch(chatGPTReducer.updateToolCallsDisplayMode(mode));
    };
    return (React.createElement("div", { className: styles.promptInputsWrapper },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: isSmallScreen ? styles.mobilePromptRow : undefined },
                useAgentSimpleAnalytics && isAnalyticsChat ? (React.createElement(NextSearchContainer, { id: nextId, isOnlySearch: true, isSimpleAgentAnalytics: true, hideMargins: true, isHideSearchType: true, searchSelectStyle: { marginLeft: "0px", width: "100%" }, style: { position: "relative", top: "0px", marginLeft: "0px" }, menuPlacement: "top", maxSearchOptionsDisplayed: 3, maxSelectedOptions: 3 })) : useSecurityMasking && chatType === "AIBLE" ? (React.createElement(MaskedInput, null)) : (React.createElement(RawInput, { key: prompt, isNoDataset: isNoDataset, tempPrompt: tempPrompt, updateTempPrompt: updateTempPrompt, usecaseSelectorRef: usecaseSelectorRef, inputBoxRef: inputBoxRef, tryChatTemplate: tryChatTemplate })),
                isSmallScreen && (React.createElement(Button, { style: {
                        color: chatButtonDarkMode ? chatButtonDarkColor : "",
                        padding: "3px",
                        paddingRight: "6px",
                        ...(chatApp?.wizard?.chatButtonColor !== undefined
                            ? {
                                background: chatApp?.wizard?.chatButtonColor,
                                borderColor: chatApp?.wizard?.chatButtonColor
                            }
                            : {})
                    }, className: chatApp?.wizard?.chatButtonColor !== undefined ? styles.forceButtonHover : "", onClick: () => {
                        if (tempPrompt != prompt) {
                            dispatch(chatGPTReducer.updatePrompt(tempPrompt, false));
                        }
                        dispatch(chatGPTReducer.submitQuestion({
                            isChatTemplate: tryChatTemplate,
                            isSimpleAgentAnalytics: useAgentSimpleAnalytics && isAnalyticsChat
                        }));
                        dispatch(chatGPTReducer.updateShowBlueprintMessage(false));
                        if (chatClearInput) {
                            updateTempPrompt("");
                            dispatch(chatGPTReducer.updatePromptAttachments(undefined));
                        }
                    }, type: isSecondary ? "secondary" : "primary", disabled: disableQuestions, isLoading: isAsking || isAskingAgent },
                    React.createElement("img", { src: paperPlaneWhiteIcon })))),
            canShowDaterange && React.createElement(WhatsChangedInput, { fullWidthRangeStyle: true }),
            React.createElement("div", { className: styles.footerButtons }, isNextSaving ? (React.createElement(React.Fragment, null,
                React.createElement("div", { style: {
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        marginLeft: "108px",
                        color: "#7E7D9A",
                        height: "38px"
                    } },
                    React.createElement(LoadingIndicator, { style: {
                            margin: "0px",
                            display: "flex",
                            justifyContent: "center",
                            transform: "scale(0.5)",
                            marginRight: "11px"
                        }, color: "#B5B4D0" }),
                    isAsking === true ? (isEmailApp ? "Generating email..." : "Evaluating...") : "Saving..."),
                isAsking === true && (React.createElement(Button, { className: styles.footerCancelButton, onClick: () => {
                        dispatch(chatGPTReducer.cancelChat());
                    }, style: {
                        color: linkColorDarkMode
                            ? linkColorDarkColor
                            : chatApp?.wizard?.linkColor !== undefined
                                ? "#ffffff"
                                : "",
                        ...(chatApp?.wizard?.linkColor !== undefined
                            ? {
                                background: chatApp?.wizard?.linkColor,
                                borderColor: chatApp?.wizard?.linkColor
                            }
                            : {})
                    } },
                    React.createElement(FontAwesomeIcon, { icon: faTimes, style: { marginRight: "10px" } }),
                    isEmailApp || isSmallScreen ? "Cancel" : "Cancel Chat")))) : isSenseMode && !isSmallScreen ? (React.createElement("div", null,
                React.createElement(Button, { onClick: () => {
                        if (tempPrompt != prompt) {
                            dispatch(chatGPTReducer.updatePrompt(tempPrompt, false));
                        }
                        if (chatClearInput) {
                            updateTempPrompt("");
                            dispatch(chatGPTReducer.updatePromptAttachments(undefined));
                        }
                        if (chatApp?.id !== undefined) {
                            return dispatch(chatGPTReducer.chatAppPrompt(prompt, undefined, tryChatTemplate, undefined, undefined, useAgentSimpleAnalytics && isAnalyticsChat));
                        }
                        else if (isEmailApp) {
                            return dispatch(chatGPTReducer.emailAppPrompt(prompt));
                        }
                        else {
                            return dispatch(chatGPTReducer.askChatGPTSenseIntro(prompt));
                        }
                    }, style: { marginLeft: "5px", fontSize: "13px" }, type: "primary", disabled: (isEmailApp && hasNoRetEmailUser) || !tempPrompt }, isEmailApp ? "Generate Email" : "Agentic Analytics Chat"))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.footerSpacerButtons },
                    agentId !== undefined && isEnabled("agent-voice") && (React.createElement(VoiceButton, { setUserPrompt: (vPrompt) => {
                            updateTempPrompt(vPrompt);
                            dispatch(chatGPTReducer.updatePrompt(vPrompt));
                        } })),
                    React.createElement("div", { style: { display: "flex", gap: "10px" } },
                        showChatInputs && chatType !== "OPENSHELL" && (React.createElement(StandardChatInputs, { showMobileSelectors: showMobileSelectors, usecaseSelectorRef: usecaseSelectorRef, inputBoxRef: inputBoxRef, tryChatTemplate: tryChatTemplate, nlqDashFooter: nlqDashFooter, showDaterange: showDaterange, setShowDaterange: setShowDaterange })),
                        !isTemplate && chatType !== "OPENSHELL" && (React.createElement(OverlayTrigger, { placement: "top", trigger: "click", rootClose: true, overlay: React.createElement(Popover, { id: "popover-positioned-top", bsClass: "chat-tones-popover popover" },
                                React.createElement("div", { style: { display: "flex", flexFlow: "column", padding: "5px 0" } },
                                    React.createElement("div", { style: { fontWeight: 700, marginBottom: "4px", padding: "0 10px" } }, "Select a tone"),
                                    React.createElement("div", { style: { height: "150px", overflowX: "hidden" } },
                                        React.createElement("div", { style: {
                                                width: "100%",
                                                height: "100%",
                                                overflowX: "scroll",
                                                display: "flex",
                                                flexFlow: "column"
                                            } }, chatTones?.length > 0 &&
                                            chatTones.map(({ label, value, rawTone }) => (React.createElement("a", { style: { padding: "5px 10px" }, className: clsx(styles.chatToneItem, value === chatTone && styles.active), onClick: () => updateChatTone(value), key: `chatTone__id__${rawTone?.id}` }, label))))),
                                    chatTones?.length === 0 && React.createElement("span", { style: { padding: "5px 10px" } }, "No available tones"))) },
                            React.createElement(Button, { style: { padding: "9px 11px" } },
                                React.createElement("img", { src: PenIcon }))))),
                    chatType === "OPENSHELL" && (React.createElement("div", { className: "flex items-center ml-auto mr-[10px]" },
                        React.createElement(ButtonGroup, null, TOOL_CALLS_DISPLAY_OPTIONS.map((option) => (React.createElement(Button, { key: option, onClick: () => updateToolCallsDisplayMode(option), style: {
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                padding: "9px 11px",
                                fontWeight: "normal"
                            }, active: option === toolCallsDisplayMode, greyscaleDefaultState: true },
                            React.createElement("img", { src: TOOL_CALLS_DISPLAY_MODE_ICONS[option], style: { width: "16px", height: "16px" } }),
                            option)))))),
                    React.createElement("div", { style: { display: "flex" } },
                        isEnabled("chat-suggest-questions") &&
                            (chatType === "DOCUMENT" || chatType === "AIBLE") &&
                            !isChatDashboard &&
                            (isAskingSuggestQuestions ? (React.createElement("div", { className: styles.suggestedLoadingWrapper, style: { position: "relative" } },
                                React.createElement(LoadingIndicator, { style: { margin: "0px", scale: ".6", position: "absolute", left: "-58px" } }),
                                isSmallScreen
                                    ? "Finding questions..."
                                    : `Finding questions from this ${chatType === "DOCUMENT" ? "document set" : "dataset"}`)) : (React.createElement(Button, { onClick: () => {
                                    if (tempPrompt != prompt) {
                                        dispatch(chatGPTReducer.updatePrompt(tempPrompt));
                                    }
                                    dispatch(chatGPTReducer.suggestQuestions());
                                }, style: {
                                    marginRight: "10px",
                                    whiteSpace: "nowrap",
                                    padding: "10px 19px"
                                } }, isSmallScreen ? (React.createElement("img", { src: crystalBallIcon, className: styles.mobileImageIcon })) : ("Suggest Questions")))),
                        isEnabled("auto-apply-chats") && hasReplayPrompts && !(isAsking || isNextSaving) && (React.createElement(Button, { disabled: disableReplayAsk, onClick: () => {
                                dispatch(chatGPTReducer.askMultiModels([{ value: modelId, label: modelId }], undefined, tryChatTemplate));
                            }, style: {
                                color: linkColorDarkMode
                                    ? linkColorDarkColor
                                    : chatApp?.wizard?.linkColor !== undefined
                                        ? "#ffffff"
                                        : "",
                                padding: "10px 19px",
                                ...(chatApp?.wizard?.linkColor !== undefined
                                    ? {
                                        background: chatApp?.wizard?.linkColor,
                                        borderColor: chatApp?.wizard?.linkColor
                                    }
                                    : {}),
                                marginRight: "10px",
                                whiteSpace: "nowrap"
                            } }, isSmallScreen ? (React.createElement("img", { src: sparklesImg, className: styles.mobileImageIcon })) : ("Ask Saved Questions"))),
                        isSmallScreen &&
                            chatType !== "OPENSHELL" &&
                            !(chatApp?.id &&
                                allowedAppUseCaseCount <= 1 &&
                                allowedAppDatasetCount <= 1 &&
                                allowedAppDocumentCount <= 1 &&
                                chatType !== "WHATS_CHANGED") && (React.createElement(Button, { onClick: () => {
                                updateShowMobileSelectors(!showMobileSelectors);
                            }, active: showMobileSelectors, style: { marginRight: "10px" } },
                            React.createElement("img", { src: gearGrayIcon, className: styles.mobileImageIcon }))),
                        agentId !== undefined && (React.createElement(Button, { style: {
                                marginRight: "10px",
                                fontSize: "13px"
                            }, onClick: () => {
                                if (agent?.executionId !== undefined && agent?.runToggle === "BACKEND") {
                                    return dispatch(chatGPTReducer.handleAgentIQ(prompt, false, "step-by-step", agent?.executionId, agent?.id, undefined, useCache, true));
                                }
                                dispatch(chatGPTReducer.handleAibleAnywhereSteps(agent, prompt));
                            }, isLoading: isAsking || isAskingAgent, type: "Primary" }, "Agentic Analytics Chat")),
                        isAsking === true && agentId === undefined && (React.createElement(Button, { onClick: () => {
                                dispatch(chatGPTReducer.cancelChat());
                            }, style: {
                                color: linkColorDarkMode
                                    ? linkColorDarkColor
                                    : chatApp?.wizard?.linkColor !== undefined
                                        ? "#ffffff"
                                        : "",
                                padding: "10px 19px",
                                whiteSpace: "nowrap",
                                ...(chatApp?.wizard?.linkColor !== undefined
                                    ? {
                                        background: chatApp?.wizard?.linkColor,
                                        borderColor: chatApp?.wizard?.linkColor
                                    }
                                    : {})
                            } },
                            React.createElement(FontAwesomeIcon, { icon: faTimes, style: { marginRight: "10px" } }),
                            isEmailApp || isSmallScreen ? "Cancel" : "Cancel Chat")),
                        isAskingAgent === true && (agentId !== undefined || chatType === "OPENSHELL") && (React.createElement(Button, { onClick: () => {
                                dispatch(chatGPTReducer.cancelAgent());
                            }, style: {
                                color: linkColorDarkMode
                                    ? linkColorDarkColor
                                    : chatApp?.wizard?.linkColor !== undefined
                                        ? "#ffffff"
                                        : "",
                                ...(chatApp?.wizard?.linkColor !== undefined
                                    ? {
                                        background: chatApp?.wizard?.linkColor,
                                        borderColor: chatApp?.wizard?.linkColor
                                    }
                                    : {})
                            } },
                            React.createElement(FontAwesomeIcon, { icon: faTimes, style: { marginRight: "10px" } }),
                            isEmailApp || isSmallScreen ? "Cancel" : "Cancel Chat")),
                        !(isEnabled("chat-suggest-questions") && isAskingSuggestQuestions) && nlqDashFooter && (React.createElement(Button, { onClick: () => {
                                updateIsHideChatBox(true);
                                if (localStorage) {
                                    localStorage.setItem("chatGpt_isHideChatBox", "true");
                                }
                            } }, isSmallScreen ? React.createElement("img", { src: minimizeIcon, className: styles.mobileImageIcon }) : "Hide Chat")),
                        !isSmallScreen && (React.createElement("div", { className: styles.chatSecurityItem, style: {
                                marginRight: "10px",
                                marginTop: "0px",
                                flexGrow: 1,
                                maxWidth: isEnabled("chat-aible-advanced-controls") ? "450px" : "300px",
                                whiteSpace: "nowrap"
                            } })),
                        isEnabled("chat-suggest-questions") && agentId === undefined && isAskingSuggestQuestions ? (React.createElement(Button, { onClick: () => {
                                dispatch(chatGPTReducer.cancelChat());
                            }, style: {
                                color: linkColorDarkMode
                                    ? linkColorDarkColor
                                    : chatApp?.wizard?.linkColor !== undefined
                                        ? "#ffffff"
                                        : "",
                                whiteSpace: "nowrap",
                                padding: "10px 19px",
                                ...(chatApp?.wizard?.linkColor !== undefined
                                    ? {
                                        background: chatApp?.wizard?.linkColor,
                                        borderColor: chatApp?.wizard?.linkColor
                                    }
                                    : {})
                            } }, isSmallScreen ? "Cancel" : "Cancel Chat")) : (!isSmallScreen &&
                            (isAsking !== true || nlqDashFooter) &&
                            agentId === undefined && (React.createElement(Button, { style: {
                                fontSize: "13px",
                                color: chatButtonDarkMode ? chatButtonDarkColor : "",
                                whiteSpace: "nowrap",
                                padding: "10px 19px",
                                ...(chatApp?.wizard?.chatButtonColor !== undefined
                                    ? {
                                        background: chatApp?.wizard?.chatButtonColor,
                                        borderColor: chatApp?.wizard?.chatButtonColor
                                    }
                                    : {})
                            }, className: chatApp?.wizard?.chatButtonColor !== undefined ? styles.forceButtonHover : "", onClick: () => {
                                if (tempPrompt != prompt) {
                                    dispatch(chatGPTReducer.updatePrompt(tempPrompt));
                                }
                                if (chatClearInput) {
                                    updateTempPrompt("");
                                    dispatch(chatGPTReducer.updatePromptAttachments(undefined));
                                }
                                dispatch(chatGPTReducer.submitQuestion({
                                    isChatTemplate: tryChatTemplate,
                                    isSimpleAgentAnalytics: useAgentSimpleAnalytics && isAnalyticsChat
                                }));
                                dispatch(chatGPTReducer.updateShowBlueprintMessage(false));
                            }, type: isSecondary ? "secondary" : "primary", disabled: disableQuestions, isLoading: isAsking || isAskingAgent, loadingText: isEmailApp ? "Generate Email" : canSummarize ? `Summarize` : `Ask` },
                            isEmailApp ? "Generate Email" : canSummarize ? `Summarize` : `Ask`,
                            React.createElement(FontAwesomeIcon, { icon: faArrowRight, style: { marginLeft: "10px" } }))))))))))));
};
const HiddenFooter = ({ updateIsHideChatBox }) => {
    return (React.createElement("div", { className: styles.mFooter },
        React.createElement("div", { className: styles.footerWrapperEmpty },
            React.createElement("div", { className: styles.settingsBoxEmpty },
                React.createElement(Button, { onClick: () => {
                        updateIsHideChatBox(false);
                        if (localStorage) {
                            localStorage.setItem("chatGpt_isHideChatBox", "false");
                        }
                    } }, "Show Chat")))));
};
const RecommendedOptionsPopupContainer = () => {
    const dispatch = useDispatch();
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const updateShowRecommendedOptions = (val) => dispatch(chatGPTReducer.updateShowRecommendedOptions(val));
    const selectBlueprint = (blueprintId) => dispatch(chatGPTReducer.selectBlueprint(blueprintId));
    return (React.createElement(RecommendedOptionsPopup, { datasetId: datasetId, artifactId: artifactId, chatType: chatType, selectBlueprint: selectBlueprint, handleClose: () => {
            updateShowRecommendedOptions(false);
        } }));
};
const BlueprintInputContainer = ({ usecaseSelectorRef, inputBoxRef }) => {
    const dispatch = useDispatch();
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const showRecommendedOptions = useSelector((state) => chatGPTReducer.getShowRecommendedOptions(state));
    const showBlueprintMessage = useSelector((state) => chatGPTReducer.getShowBlueprintMessage(state));
    return (React.createElement(BlueprintSelector, { isDynamic: true, isStyled: true, menuPlacement: "top", style: {
            marginLeft: "-5px"
        }, color: chatApp?.wizard?.linkColor, popover: showBlueprintMessage ? (React.createElement(BlueprintPopup, { handleClose: () => {
                dispatch(chatGPTReducer.updateShowBlueprintMessage(false));
            }, onClick: () => {
                console.log("click");
                dispatch(chatGPTReducer.selectBlueprint(CHATAIBLE_SQL.id));
            } })) : showRecommendedOptions ? (React.createElement(RecommendedOptionsPopupContainer, null)) : undefined, onChange: isEnabled("multi-document-dataset")
            ? (val) => dispatch(chatGPTReducer.selectBlueprintAndUpdateMultiDatasets(val))
            : undefined, innerRef: usecaseSelectorRef, onChangeFocus: inputBoxRef }));
};
export const WhatsChangedInput = ({ fullWidthRangeStyle, senseDatasetId, isManualApply, isChatTemplate, isWhatsChangedOverview, defaultDatasetId, hideDatesOutsideRange, updateHideDatesOutsideRange }) => {
    debug("Render: WhatsChangedInput");
    const dispatch = useDispatch();
    const currentNextId = useSelector((state) => nextReducer.getCurrentNextId(state)) ?? "new";
    const nextId = senseDatasetId ? "DATASET_" + senseDatasetId : currentNextId;
    let datasetId;
    if (senseDatasetId) {
        datasetId = senseDatasetId;
    }
    else if (defaultDatasetId) {
        datasetId = defaultDatasetId;
    }
    else {
        datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    }
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const comparisonOptions = useSelector((state) => nextReducer.getComparisonOptions(state, nextId));
    const dateColumn = useSelector((state) => homeReducer.getKPIAnalysisDateColumn(state, datasetId));
    const KPIDateRange = useSelector((state) => homeReducer.getKPIDateRange(state, datasetId));
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const changeTimestampColumn = (datasetId, timestampCol) => dispatch(homeReducer.changeTimestampColumn(datasetId, timestampCol));
    const [WHATS_CHANGEDReanalysis, updateWHATS_CHANGEDReanalysis] = useState(false);
    const [originalDateColumn, updateOriginalDateColumn] = useState(dateColumn);
    const timeBucket = useSelector((state) => homeReducer.getKPIAnalysisTimeBucket(state, datasetId));
    const isWeekStartSun = useSelector((state) => homeReducer.getKPIAnalysisWeekStartSun(state, datasetId));
    const [localTimeBucket, updateLocalTimeBucket] = useState(timeBucket);
    const [localIsWeekStartSun, updateLocalIsWeekStartSun] = useState(isWeekStartSun);
    const hasUpdatedTimeBucket = localTimeBucket !== timeBucket;
    const hasUpdatedIsWeekStartSun = localIsWeekStartSun !== isWeekStartSun;
    const hasUpdatedTimeSetting = hasUpdatedTimeBucket || hasUpdatedIsWeekStartSun;
    const isProcessing = dataset?.status_name && dataset?.status_name !== "DONE";
    // Reset local state when datasetId switches
    useEffect(() => {
        updateLocalTimeBucket(timeBucket);
        updateLocalIsWeekStartSun(isWeekStartSun);
    }, [datasetId, isProcessing]);
    let fields = dataset?.ranked_fields;
    if (!fields && dataset?.fields) {
        fields = Object.keys(dataset.fields).map((fKey) => dataset.fields[fKey]);
    }
    // Null check due to this component being rendered before dataset details finishes downloading
    if (!fields) {
        fields = [];
    }
    const dates = fields.find((f) => f.label === comparisonOptions?.dateField)?.data;
    const filteredDates = (dates ?? [])?.filter((d) => d?.value !== "{Missing}");
    const getNumberOfMissingDates = () => {
        if (filteredDates?.length > 0 && (dates ?? [])?.length - filteredDates?.length === 1) {
            if (dataset?.mappings) {
                const fieldIndex = dataset?.fields?.[comparisonOptions?.dateField ?? ""]?.index;
                const dateMappingMissing = dataset?.mappings?.[fieldIndex]?.[2]?.missing;
                return dateMappingMissing;
            }
            return undefined;
        }
        return 0;
    };
    const getRowsIgnoredText = () => {
        const numberOfMissingDates = getNumberOfMissingDates();
        if (numberOfMissingDates > 0) {
            return `rows ignored (including ${numberOfMissingDates} missing ${numberOfMissingDates === 1 ? "date" : "dates"} which cannot be selected).`;
        }
        if (numberOfMissingDates === undefined) {
            return "rows ignored (including some missing dates which cannot be selected).";
        }
        return "rows ignored.";
    };
    const dateFieldOptions = fields !== undefined
        ? fields
            .filter((f) => f.type === "date")
            .map((f) => ({
            value: f.label,
            label: f.label
        }))
        : [];
    const datasetDateField = dataset?.options?.timestamp_column;
    useEffect(() => {
        let retComparisonOptions = {};
        if (!comparisonOptions || senseDatasetId || isChatTemplate) {
            retComparisonOptions = {
                ...KPIDateRange,
                dateField: dateColumn ?? datasetDateField
            };
        }
        else {
            retComparisonOptions = {
                ...comparisonOptions
            };
        }
        if (!retComparisonOptions.dateField) {
            if (dateColumn) {
                retComparisonOptions.dateField = dateColumn;
            }
            else if (datasetDateField) {
                retComparisonOptions.dateField = datasetDateField;
            }
            else {
                retComparisonOptions.dateField = dateFieldOptions?.[0]?.label;
                retComparisonOptions.referenceStart = undefined;
                retComparisonOptions.referenceEnd = undefined;
                retComparisonOptions.currentStart = undefined;
                retComparisonOptions.currentEnd = undefined;
            }
        }
        // On sense tile, repopulate date range from KPIDateRange if new comparison dateField is the same as original kpi dateColumn
        const resetDateSettings = comparisonOptions?.dateField && originalDateColumn && comparisonOptions.dateField === originalDateColumn;
        // Pass dates as an array to check if any are undefined or missing from dates data
        const checkIsMissingDateOption = (datesArr) => {
            const isMissing = datesArr.some((date) => {
                if (date === undefined) {
                    return true;
                }
                const foundDate = filteredDates?.find((fDate) => fDate?.value === date);
                if (!foundDate) {
                    return true;
                }
                return false;
            });
            return isMissing;
        };
        const comparisonDates = [
            retComparisonOptions?.currentEnd,
            retComparisonOptions?.currentStart,
            retComparisonOptions?.referenceEnd,
            retComparisonOptions?.referenceStart
        ];
        const missingDateRange = checkIsMissingDateOption(comparisonDates);
        if (senseDatasetId && resetDateSettings) {
            if (missingDateRange) {
                retComparisonOptions = {
                    ...KPIDateRange,
                    dateField: comparisonOptions?.dateField
                };
            }
        }
        // Populating the initial comparisonOption date references if they don't exist or if a date is not found in
        // filteredDates (fixes broken state but now requires all valid dates to be saved correctly).
        // Using new function to check default date indices, 3 months start/end, 4 weeks start/end, 7 days (or whatever date unit) start/end otherwise
        if (retComparisonOptions?.dateField && missingDateRange) {
            const datasetTimeBucket = dataset?.options?.kpi_analysis?.time_bucket;
            const { refStart, refEnd, currStart, currEnd } = getDefaultDateIndices(filteredDates, datasetTimeBucket);
            retComparisonOptions.referenceStart = filteredDates[refStart]?.value;
            retComparisonOptions.referenceEnd = filteredDates[refEnd]?.value;
            retComparisonOptions.currentStart = filteredDates[currStart]?.value;
            retComparisonOptions.currentEnd = filteredDates[currEnd]?.value;
        }
        dispatch(nextReducer.updateComparisonOptions(nextId, retComparisonOptions));
    }, [datasetId, comparisonOptions?.dateField, dateColumn, dataset?.status_name]);
    const dateAnalysisState = {
        ...comparisonOptions,
        selectedDateField: dataset?.fields?.[comparisonOptions?.dateField ?? ""] || undefined,
        dateAnalysisTarget: "EXPLORE"
    };
    const dateValues = calculateDateValues(dataset, dateAnalysisState);
    const { currentStart, currentEnd, referenceStart, referenceEnd, dateRowsExcluded, dateRowsBefore, dateFieldMax, dateRowsAfter, dateAnalysisTarget } = dateValues;
    const pieData = [
        {
            name: "rows ignored",
            value: dateRowsExcluded,
            color: "#C8CAD4"
        },
        {
            name: " training rows",
            value: dateRowsBefore,
            color: "#8884d8"
        },
        {
            name: " comparison rows",
            value: dateRowsAfter,
            color: "#34D399"
        }
    ];
    const getDateRangeStyle = () => {
        if (senseDatasetId) {
            return {
                width: "calc(100% - 20px)",
                marginTop: "0px",
                fontSize: "13px"
            };
        }
        if (fullWidthRangeStyle) {
            return {
                width: "100%",
                marginTop: "0px",
                fontSize: "13px"
            };
        }
        return {
            width: "50%",
            minWidth: "200px",
            maxWidth: "300px",
            marginTop: "0px",
            fontSize: "13px"
        };
    };
    if (!dataset || dataset?.status_name !== "DONE") {
        return null;
    }
    const updateDateAnalysisState = (senseId, dateAnalysis) => {
        dispatch(updateTileState(senseId, { dateAnalysis }));
    };
    const timeBucketOptions = [
        // {label: "Hour", value: "H"},
        { label: "Day", value: "D" },
        { label: "Week", value: "W" },
        { label: "Month", value: "M" }
    ];
    const disableSenseReAnalysis = Boolean(senseDatasetId && !localTimeBucket);
    if (!senseDatasetId &&
        isChatTemplate &&
        !isWhatsChangedOverview &&
        (!dataset?.outcome || dataset?.status_name !== "DONE")) {
        return React.createElement("div", null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                display: "flex",
                alignItems: "center",
                marginBottom: "20px"
            } },
            React.createElement("div", { style: {
                    fontSize: "14px",
                    fontWeight: "bold",
                    marginRight: "8px"
                } }, "Date Field:"),
            React.createElement(DynamicWidthSelector, { options: dateFieldOptions, onChange: (v) => {
                    if (isOptionType(v) && v?.value !== comparisonOptions?.dateField) {
                        const retComparisonOptions = {
                            ...comparisonOptions,
                            dateField: v?.label,
                            referenceStart: undefined,
                            referenceEnd: undefined,
                            currentStart: undefined,
                            currentEnd: undefined
                        };
                        dispatch(nextReducer.updateComparisonOptions(nextId, retComparisonOptions));
                        if (senseDatasetId) {
                            updateDateAnalysisState(senseDatasetId, { ...retComparisonOptions });
                        }
                    }
                    if (isOptionType(v) && v?.label !== dateColumn && datasetId !== undefined) {
                        dispatch(homeReducer.updateKPIAnalysisDateColumn(datasetId, v?.label));
                        const newDateRange = {
                            referenceStart: undefined,
                            referenceEnd: undefined,
                            currentStart: undefined,
                            currentEnd: undefined
                        };
                        dispatch(homeReducer.updateKPIDateRange(datasetId, newDateRange));
                    }
                }, 
                // isStyled
                // isDynamic
                isDisabled: !dataset, menuPlacement: "top", value: comparisonOptions?.dateField
                    ? {
                        label: comparisonOptions.dateField,
                        value: comparisonOptions.dateField
                    }
                    : undefined, placeholder: !dataset ? "No Dataset Selected" : "Select a Date Field", color: chatApp?.wizard?.linkColor, style: { minWidth: "200px" } })),
        (senseDatasetId || isChatTemplate) && dates && dates.length > 1 && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.kpiSettingsItemFlex },
                React.createElement("div", { className: styles.kpiSettingsItemTitle, style: { marginRight: "auto", fontWeight: "normal" } }, "Set the time interval for the horizontal axis:"),
                timeBucketOptions.map((option) => {
                    return (React.createElement("div", { key: "timebucket_" + option.value, className: styles.kpiOptionsRadioButton, onClick: () => {
                            if (localTimeBucket !== option.value) {
                                return updateLocalTimeBucket(option.value);
                            }
                        } },
                        React.createElement("input", { type: "radio", checked: localTimeBucket === option.value }),
                        React.createElement("span", { className: styles.kpiOptionsRadioLabel }, option.label)));
                })),
            localTimeBucket === "W" && (React.createElement("div", { className: styles.kpiSettingsItemFlex },
                React.createElement("div", { className: styles.kpiSettingsItemTitle, style: { marginRight: "auto", fontWeight: "normal" } }, "Which day does the week start on?"),
                React.createElement("div", { className: styles.kpiOptionsRadioButton, onClick: () => {
                        if (!localIsWeekStartSun) {
                            return updateLocalIsWeekStartSun(true);
                        }
                    } },
                    React.createElement("input", { type: "radio", checked: localIsWeekStartSun }),
                    React.createElement("span", { className: styles.kpiOptionsRadioLabel }, "Sunday")),
                React.createElement("div", { className: styles.kpiOptionsRadioButton, onClick: () => {
                        if (localIsWeekStartSun) {
                            return updateLocalIsWeekStartSun(false);
                        }
                    } },
                    React.createElement("input", { type: "radio", checked: !localIsWeekStartSun }),
                    React.createElement("span", { className: styles.kpiOptionsRadioLabel }, "Monday")))))),
        dates && dates.length === 1 && (React.createElement(Alert, { bsStyle: "warning" },
            React.createElement("strong", null, comparisonOptions?.dateField),
            " currently includes only one date field. What's Changed analyses require a minimum of two date fields to proceed.")),
        comparisonOptions?.dateField !== undefined &&
            (dataset?.status_name !== "DONE" && dataset?.status_name !== "ERROR" ? (React.createElement(React.Fragment, null,
                React.createElement("div", null, "This dataset is being analyzed."),
                React.createElement("div", { style: {
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "8px",
                        position: "relative",
                        height: 50
                    } },
                    React.createElement(LoadingIndicator, { style: {
                            margin: "0px",
                            transform: "scale(0.5)",
                            position: "absolute"
                        } })))) : comparisonOptions?.dateField !== datasetDateField || WHATS_CHANGEDReanalysis ? (React.createElement(React.Fragment, null,
                React.createElement("div", null, "This dataset will need to be reanalyzed to see what's changed."),
                React.createElement("div", { style: {
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "8px"
                    } },
                    React.createElement(Button, { type: "primary", onClick: async () => {
                            updateWHATS_CHANGEDReanalysis(true);
                            dispatch(homeReducer.updateIsSavingKPISettings(datasetId, true));
                            try {
                                if (senseDatasetId || isChatTemplate) {
                                    if (dateColumn !== comparisonOptions?.dateField && comparisonOptions?.dateField !== undefined) {
                                        dispatch(homeReducer.updateKPIAnalysisDateColumn(datasetId, comparisonOptions?.dateField));
                                    }
                                    dispatch(homeReducer.updateKPIAnalysisTimeBucket(datasetId, localTimeBucket));
                                    dispatch(homeReducer.updateKPIAnalysisWeekStartSun(datasetId, localIsWeekStartSun));
                                    await dispatch(homeReducer.saveKPISettings(datasetId, comparisonOptions?.dateField));
                                }
                                else if (comparisonOptions?.dateField !== undefined) {
                                    await changeTimestampColumn(dataset.id, comparisonOptions?.dateField);
                                    const resetComparisonOptions = {
                                        dateField: comparisonOptions?.dateField
                                    };
                                    dispatch(nextReducer.updateComparisonOptions(nextId, resetComparisonOptions));
                                }
                            }
                            catch (e) {
                                console.log(e);
                            }
                            dispatch(homeReducer.updateIsSavingKPISettings(datasetId, false));
                            updateWHATS_CHANGEDReanalysis(false);
                        }, disabled: disableSenseReAnalysis, isLoading: WHATS_CHANGEDReanalysis }, "Analyze " + comparisonOptions?.dateField)))) : (senseDatasetId || isChatTemplate) && hasUpdatedTimeSetting ? (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement(Button, { onClick: () => {
                            if (!dateColumn && comparisonOptions?.dateField !== undefined) {
                                dispatch(homeReducer.updateKPIAnalysisDateColumn(datasetId, comparisonOptions?.dateField));
                            }
                            dispatch(homeReducer.updateKPIAnalysisTimeBucket(datasetId, localTimeBucket));
                            dispatch(homeReducer.updateKPIAnalysisWeekStartSun(datasetId, localIsWeekStartSun));
                            const newDateRange = {
                                referenceStart: undefined,
                                referenceEnd: undefined,
                                currentStart: undefined,
                                currentEnd: undefined
                            };
                            dispatch(homeReducer.updateKPIDateRange(datasetId, newDateRange));
                            dispatch(homeReducer.saveKPISettings(datasetId));
                        }, style: { marginRight: "10px" } }, "Update Time Setting"),
                    React.createElement(Button, { onClick: () => {
                            updateLocalTimeBucket(timeBucket);
                            updateLocalIsWeekStartSun(isWeekStartSun);
                        }, style: { marginRight: "10px" } }, "Reset Time Setting")))) : (React.createElement(React.Fragment, null,
                React.createElement(SmallDateChart, { datasetId: datasetId, timeBucketOverride: localTimeBucket, updateComparisonOptions: (data) => {
                        dispatch(nextReducer.updateComparisonOptions(nextId, data));
                        if (senseDatasetId) {
                            updateDateAnalysisState(senseDatasetId, { ...data });
                        }
                    }, comparisonOptions: comparisonOptions, field: dataset?.fields?.[comparisonOptions?.dateField], style: getDateRangeStyle(), isSense: senseDatasetId ? true : undefined, isManualApply: isManualApply ?? true }),
                dates && dates.length > 1 && (React.createElement(React.Fragment, null,
                    isChatTemplate && updateHideDatesOutsideRange ? (React.createElement("div", { style: { display: "flex", alignItems: "center", marginTop: "8px" } },
                        React.createElement("div", { className: styles.wizardBoldText }, "Limit charts to Reference and Current Period?"),
                        React.createElement(LabeledToggle, { style: { display: "block", marginLeft: "10px" }, checked: hideDatesOutsideRange, onChange: () => {
                                updateHideDatesOutsideRange(!hideDatesOutsideRange);
                            }, isAibleColors: true }))) : null,
                    React.createElement("div", { style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexGrow: 1,
                            width: "100%",
                            minHeight: "150px"
                        } },
                        React.createElement("div", { style: { fontSize: "13px", width: "calc(100% - 120px)" } },
                            dateRowsExcluded !== undefined && (React.createElement("div", { style: { display: "flex", alignItems: "center" } },
                                React.createElement("div", { style: { background: "#C8CAD4" } }),
                                React.createElement("div", null,
                                    React.createElement("span", { style: { fontWeight: "bold" } }, dateRowsExcluded),
                                    React.createElement("span", { style: { marginLeft: "5px" } }, getRowsIgnoredText())),
                                React.createElement(Tooltip, { overlay: React.createElement("div", null, dateRowsExcluded > 0
                                        ? `Your Exploration will exclude data not in the reference or current periods`
                                        : `Your Exploration will not exclude any rows`) }))),
                            dateRowsAfter !== undefined && (React.createElement("div", null,
                                React.createElement("div", { style: { display: "flex", alignItems: "center" } },
                                    React.createElement("div", { style: { background: "#8884d8" } }),
                                    React.createElement("div", null,
                                        React.createElement("span", { style: { fontWeight: "bold" } }, dateRowsBefore),
                                        React.createElement("span", { style: { marginLeft: "5px" } }, dateRowsBefore
                                            ? `rows from ${referenceStart} and ${referenceEnd} ` +
                                                `will be used for
                                the comparison period for what has changed
                                       `
                                            : "training rows")),
                                    React.createElement(Tooltip, { overlay: React.createElement("div", null, dateRowsBefore === dateFieldMax
                                            ? `Your Exploration will be created using all ${dateRowsBefore} rows`
                                            : `Your Exploration will be created using the ${dateRowsBefore} rows ` +
                                                `from ${referenceStart} to ${referenceEnd}` +
                                                (Boolean(dateRowsAfter) &&
                                                    ` and will compare them to the ${dateRowsAfter} rows ` +
                                                        `from ${currentStart} to ${currentEnd}`)) })),
                                React.createElement("div", { style: { display: "flex", alignItems: "center" } },
                                    React.createElement("div", { style: { background: "#34D399" } }),
                                    React.createElement("div", null,
                                        React.createElement("span", { style: { fontWeight: "bold" } }, dateRowsAfter),
                                        React.createElement("span", { style: { marginLeft: "5px" } }, `rows from ${currentStart} and ${currentEnd} ` +
                                            `will be used for ${dateAnalysisTarget === "CREATE_AI" && "AI evaluation"}`)))))),
                        React.createElement("div", null,
                            React.createElement(PieChart, { width: 100, height: 100 },
                                React.createElement(Pie, { data: pieData, labelLine: false, dataKey: "value", paddingAngle: 0 }, pieData.map((entry, index) => (React.createElement(Cell, { key: `cell-${index}`, fill: entry.color, stroke: entry.color }))))))))))))));
};
const StandardChatInputs = ({ showMobileSelectors, usecaseSelectorRef, inputBoxRef, tryChatTemplate, nlqDashFooter, setShowDaterange, showDaterange }) => {
    debug("Render: ExpandedFooter");
    const dispatch = useDispatch();
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const conversation = useSelector((state) => chatGPTReducer.getConversation(state));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const selectedBlueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const isSmallScreen = useSelector((state) => viewReducer.getIsSmallScreen(state));
    const comparisonOptions = useSelector((state) => nextReducer.getComparisonOptions(state, nextId));
    const updateShowRecommendedOptions = (val) => dispatch(chatGPTReducer.updateShowRecommendedOptions(val));
    const getRecommendedDatasets = (datasetId) => dispatch(chatGPTReducer.getRecommendedDatasets(datasetId));
    const getRecommendedDocumentsets = (artifactId) => dispatch(chatGPTReducer.getRecommendedDocumentSets(artifactId));
    const multiDataMessages = conversation === undefined
        ? []
        : keysOf(conversation)
            .filter((cKey) => conversation[cKey]?.askChatGPT_MultipleDatasets !== undefined ||
            conversation[cKey]?.askChatGPT_MultipleDatasets !== undefined)
            .map((cKey) => conversation[cKey]);
    const handleRecommendedDatasets = (val) => {
        updateShowRecommendedOptions(false);
        getRecommendedDatasets(val);
        if (getRecommendedDatasets(val)?.length > 0 &&
            !getRecommendedDatasets(val)?.some((recommended) => recommended?.id === selectedBlueprintId)) {
            updateShowRecommendedOptions(true);
        }
    };
    const handleRecommendedDocumentsets = (val) => {
        updateShowRecommendedOptions(false);
        getRecommendedDocumentsets(val);
        if (getRecommendedDocumentsets(val)?.length > 0 &&
            !getRecommendedDocumentsets(val)?.some((recommended) => recommended?.id === selectedBlueprintId)) {
            updateShowRecommendedOptions(true);
        }
    };
    const selectorBoxClass = isSmallScreen
        ? showMobileSelectors
            ? styles.mobileSelectorsBox
            : styles.mobileSelectorsBox + " " + styles.mobileSelectorsBoxHidden
        : styles.settingsSelectorsBox;
    const IS_SIMPLE_MODE = true;
    console.log("chatType", chatType);
    console.log("comparisonOptions", comparisonOptions);
    const blueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const agentId = useSelector((state) => chatGPTReducer.getAgentId(state));
    const isWebSearch = useSelector((state) => chatGPTReducer.getIsWebSearch(state));
    const optimizeSetup = useSelector((state) => chatGPTReducer.getOptimizeSetup(state));
    return agentId !== undefined ? (React.createElement("div", null)) : IS_SIMPLE_MODE ? (React.createElement("div", { className: styles.chatLeftActions },
        !(blueprintId === "AGENT_IQ") && optimizeSetup === undefined && (React.createElement(ContextSelectionButtons, { nextId: nextId, nlqDashFooter: nlqDashFooter, setShowDaterange: setShowDaterange, showDaterange: showDaterange, isChatTemplate: tryChatTemplate })),
        isEnabled("chat-agent-iq") && blueprintId == "AGENT_IQ" && (React.createElement("div", { className: styles.agentIQAutoDiscoveryWrapper },
            React.createElement("img", { src: sparklesImg }),
            "Auto-discovery enabled")),
        isEnabled("chat-agent-iq") && blueprintId === "AGENT_IQ_TEAM" && (React.createElement(Button, { active: isWebSearch === true, onClick: () => dispatch(chatGPTReducer.updateIsWebSearch(!isWebSearch)) }, "Web Search")))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: selectorBoxClass },
            React.createElement("div", { className: styles.chatSelectorsCopy }, "I am ready to chat about "),
            React.createElement(BlueprintInputContainer, { usecaseSelectorRef: usecaseSelectorRef, inputBoxRef: inputBoxRef }),
            React.createElement("div", { className: styles.chatSelectorsCopy }, " with a "),
            React.createElement(ToneSelector, { isDynamic: true, isStyled: true, color: chatApp?.wizard?.linkColor, style: {
                    marginLeft: "-5px"
                } }),
            React.createElement("div", { className: styles.chatSelectorsCopy }, " tone using "),
            React.createElement(ModelSelector, { isDynamic: true, isStyled: true, style: {
                    marginLeft: "-5px"
                }, color: chatApp?.wizard?.linkColor ? chatApp?.wizard?.linkColor : "#8556EB", menuPlacement: "top" }),
            chatType === "DOCUMENT" &&
                !(isEnabled("multi-document-dataset") && multiDataMessages !== undefined && multiDataMessages.length > 0) && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.chatSelectorsCopy }, "I will reference "),
                React.createElement(DocumentSelector, { artifactId: artifactId, onChange: (val) => {
                        dispatch(chatGPTReducer.updateArtifactId(val?.id));
                        handleRecommendedDocumentsets(val?.id);
                    }, isDynamic: true, isStyled: true, style: {
                        marginLeft: "-5px"
                    }, color: chatApp?.wizard?.linkColor }),
                React.createElement("div", { className: styles.chatSelectorsCopy }, " to answer your summarization questions."))),
            (chatType === "WHATS_CHANGED" || chatType === "KPI_ANALYSIS" || chatType === "SQL" || chatType === "AIBLE") &&
                !(isEnabled("multi-document-dataset") && multiDataMessages !== undefined && multiDataMessages.length > 0) && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.chatSelectorsCopy }, "I will scan "),
                React.createElement(DatasetSelector, { datasetId: datasetId, onChange: (val) => {
                        if (val !== datasetId) {
                            dispatch(chatGPTReducer.updateShouldInit(true));
                            dispatch(nextReducer.updateDatasetId(nextId, val));
                            handleRecommendedDatasets(val);
                        }
                    }, isDynamic: true, isStyled: true, style: {
                        marginLeft: "-5px"
                    }, allowAllDatasets: chatType === "SQL", menuPlacement: "top", filter: chatType === "WHATS_CHANGED" ? "date" : undefined, color: chatApp?.wizard?.linkColor }),
                chatType === "WHATS_CHANGED" || chatType === "KPI_ANALYSIS" ? (React.createElement(WhatsChangedInput, null)) : (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.chatSelectorsCopy }, ` to answer your ${chatType === "SQL" ? "NLQ" : "analytics"} questions.`))))),
            isEnabled("multi-document-dataset") && multiDataMessages !== undefined && multiDataMessages.length > 0 && (React.createElement(MultiDataSelect, null)),
            React.createElement(FocusVariablePromptInput, null))));
};
const FocusVariablePromptInput = () => {
    const dispatch = useDispatch();
    const useFocusVariable = useSelector((state) => chatGPTReducer.getUseFocusVariable(state));
    const focusVariablePrompt = useSelector((state) => chatGPTReducer.getFocusVariablePrompt(state));
    const focusVariablePlaceholder = useSelector((state) => chatGPTReducer.getFocusVariablePlaceholder(state));
    const focusVariable = useSelector((state) => chatGPTReducer.getFocusVariable(state));
    if (!(isEnabled("chataible-focus-variable") && useFocusVariable)) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginRight: "10px" } }, focusVariablePrompt),
        React.createElement(LineInput, { value: focusVariable, placeholder: focusVariablePlaceholder, onChange: (val) => dispatch(chatGPTReducer.updateFocusVariable(val)) })));
};
const ExpandedFooter = ({ isNoDataset, isSenseMode, updateIsHideChatBox, tryChatTemplate, nlqDashFooter, hideAutonomyControls, safeClawOptimize }) => {
    debug("Render: ExpandedFooter");
    const isSmallScreen = useSelector((state) => viewReducer.getIsSmallScreen(state));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const [showMobileSelectors, updateShowMobileSelectors] = useState(false);
    const usecaseSelectorRef = useRef(null);
    const inputBoxRef = useRef(null);
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const showSettings = useSelector((state) => chatGPTReducer.getShowSettings(state));
    const activeTab = useSelector((state) => nextReducer.getActiveTab(state, nextId));
    const contextSelectionPanelTab = useSelector((state) => chatGPTReducer.getContextSelectionPanelTab(state));
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const history = useHistory();
    const agentId = useSelector((state) => chatGPTReducer.getAgentId(state));
    const agent = useSelector((state) => aibleAnywhereReducer.getAibleAnywhere(state, agentId));
    const optimizeSetup = useSelector((state) => chatGPTReducer.getOptimizeSetup(state));
    console.log("What is agent?", agent);
    const getFooterWrapperStyle = () => {
        if (safeClawOptimize) {
            return { bottom: "0px" };
        }
        if (isEnabled("agent-autonomy-controls")) {
            return { bottom: "70px" };
        }
        return {};
    };
    return agent?.hideInputControls === true ? (React.createElement("div", null)) : (React.createElement("div", { className: styles.mFooter, style: {
            width: 
            // TODO: WTF is this???
            tryChatTemplate
                ? nlqDashFooter
                    ? "60%"
                    : "100%"
                : (optimizeSetup !== undefined || chatType === "OPTIMIZE") && showSettings !== true
                    ? "60%"
                    : chatType === "OPENSHELL"
                        ? "60%"
                        : chatType === "DOCUMENT"
                            ? !contextSelectionPanelTab &&
                                (showSettings === true || activeTab === "NLQ Dashboard" || artifactId === undefined)
                                ? "100%"
                                : "60%"
                            : (!contextSelectionPanelTab || showSettings === true) &&
                                (activeTab === "NLQ Dashboard" ||
                                    datasetId === undefined ||
                                    showSettings === true ||
                                    datasetId === "new")
                                ? "100%"
                                : "60%"
        } },
        React.createElement("div", { className: styles.footerWrapper, style: getFooterWrapperStyle() },
            React.createElement(PromptInput, { isNoDataset: isNoDataset, isSenseMode: isSenseMode, updateIsHideChatBox: updateIsHideChatBox, showMobileSelectors: showMobileSelectors, updateShowMobileSelectors: updateShowMobileSelectors, usecaseSelectorRef: usecaseSelectorRef, inputBoxRef: inputBoxRef, tryChatTemplate: tryChatTemplate, nlqDashFooter: nlqDashFooter })),
        !isSmallScreen && React.createElement(SqlWarningPopup, null),
        !isSmallScreen && React.createElement(LegacyModelWarning, null),
        isEnabled("agent-autonomy-controls") && hideAutonomyControls !== true && (React.createElement("div", { className: styles.agentControls },
            React.createElement(AgentAutonomyControls, { isAgentPage: true, history: history })))));
};
const Footer = ({ isNoDataset, isSenseMode, tryChatTemplate, nlqDashFooter, hideAutonomyControls, safeClawOptimize }) => {
    const [isHideChatBox, updateIsHideChatBox] = useState(localStorage.getItem("chatGpt_isHideChatBox") === "true" ? true : false);
    if (isHideChatBox && nlqDashFooter) {
        return React.createElement(HiddenFooter, { updateIsHideChatBox: updateIsHideChatBox });
    }
    return (React.createElement(ExpandedFooter, { isNoDataset: isNoDataset, isSenseMode: isSenseMode, updateIsHideChatBox: updateIsHideChatBox, tryChatTemplate: tryChatTemplate, nlqDashFooter: nlqDashFooter, hideAutonomyControls: hideAutonomyControls, safeClawOptimize: safeClawOptimize }));
};
const AnalyticsSeeWhatWasSent = ({ message, index }) => {
    debug("Render: AnalyticsSeeWhatWasSent");
    const dispatch = useDispatch();
    const openMessageIndex = useSelector((state) => chatGPTReducer.getOpenMessageIndex(state));
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const modelName = useSelector((state) => chatGPTReducer.getModelName(state));
    return (React.createElement(MessageExpansionItem, { openLabel: "Close", closedLabel: "See what was sent", messageIndex: index, nextId: nextId, dataset: dataset, updateOpenMessageIndex: (openMessageIndex) => dispatch(chatGPTReducer.updateOpenMessageIndex(openMessageIndex)), index: index, isOpen: openMessageIndex === index, modelName: modelName, message: message }, typeof message.jsonData == "string"
        ? message.jsonData
        : `${message?.jsonData?.Dataset}\n\n${message?.jsonData?.Outcome}\n\n${message?.jsonData?.Interactions}\n\n${message?.jsonData?.Charts}`));
};
const ChatSettingsPopover = ({ message }) => {
    const aDataset = useSelector((state) => homeReducer.getDataset(state, message?.datasetId));
    const aDocument = useSelector((state) => message?.artifactName ?? getCorpus(state, message?.artifactId ?? -1)?.name);
    const mModelId = message?.model;
    const mModel = MODEL_OPTIONS?.[mModelId ?? ""];
    const mBlueprintId = message?.analytics?.blueprintId;
    const mBlueprint = useSelector((state) => blueprintReducer.getBlueprint(state, mBlueprintId));
    const mChatToneId = message?.chatTone;
    const mChatTone = useSelector((state) => getTone(state, mChatToneId));
    return (React.createElement(Popover, { id: "popover-positioned-top" },
        React.createElement("div", { className: styles.responseSettingsPopover },
            React.createElement("span", null, "Chat Settings: "),
            React.createElement("span", null, `${mBlueprint?.name} agent template `),
            (aDataset !== undefined || aDocument !== undefined) && (React.createElement("span", null, aDataset !== undefined ? `and ${aDataset?.label} ` : `and ${aDocument} `)),
            React.createElement("span", null, `using ${mModel?.label} `),
            mChatToneId && React.createElement("span", null, `and ${mChatTone?.name} tone`))));
};
const ChatMessageUserFeedbackPopover = ({ feedbackUserList, users }) => {
    return (React.createElement("div", { className: styles.userList }, users
        ?.filter((user) => feedbackUserList?.includes(user?.id))
        ?.map((user) => React.createElement("div", { key: user?.id }, user?.fullname))));
};
const EmailUserSelect = ({ index, emailUsers }) => {
    const dispatch = useDispatch();
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const retEmailUser = useSelector((state) => chatGPTReducer.getRetEmailUser(state));
    const mapper = customMapper((em) => em.label);
    const options = [
        {
            label: "Create New",
            value: "CREATE_NEW",
            email_user: {
                name: "",
                email: "",
                number: ""
            }
        },
        ...emailUsers.map((em) => ({
            label: em.name,
            value: em.name,
            email_user: em
        }))
    ];
    return (React.createElement("div", { className: styles.emailUserSelect },
        React.createElement(ToneSelector, { isDynamic: true, isStyled: true, menuPlacement: index > 0 ? "top" : "bottom", style: {
                marginLeft: "-6px"
            }, color: chatApp?.wizard?.linkColor }),
        React.createElement("div", { style: { marginRight: "5px", padding: "7px 0px" } }, " email from: "),
        React.createElement(DynamicWidthSelector, { options: mapper.mapAll(options), onChange: selectOnChangeWrapper((val) => dispatch(chatGPTReducer.updateEmailUser(val))), value: mapper.map(retEmailUser), isDynamic: true, isStyled: true, menuPlacement: index > 0 ? "top" : "bottom", color: chatApp?.wizard?.linkColor }),
        React.createElement(Button, { onClick: () => {
                if (confirm("Warning this will reset all your added people!")) {
                    localStorage.removeItem("chat_email_users");
                }
            }, style: { marginLeft: "5px", padding: "4px 14px" } }, "Reset")));
};
const ChatExportControls = ({ index }) => {
    const dispatch = useDispatch();
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const isShowPowerBISettings = useSelector((state) => chatGPTReducer.getIsShowPowerBISettings(state));
    const isPowerBIExport = useSelector((state) => chatGPTReducer.getIsPowerBIExport(state));
    return (React.createElement("div", null,
        React.createElement("div", { style: {
                display: "flex",
                alignItems: "center"
            } },
            isEnabled("looker-export") && (React.createElement(Button, { onClick: () => dispatch(chatGPTReducer.exportToLooker(index)), type: "secondary", isSmall: true, style: {
                    whiteSpace: "nowrap",
                    marginRight: "5px"
                } }, "Export to Looker")),
            isEnabled("google-slides-export") && React.createElement(GoogleSlidesExport, { mIndex: index }),
            isEnabled("chat-aible-power-bi") && (React.createElement(ButtonGroup, { style: {
                    marginLeft: "10px",
                    position: "relative"
                } },
                React.createElement(Button, { style: {
                        whiteSpace: "nowrap"
                    }, isSmall: true, onClick: () => dispatch(chatGPTReducer.updateIsShowPowerBISettings(!isShowPowerBISettings)), type: "secondary", active: isShowPowerBISettings }, "Power BI Settings"),
                isPowerBIExport ? (React.createElement(LoadingIndicator, { style: {
                        position: "absolute",
                        top: "-40px",
                        left: "150px"
                    } })) : (React.createElement(PowerBIExportButtonContainer, null)))))));
};
export const ChatMessageContent = ({ content }) => {
    if (typeof content === "string") {
        return React.createElement("div", null, content);
    }
    return (React.createElement(React.Fragment, null, content
        .filter((c) => c.type === "text")
        .map((p, i) => (React.createElement("div", { key: i }, p.text)))));
};
const SimpleDatasetTransform = ({ dataset_transform }) => {
    const dataset = useSelector((state) => homeReducer.getDataset(state, dataset_transform?.dataset_id));
    const userName = useSelector((state) => loginReducer.getUserName(state));
    const userEmail = useSelector((state) => loginReducer.getUserEmail(state));
    const [transformState, updateTransformState] = useState(dataset_transform ?? {});
    const [hasAppliedUpdate, updateHasAppliedUpdate] = useState(false);
    const operationOptions = [
        { label: "+", value: "+" },
        { label: "-", value: "-" },
        { label: "*", value: "*" },
        { label: "/", value: "/" }
    ];
    const isTransformRecommended = JSON.stringify(dataset_transform) === JSON.stringify(transformState);
    return (React.createElement("div", { className: styles.simpleTransform },
        React.createElement("div", { className: styles.simpleTransformSubHeader }, "Transform Dataset: Create Derived Field"),
        React.createElement("div", { className: styles.simpleTransformTile },
            React.createElement("div", { className: styles.simpleTransformHeader }, dataset?.label),
            React.createElement("div", { className: styles.simpleTransformBody },
                React.createElement(Labeled, { label: "First Column", style: { marginBottom: "5px" } },
                    React.createElement(Select, { value: {
                            label: transformState?.column1,
                            value: transformState?.column1
                        }, onChange: (value) => updateTransformState({
                            ...transformState,
                            column1: value?.value
                        }), options: Object.keys(dataset?.fields ?? {})
                            .filter((f) => dataset?.fields?.[f]?.type === "number" || dataset?.fields?.[f]?.isNumeric)
                            .map((f) => ({
                            label: dataset?.fields?.[f]?.label,
                            value: dataset?.fields?.[f]?.label
                        })), placeholder: "First Column", menuPlacement: "bottom" })),
                React.createElement(Labeled, { label: "Operation", style: { marginBottom: "5px" } },
                    React.createElement(Select, { value: {
                            label: transformState?.operator,
                            value: transformState?.operator
                        }, onChange: (value) => updateTransformState({
                            ...transformState,
                            operator: value?.value
                        }), options: operationOptions, placeholder: "Operation", menuPlacement: "bottom" })),
                React.createElement(Labeled, { label: "Second Column", style: { marginBottom: "5px" } },
                    React.createElement(Select, { value: {
                            label: transformState?.column2,
                            value: transformState?.column2
                        }, onChange: (value) => updateTransformState({
                            ...transformState,
                            column2: value?.value
                        }), options: Object.keys(dataset?.fields ?? {})
                            .filter((f) => dataset?.fields?.[f]?.type === "number" || dataset?.fields?.[f]?.isNumeric)
                            .map((f) => ({
                            label: dataset?.fields?.[f]?.label,
                            value: dataset?.fields?.[f]?.label
                        })), placeholder: "Second Column", menuPlacement: "bottom" })),
                React.createElement(Labeled, { label: "Alias", style: { marginBottom: "5px" } },
                    React.createElement(LineInput, { value: transformState?.derived_field_name, onChange: (val) => updateTransformState({
                            ...transformState,
                            derived_field_name: val
                        }) })),
                !hasAppliedUpdate && (React.createElement("div", { className: styles.simpleTransformActions },
                    React.createElement(Button, { onClick: () => {
                            const socket = chatGPTReducer.getWebSocket();
                            if (socket) {
                                socket.send(JSON.stringify({
                                    type: "user_interaction_message",
                                    id: "string",
                                    thread_id: "default",
                                    parent_id: "root",
                                    content: {
                                        messages: [
                                            {
                                                role: "user",
                                                content: [
                                                    {
                                                        type: "text",
                                                        text: JSON.stringify({
                                                            ...transformState,
                                                            permission: "no"
                                                        })
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    timestamp: "string",
                                    user: {
                                        name: userName,
                                        email: userEmail
                                    },
                                    schema_version: "1.0"
                                }));
                                updateHasAppliedUpdate(true);
                            }
                        } }, "Cancel"),
                    React.createElement(Button, { type: "primary", onClick: () => {
                            const socket = chatGPTReducer.getWebSocket();
                            if (socket) {
                                socket.send(JSON.stringify({
                                    type: "user_interaction_message",
                                    id: "string",
                                    thread_id: "default",
                                    parent_id: "root",
                                    content: {
                                        messages: [
                                            {
                                                role: "user",
                                                content: [
                                                    {
                                                        type: "text",
                                                        text: JSON.stringify({
                                                            ...transformState,
                                                            permission: "yes"
                                                        })
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    timestamp: "string",
                                    user: {
                                        name: userName,
                                        email: userEmail
                                    },
                                    schema_version: "1.0"
                                }));
                            }
                            updateHasAppliedUpdate(true);
                        } }, isTransformRecommended ? "Accept Agent Recommendations" : "Apply"))))),
        !hasAppliedUpdate && (React.createElement("div", { className: styles.simpleTransformMsg }, "Please review and accept the recommended Dataset transformation to answer your question"))));
};
const SimpleDatasetTransformJoin = ({ dataset_transform_join }) => {
    const [transformState, updateTransformState] = useState(dataset_transform_join ?? {});
    const datasets = useSelector((state) => viewReducer.getDatasets(state));
    const dataset1 = useSelector((state) => homeReducer.getDataset(state, transformState?.dataset_id_1));
    const dataset2 = useSelector((state) => homeReducer.getDataset(state, transformState?.dataset_id_2));
    const userName = useSelector((state) => loginReducer.getUserName(state));
    const userEmail = useSelector((state) => loginReducer.getUserEmail(state));
    const [hasAppliedUpdate, updateHasAppliedUpdate] = useState(false);
    const isTransformRecommended = JSON.stringify(dataset_transform_join) === JSON.stringify(transformState);
    return (React.createElement("div", { className: styles.simpleTransform },
        React.createElement("div", { className: styles.simpleTransformSubHeader }, "Transform Dataset: Dataset Join"),
        React.createElement("div", { className: styles.simpleTransformTile },
            React.createElement("div", { className: styles.simpleTransformHeader }, dataset1?.label + " joined with " + dataset2?.label),
            React.createElement("div", { className: styles.simpleTransformBody },
                React.createElement(Labeled, { label: "Dataset 1", style: { marginBottom: "5px" } },
                    React.createElement(Select, { value: { label: dataset1?.label, value: dataset1?.id }, onChange: (value) => updateTransformState({
                            ...transformState,
                            dataset_id_1: value?.value,
                            left_key: undefined
                        }), options: datasets.map((d) => ({ label: d?.label, value: d?.id })), placeholder: "Select First Dataset", menuPlacement: "bottom" })),
                React.createElement(Labeled, { label: "Dataset 2", style: { marginBottom: "5px" } },
                    React.createElement(Select, { value: { label: dataset2?.label, value: dataset2?.id }, onChange: (value) => updateTransformState({
                            ...transformState,
                            dataset_id_2: value?.value,
                            right_key: undefined
                        }), options: datasets.map((d) => ({ label: d?.label, value: d?.id })), placeholder: "Select Second Dataset", menuPlacement: "bottom" })),
                React.createElement(Labeled, { label: "Left Key", style: { marginBottom: "5px" } },
                    React.createElement(Select, { value: {
                            label: transformState?.left_key,
                            value: transformState?.left_key
                        }, onChange: (value) => updateTransformState({
                            ...transformState,
                            left_key: value?.value
                        }), options: Object.keys(dataset1?.fields ?? {}).map((f) => ({
                            label: dataset1?.fields?.[f]?.label,
                            value: dataset1?.fields?.[f]?.label
                        })), placeholder: "Second Column", menuPlacement: "bottom" })),
                React.createElement(Labeled, { label: "Right Key", style: { marginBottom: "5px" } },
                    React.createElement(Select, { value: {
                            label: transformState?.right_key,
                            value: transformState?.right_key
                        }, onChange: (value) => updateTransformState({
                            ...transformState,
                            right_key: value?.value
                        }), options: Object.keys(dataset2?.fields ?? {}).map((f) => ({
                            label: dataset2?.fields?.[f]?.label,
                            value: dataset2?.fields?.[f]?.label
                        })), placeholder: "Second Column", menuPlacement: "bottom" })),
                React.createElement(Labeled, { label: "New Dataset Name", style: { marginBottom: "5px" } },
                    React.createElement(LineInput, { value: transformState?.new_dataset_name, onChange: (val) => updateTransformState({
                            ...transformState,
                            new_dataset_name: val
                        }) })),
                !hasAppliedUpdate && (React.createElement("div", { className: styles.simpleTransformActions },
                    React.createElement(Button, { onClick: () => {
                            const socket = chatGPTReducer.getWebSocket();
                            if (socket) {
                                socket.send(JSON.stringify({
                                    type: "user_interaction_message",
                                    id: "string",
                                    thread_id: "default",
                                    parent_id: "root",
                                    content: {
                                        messages: [
                                            {
                                                role: "user",
                                                content: [
                                                    {
                                                        type: "text",
                                                        text: JSON.stringify({
                                                            ...transformState,
                                                            permission: "no"
                                                        })
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    timestamp: "string",
                                    user: {
                                        name: userName,
                                        email: userEmail
                                    },
                                    schema_version: "1.0"
                                }));
                                updateHasAppliedUpdate(true);
                            }
                        } }, "Cancel"),
                    React.createElement(Button, { type: "primary", onClick: () => {
                            const socket = chatGPTReducer.getWebSocket();
                            if (socket) {
                                socket.send(JSON.stringify({
                                    type: "user_interaction_message",
                                    id: "string",
                                    thread_id: "default",
                                    parent_id: "root",
                                    content: {
                                        messages: [
                                            {
                                                role: "user",
                                                content: [
                                                    {
                                                        type: "text",
                                                        text: JSON.stringify({
                                                            ...transformState,
                                                            permission: "yes"
                                                        })
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    timestamp: "string",
                                    user: {
                                        name: userName,
                                        email: userEmail
                                    },
                                    schema_version: "1.0"
                                }));
                            }
                            updateHasAppliedUpdate(true);
                        }, disabled: transformState?.dataset_id_1 === undefined ||
                            transformState?.dataset_id_2 === undefined ||
                            transformState?.left_key === undefined ||
                            transformState?.right_key === undefined ||
                            transformState?.new_dataset_name === undefined }, isTransformRecommended ? "Accept Agent Recommendations" : "Apply"))))),
        !hasAppliedUpdate && (React.createElement("div", { className: styles.simpleTransformMsg }, "Please review and accept the recommended Dataset transformation to answer your question"))));
};
const SimpleDatasetTile = ({ datasetId }) => {
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    return (React.createElement("div", { className: styles.simpleTransform },
        React.createElement("div", { className: styles.simpleTransformSubHeader }, "New Transformed Dataset"),
        dataset && React.createElement(SenseTile, { id: datasetId })));
};
const ChatMessageBody = ({ message, index, emailUsers, isChatTemplate, tryChatTemplate, isLastMessage, isAssistantAgent }) => {
    debug("Render: ChatMessageBody");
    const dispatch = useDispatch();
    const [isDownloadingNotebook, updateIsDownloadingNotebook] = useState(false);
    const [isFetchingDetails, updateIsFetchingDetails] = useState({});
    const updateFetchingId = (id, bool) => {
        updateIsFetchingDetails({
            ...isFetchingDetails,
            [id]: bool
        });
    };
    const currQuestionIndex = message?.questionIndex ?? index;
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const openMessageIndex = useSelector((state) => chatGPTReducer.getOpenMessageIndex(state));
    const showRequestJSON = useSelector((state) => chatGPTReducer.getShowRequestJSON(state));
    const isEmailApp = useSelector((state) => chatGPTReducer.getIsEmailApp(state));
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const backgroundColorDarkMode = useSelector((state) => chatGPTReducer.getBackgroundColorDarkMode(state));
    const questionIndex = useSelector((state) => chatGPTReducer.getQuestionIndex(state));
    const isIntermediateStepsShown = useSelector((state) => chatGPTReducer.getShowIntermediateSteps(state)?.[currQuestionIndex]);
    const toolCallsFeedback = useSelector((state) => chatGPTReducer.getToolCallsFeedbackByQuestion(state, currQuestionIndex));
    const updateToolCallsFeedbackByName = (toolName, feedback) => dispatch(chatGPTReducer.updateToolCallsFeedbackByQuestionAndTool(currQuestionIndex, toolName, feedback));
    const hasToolCallsFeedback = Object.keys(toolCallsFeedback ?? {}).length > 0;
    // console.log("-=-=-=-=-=-=-=-=-=- tool call", questionIndex);
    // console.log(hasToolCallsFeedback, toolCallsFeedback);
    // console.log(message);
    const account = useSelector((state) => chatGPTReducer.getChatGPTAccountId(state));
    const updateOpenMessageIndex = (openMessageIndex) => dispatch(chatGPTReducer.updateOpenMessageIndex(openMessageIndex));
    const isChatGPT = message.user === "ChatGPT";
    const isAible = message.user === "Aible";
    const isUser = !(isChatGPT || isAible);
    const totalIntermediateSteps = useSelector((state) => chatGPTReducer.getTotalIntermediateSteps(state, currQuestionIndex));
    const backgroundColorDarkColor = "#EFECF6";
    const mModelId = message?.model;
    const contentGenerationIds = message?.contentGenerationIds;
    const contentGenerationAccount = message?.contentGenerationAccount;
    const hasContentGenerationIds = contentGenerationIds && contentGenerationIds?.length > 0;
    const showFirstMessageOutcomeSelection = useSelector((state) => chatGPTReducer.getShowFirstMessageOutcomeSelection(state));
    const firstMessageOutcomeSelectionDefaultShow = useSelector((state) => chatGPTReducer.getFirstMessageOutcomeSelectionDefaultShow(state));
    const [isViewSentAgentIQ, updateIsViewSentAgentIQ] = useState(false);
    const conversationArrayLength = useSelector((state) => chatGPTReducer.getConversationArrayLength(state));
    const [hasAskedQuestion, updateHasAskedQuestion] = useState(false);
    const isCreatingStepByStepAgent = useSelector((state) => globalReducer.getIsCreatingStepByStepAgent(state));
    const backendAgentId = useSelector((state) => chatGPTReducer.getBackendExecutionId(state));
    const [isStepByStepHover, setIsStepByStepHover] = useState(false);
    // Checks and state for showing the feedback/retry when user does not have reasoning or response had no reasoning chunks.
    // Also checks that current user has thumbs downed.
    const [isCommenting, updateIsCommenting] = useState(false);
    const executionId = message.contentGenerationIds?.[0];
    const execution = useSelector((state) => getChatMessageDetails(state, executionId));
    const userID = useSelector((state) => loginReducer.getUserID(state));
    const executionRatings = useSelector((state) => executionId && !isNaN(Number(executionId))
        ? getRatingsById(state, "CONTENT_GENERATION_EXECUTION", Number(executionId))
        : {});
    const foundDislike = Object.values(executionRatings).find((rating) => rating.score == "DISLIKE" && rating.created_by.id === userID);
    const userHasDisliked = foundDislike !== undefined;
    const result = execution?.results.find((r) => r.id === message.response_data?.result_id);
    const chunks = getSplitMessageOutputContentFromMessage(message, result, userID);
    const noReasoningChunks = !chunks?.some((c) => isReasoningStep(c));
    const isThinkingOff = !isEnabled("chat-reason") || noReasoningChunks;
    useEffect(() => {
        if (isAsking && !hasAskedQuestion) {
            updateHasAskedQuestion(true);
        }
    }, [isAsking]);
    const simulateStreamNewMessage = isEnabled("chat-streaming-responses") &&
        hasAskedQuestion &&
        message?.index === conversationArrayLength - 1 &&
        !message?.isQuestion &&
        !message.content_references;
    const messageText = message.userText
        ? typeof message.userText === "string"
            ? message.userText
            : JSON.stringify(message.userText)
        : typeof message.text === "string"
            ? message.text
            : JSON.stringify(message.text);
    const hasCustomIcon = chatApp?.wizard?.base64StringBot !== undefined && chatApp?.wizard?.base64StringBot !== "";
    const isAskingSuggestQuestions = useSelector((state) => getIsAskingSuggestQuestions(state));
    const toolCallsDisplayMode = useSelector((state) => chatGPTReducer.getToolCallsDisplayMode(state));
    const finalReportToolCall = (message?.toolCalls ?? [])?.find((toolCall) => toolCall?.name === "aible_submit_final_report" && toolCall?.status === "complete");
    const hasReportToolCall = finalReportToolCall !== undefined;
    return (React.createElement("div", { className: styles.chatBody + " " + (message?.possibleColumns !== undefined ? styles.isPossibleColumn : "") },
        React.createElement(OverlayTrigger, { placement: "top", trigger: mModelId !== undefined ? ["hover"] : [], rootClose: true, overlay: React.createElement(ChatSettingsPopover, { message: message }) },
            React.createElement("div", { className: styles.userIcon, style: hasCustomIcon
                    ? { background: "#94A3B8" }
                    : { background: isChatGPT ? "#7E7D9A" : isAible ? "#3E1270" : undefined } }, isChatGPT || isAible ? (React.createElement("img", { className: hasCustomIcon ? styles.userIconImageCustom : styles.userIconImage, src: hasCustomIcon
                    ? chatApp?.wizard?.base64StringBot
                    : isAible
                        ? aibleBadge
                        : isEmailApp
                            ? chataibleEmailBadge
                            : llmBadge })) : ((message.userInitials ?? "U")))),
        React.createElement("div", { className: styles.messageBody, style: message?.possibleColumns !== undefined ? { width: "calc(100% - 34px)" } : {} },
            message?.toolCalls?.length > 0 && toolCallsDisplayMode !== "Hide work" && (React.createElement(ToolCallList, { toolCalls: message.toolCalls, toolCallsDisplayMode: toolCallsDisplayMode, toolCallsFeedback: toolCallsFeedback, updateToolCallsFeedbackByName: updateToolCallsFeedbackByName })),
            message?.findCosts && React.createElement(FindCosts, { message: message, index: index }),
            message?.possibleColumns !== undefined && React.createElement(PossibleColumns, { message: message, index: index }),
            message?.title !== undefined && message?.user === "Aible" && (React.createElement("div", { className: styles.aaTitle }, message?.title)),
            message?.buttonActions && (React.createElement("div", { className: styles.aaButtonActions }, message.buttonActions.map((ba) => (React.createElement(Button, { style: { marginRight: "10px" } }, ba?.Text))))),
            message?.agentiq_prediction && React.createElement(AgentIQPredictionTable, { message: message }),
            message?.prediction_table && React.createElement(PredictionTable, { message: message }),
            hasReportToolCall && finalReportToolCall?.responseId !== undefined && (React.createElement("div", { className: "flex items-center mt-[24px] mb-[28px]" },
                React.createElement(Button, { style: { padding: "6px 8px", marginRight: "8px" }, onClick: () => {
                        dispatch(aibleAnywhereReducer.generateWorkflowFromOpenShell(finalReportToolCall?.responseId));
                    }, isLoading: isCreatingStepByStepAgent, loadingText: "Saving plan...", onMouseOver: () => setIsStepByStepHover(true), onMouseLeave: () => setIsStepByStepHover(false) }, "Save plan off for consistent execution"),
                message?.toolInfo?.predict !== undefined && (React.createElement(OptimizeConfigureButton, { predict: message?.toolInfo?.predict })))),
            React.createElement("div", { className: simulateStreamNewMessage ? `${styles.messageText} ${styles.simulateStreamingMessage}` : styles.messageText },
                message?.isSuggestQuestionsResponse === true ? (React.createElement(IsSuggestQuestionsResponse, { message: message })) : message?.isSavedPreferredRequest === true && message?.savedHints && message?.savedHints?.length > 0 ? (React.createElement(SavedPreferredHints, { message: message, isChatTemplate: isChatTemplate })) : message?.isSavedSuggestedQuestions === true &&
                    message?.savedSuggestedQuestions &&
                    message?.savedSuggestedQuestions?.length > 0 ? (React.createElement(SavedSuggestedQuestions, { message: message, isChatTemplate: isChatTemplate })) : hasOutputContent(message) ? (React.createElement(ResponseWithIds, { message: message, index: index, renderChunksAsStreaming: simulateStreamNewMessage })) : simulateStreamNewMessage && message?.agent_iq === undefined ? (React.createElement(MarkdownTypewriter, { overrides: isUser ? USER_MARKDOWN_OVERRIDES : CHAT_MARKDOWN_OVERRIDES, text: messageText })) : isUser ? (React.createElement("div", { style: USER_MARKDOWN_OVERRIDES.p.style },
                    React.createElement(MarkdownPanel, { overrides: CHAT_MARKDOWN_OVERRIDES }, messageText))) : message?.agent_iq?.input !== undefined ? (React.createElement(React.Fragment, null,
                    React.createElement(ReasoningResult, { message: message, index: index, executionId: 1, result: {
                            id: 1,
                            data: {
                                output: {
                                    content: messageText
                                }
                            }
                        }, hideResponseChunkRetry: true, renderChunksAsStreaming: simulateStreamNewMessage }))) : (React.createElement(MarkdownPanel, { overrides: CHAT_MARKDOWN_OVERRIDES }, messageText)),
                Object.keys(message?.agent_iq?.allContent ?? {}).filter((aK) => message?.agent_iq?.allContent[aK]?.output !== undefined).length > 0 && (React.createElement("div", { className: styles.chatAgentIQ },
                    React.createElement("div", { className: styles.chatAgentIQHeader },
                        "Autonomous Agent Steps",
                        !isAssistantAgent && isEnabled("agent-iq-save-workflow") && (React.createElement(Button, { style: { marginLeft: "10px", padding: "4px" }, onClick: () => dispatch(aibleAnywhereReducer.generateWorkflow(message)), isLoading: isCreatingStepByStepAgent, loadingText: "Saving plan...", onMouseOver: () => setIsStepByStepHover(true), onMouseLeave: () => setIsStepByStepHover(false) }, "Save plan off for consistent execution"))),
                    Object.keys(message?.agent_iq?.allContent ?? {})
                        .filter((aK) => message?.agent_iq?.allContent[aK]?.output !== undefined)
                        .sort((a, b) => message?.agent_iq?.allContent?.[a]?.outputCount - message?.agent_iq?.allContent?.[b]?.outputCount)
                        .map((aK, i) => {
                        const uid = message?.agent_iq?.allContent?.[aK]?.id;
                        const mName = message?.agent_iq?.allContent?.[aK]?.name ?? "";
                        //Simple hack for now
                        const isGoodName = mName.indexOf("Function") !== -1 || mName.indexOf("Tool") !== -1;
                        const retIsStepByStepHover = (isCreatingStepByStepAgent === true || isStepByStepHover === true) &&
                            mName.toLowerCase().indexOf("dataset_nlq") === -1 &&
                            mName.toLowerCase().indexOf("analyze_dataset") === -1 &&
                            mName.toLowerCase().indexOf("summarize_document") === -1 &&
                            mName.toLowerCase().indexOf("prediction_tool") === -1 &&
                            mName.toLowerCase().indexOf("web_researcher_tool") === -1;
                        const dName = i === 0 && backendAgentId === undefined
                            ? "1: Generate Plan"
                            : i +
                                1 +
                                ": " +
                                (isGoodName
                                    ? message?.agent_iq?.allContent?.[aK]?.name
                                    : message?.agent_iq?.result_id === uid
                                        ? "Result"
                                        : message?.agent_iq?.allContent?.[aK]?.name);
                        const sName = (dName ?? "").toLowerCase();
                        return (React.createElement(Accordion, { style: retIsStepByStepHover ? { background: "#efecf6" } : {}, header: React.createElement("div", { className: styles.agentIQHeader },
                                dName,
                                retIsStepByStepHover === true && (React.createElement("span", { className: styles.agentIqNotSavedMessage }, sName.indexOf("generate plan") !== -1
                                    ? "(The plan will be saved but this step will not be executed again)"
                                    : sName.indexOf("search_context") !== -1
                                        ? "(Search steps are not saved)"
                                        : sName.indexOf("get_dataset_info") !== -1
                                            ? "(The dataset information will be saved. The step will not execute)"
                                            : sName.indexOf("perform_left_join") !== -1
                                                ? "(The join has been executed and does not need to be performed again)"
                                                : sName === "result"
                                                    ? "(The result will be based on the output when the step by step agent executes)"
                                                    : "(This step will not be saved when a step-by-step agent is created)"))), show: message?.agent_iq?.collapseIds?.[uid] !== true, onClick: () => dispatch(chatGPTReducer.updateMessage(index, {
                                ...message,
                                agent_iq: {
                                    ...message.agent_iq,
                                    collapseIds: {
                                        ...(message.agent_iq.collapseIds ?? {}),
                                        [uid]: !message?.agent_iq?.collapseIds?.[uid]
                                    }
                                }
                            })) }, message?.agent_iq?.collapseIds?.[uid] !== true &&
                            message?.agent_iq?.allContent[aK]?.output !== undefined && (React.createElement(ReasoningMessageOld, { message: message, messageText: message?.agent_iq?.allContent[aK]?.output }))));
                    }))),
                message?.agent_iq?.input !== undefined && (React.createElement("a", { onClick: () => updateIsViewSentAgentIQ(!isViewSentAgentIQ), className: styles.expansionItemLink }, isViewSentAgentIQ ? "Hide work" : "View all of the work")),
                message?.agent_iq?.input !== undefined && isViewSentAgentIQ && (React.createElement("div", { className: styles.seeWhatWasSentContentContainer, style: { padding: "20px" } },
                    React.createElement(MarkdownPanel, { overrides: CHAT_MARKDOWN_OVERRIDES }, message?.agent_iq?.input))),
                message.isError && message.userText?.includes("token") && (React.createElement("div", null, "Token counts include the high level statistics sent."))),
            message?.isAttachFile && React.createElement(FileAttachMessage, { message: message, index: index }),
            message?.isUploadFile && React.createElement(FileUploadMessage, { message: message, index: index }),
            message?.isStreamed && isLastMessage && isAsking && (React.createElement("div", { className: styles.streamingLoadingStatus },
                React.createElement("div", { className: styles.aStateBoxIcon, style: { height: "20px" } },
                    React.createElement(LoadingIndicator, { style: {
                            margin: "0px",
                            marginLeft: "-10px",
                            transform: "scale(.3)"
                        } })),
                "Summarizing")),
            message?.isSuggestQuestionsRequest && isLastMessage && isAskingSuggestQuestions && (React.createElement("div", { className: styles.streamingLoadingStatus },
                React.createElement("div", { className: styles.aStateBoxIcon, style: { height: "20px" } },
                    React.createElement(LoadingIndicator, { style: {
                            margin: "0px",
                            marginLeft: "-10px",
                            transform: "scale(.3)"
                        } })),
                "Analyzing...")),
            !message?.isStreamed && showRequestJSON && Boolean(message?.currentPromptCharts?.length) && (React.createElement(AnalyticsSeeWhatWasSent, { message: message, index: index })),
            !message?.isStreamed && showRequestJSON && message?.document_data !== undefined && (React.createElement(DocumentSummarizationExpansionItem, { message: message })),
            message?.reasoning !== undefined && (React.createElement(ReasoningMessage, { message: message, index: index, renderChunksAsStreaming: simulateStreamNewMessage, hideFinalResponseRetry: true })),
            message?.isShowDatasetAnalytics && (React.createElement("div", { style: { marginTop: "20px", marginBottom: "20px" } },
                React.createElement(DatasetAnalytics, { defaultShow: true }))),
            message?.openClawProjects !== undefined && React.createElement(OpenClawProjects, { message: message, index: index }),
            message?.altStrategies !== undefined && React.createElement(AltStrategies, { message: message, index: index }),
            message?.labeledContentGenerationIds !== undefined &&
                message?.labeledContentGenerationIds.map((labelObj) => {
                    return (React.createElement(SeeWhatWasSent, { contentGenerationId: labelObj?.id, accountId: contentGenerationAccount, key: "seeWhatWasSent__" + labelObj?.id, isFetchingDetails: isFetchingDetails, updateFetchingId: updateFetchingId, customLabel: labelObj?.label }));
                }),
            !message?.isStreamed &&
                hasContentGenerationIds &&
                contentGenerationIds.map((id) => {
                    return (React.createElement(SeeWhatWasSent, { contentGenerationId: id, accountId: contentGenerationAccount, key: "seeWhatWasSent__" + id, isFetchingDetails: isFetchingDetails, updateFetchingId: updateFetchingId }));
                }),
            message.errorMessage !== undefined && (React.createElement(React.Fragment, null,
                React.createElement(MessageExpansionItem, { openLabel: "Close", closedLabel: "See Error Details", index: index, isOpen: openMessageIndex === index, updateOpenMessageIndex: updateOpenMessageIndex },
                    React.createElement(MarkdownPanel, { overrides: CHAT_MARKDOWN_OVERRIDES }, message.errorMessage)),
                !hasContentGenerationIds &&
                    Number(message?.ids?.length) > 0 &&
                    message?.ids?.map((id) => {
                        if (Number(id) > 0) {
                            return (React.createElement(SeeWhatWasSent, { contentGenerationId: id, accountId: message?.accountId ?? account, key: "seeWhatWasSent__" + id, isFetchingDetails: isFetchingDetails, updateFetchingId: updateFetchingId }));
                        }
                        return null;
                    }))),
            message?.isEmailApp && emailUsers !== undefined && React.createElement(EmailUserSelect, { emailUsers: emailUsers, index: index }),
            React.createElement("div", { className: styles.chatActions },
                !message?.isStreamed && (React.createElement(React.Fragment, null,
                    React.createElement(Feedback, { message: message, index: index, updateIsCommenting: updateIsCommenting }),
                    hasOutputContent(message) && isEnabled("chat-aible-advanced-controls") && (React.createElement(ChatExportControls, { message: message, index: index })))),
                message?.isError && message?.ids?.length && isEnabled("chat-aible-notebook-download") && (React.createElement(Button, { type: "secondary", isSmall: true, onClick: () => {
                        updateIsDownloadingNotebook(true);
                        const messagePromises = message?.ids?.map((mId) => {
                            if (mId) {
                                return dispatch(chatGPTReducer.fetchErrorNotebook(mId, message?.accountId));
                            }
                            return Promise.resolve(mId);
                        }) ?? [];
                        return Promise.all(messagePromises).finally(() => {
                            updateIsDownloadingNotebook(false);
                        });
                    }, style: { marginBottom: "4px", display: "inline-block" }, isLoading: isDownloadingNotebook }, "Share Error Report"))),
            !message?.isStreamed &&
                (userHasDisliked || (hasToolCallsFeedback && !message?.toolCalls?.length)) &&
                isThinkingOff && (React.createElement("div", null,
                React.createElement(AddModelFeedback, { message: message, executionId: executionId, isCommenting: isCommenting || (hasToolCallsFeedback && !message?.toolCalls?.length), updateIsCommenting: updateIsCommenting }))),
            React.createElement("div", { className: styles.chatMessageInfoActions },
                !message?.isStreamed &&
                    message?.isQuestion &&
                    !(isAsking && currQuestionIndex === questionIndex) &&
                    totalIntermediateSteps > 0 && (React.createElement("a", { className: styles.intermediateStepsButton, onClick: () => {
                        dispatch(chatGPTReducer.updateShowIntermediateSteps(currQuestionIndex, !isIntermediateStepsShown));
                    } }, isIntermediateStepsShown
                    ? `Hide all intermediate steps`
                    : `Show (${totalIntermediateSteps}) intermediate steps `)),
                message?.isQuestion &&
                    !(isAsking && currQuestionIndex === questionIndex) &&
                    isEnabled("chat-aible-hide-conversations-from-chat") && (React.createElement("a", { className: styles.intermediateStepsButton, onClick: () => dispatch(chatGPTReducer.hideConversationMessagesByQuestionIndex(message?.questionIndex ?? -1)) }, "Hide")),
                !message?.isStreamed && (React.createElement("div", { className: styles.tokenDateInfo, style: {
                        color: backgroundColorDarkMode ? backgroundColorDarkColor : "#7e7d9a"
                    } },
                    (message?.response_data?.usage !== undefined || message?.contentGenerationIds) &&
                        !message?.isCachedResponse && (React.createElement(MessageCost, { message: message, isFetchingDetails: isFetchingDetails, updateFetchingId: updateFetchingId })),
                    React.createElement("div", { className: styles.messageDate },
                        message?.isCachedResponse
                            ? `Cached response generated ${moment.utc(message?.responseDate ?? message?.date).fromNow()}`
                            : moment.utc(message.date).fromNow(),
                        message?.cachedPrompt !== undefined && (React.createElement("div", { style: {
                                display: "flex",
                                lineHeight: "100%",
                                alignItems: "center"
                            } },
                            React.createElement("div", null, "Response generated from a similar prompt"),
                            React.createElement(OverlayTrigger, { placement: "top", trigger: ["hover"], rootClose: true, overlay: React.createElement(Popover, { id: "popover-positioned-top", title: React.createElement("strong", { style: { fontSize: "13px" } }, "Cached Response Prompt") }, message?.cachedPrompt) },
                                React.createElement("div", { className: styles.cacheTooltip },
                                    React.createElement(FontAwesomeIcon, { icon: faInfo }))))))))),
            tryChatTemplate && showFirstMessageOutcomeSelection && message?.isNewChatMessage ? (React.createElement("div", { className: styles.messageText, style: {
                    marginTop: "20px"
                } },
                React.createElement(DatasetAnalytics, { defaultShow: firstMessageOutcomeSelectionDefaultShow, skipRedirect: true, skipExploreStepDetection: true, isMessageFlow: true }))) : null)));
};
const AutoTableImport = ({ message, ignoredImports, updateIgnoredImports }) => {
    const dispatch = useDispatch();
    const importTables = message.importTables ?? [];
    return (React.createElement("div", { className: styles.autoImport },
        React.createElement("div", { className: styles.tableSelect }, importTables.map((tItem, i) => {
            const isIgnored = ignoredImports?.[tItem.table.name] === true;
            return (React.createElement("div", { className: styles.tableItem, key: "importTable_" + i },
                React.createElement("input", { type: "checkbox", checked: isIgnored ? false : true, onChange: () => updateIgnoredImports({
                        ...ignoredImports,
                        [tItem.table.name]: !isIgnored
                    }) }),
                React.createElement("div", null, tItem.table.name)));
        })),
        React.createElement(Button, { type: "primary", onClick: () => dispatch(chatGPTReducer.autoImportTables(importTables.filter((tItem) => ignoredImports?.[tItem.table.name] !== true))), disabled: importTables.filter((tItem) => ignoredImports?.[tItem.table.name] !== true).length === 0 }, "Automatically Import")));
};
const ReasoningStep = ({ children, comment, score, updateComment, updateScore, savePreferredRequest }) => {
    const [disableScoreButtons, updateDisableScoreButtons] = useState(false);
    const [disableCommentButton, updateDisableCommentButton] = useState(false);
    const [pendingComment, updatePendingComment] = useState(comment);
    const [isCommenting, updateIsCommenting] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.reasonLine },
            React.createElement("div", { className: styles.reasonLineText }, children),
            React.createElement("div", { className: styles.thinkFeedbackButtonContainer },
                React.createElement(Button, { active: score === 1, onClick: () => {
                        updateDisableScoreButtons(true);
                        updateScore(score === 1 ? 0 : 1).finally(() => updateDisableScoreButtons(false));
                        if (score === 0) {
                            savePreferredRequest();
                        }
                        updatePendingComment(comment);
                        updateIsCommenting(true);
                    }, disabled: disableScoreButtons, style: score === 1 ? { backgroundColor: "#A4F4BB" } : {}, className: styles.thinkFeedbackButton },
                    React.createElement("img", { src: score === 1 ? IconThumbsUpFilled : IconThumbsUp, className: styles.iconReasonFeedback })),
                React.createElement(Button, { active: score === -1, onClick: () => {
                        updateDisableScoreButtons(true);
                        updateScore(score === -1 ? 0 : -1).finally(() => updateDisableScoreButtons(false));
                        updatePendingComment(comment);
                        updateIsCommenting(true);
                    }, disabled: disableScoreButtons, style: score === -1 ? { backgroundColor: "#FFA4A0" } : {}, className: styles.thinkFeedbackButton },
                    React.createElement("img", { src: score === -1 ? IconThumbsDownFilled : IconThumbsDown, className: styles.iconReasonFeedback })))),
        comment !== undefined && !isCommenting && (React.createElement("div", { className: styles.reasonComment, onClick: () => updateIsCommenting(true) }, "Feedback: " + comment)),
        isCommenting && (React.createElement("div", { className: styles.reasonFeedbackComment },
            React.createElement("div", { style: { fontWeight: "bold" } }, "What did I do " + (score === -1 ? "wrong" : "right") + "?"),
            React.createElement(LineInput, { style: { marginBottom: "10px", background: "white" }, value: pendingComment, isDisabled: disableCommentButton, onChange: updatePendingComment }),
            React.createElement("div", { className: styles.reasonFeedbackActions },
                React.createElement(Button, { type: "primary", style: { marginRight: "10px" }, disabled: disableCommentButton, onClick: () => {
                        if (!pendingComment || !String(pendingComment).trim()) {
                            return updateIsCommenting(false);
                        }
                        updateDisableCommentButton(true);
                        updateComment(pendingComment).finally(() => {
                            updateDisableCommentButton(false);
                            updateIsCommenting(false);
                        });
                        // Disabling automatically turning on fewshot on comment and do not add hints to fewshot
                        // dispatch(nextReducer.updateIsFewShotEnabled(nextId, true));
                        // dispatch(nextReducer.addFewShotExample(nextId, { prompt: thinkingText, response: pendingComment }));
                    } }, "Improve Model"),
                React.createElement(Button, { disabled: disableCommentButton, onClick: () => {
                        updatePendingComment(comment);
                        updateIsCommenting(false);
                    } }, "Cancel"))))));
};
const ReasoningStepContainer = ({ executionId, resultId, feedback, children, thinkingText }) => {
    const dispatch = useDispatch();
    const chatMessageDetail = useSelector((state) => getChatMessageDetails(state, executionId));
    const parentExecutionId = chatMessageDetail?.request?.parent_execution_id;
    return (React.createElement(ReasoningStep, { score: feedback.score, comment: feedback.comment, updateScore: (score) => dispatch(addOutputFeedbackItem(executionId, resultId, {
            ...feedback,
            score: score
        })).then(() => {
            return;
        }), updateComment: (comment) => dispatch(addOutputFeedbackItem(executionId, resultId, {
            ...feedback,
            comment: comment
        })).then(() => {
            return;
        }), savePreferredRequest: () => {
            if (parentExecutionId !== undefined) {
                console.log("Parent execution id, execution id, saving: ", parentExecutionId, executionId);
                return dispatch(chatGPTReducer.savePreferredThinkingRequest(parentExecutionId, executionId));
            }
        }, thinkingText: thinkingText }, children));
};
const ReasoningResult = ({ message, executionId, result, onRetryWithFeedback, templateId, hideResponseChunkRetry, hideFinalResponseRetry }) => {
    const dispatch = useDispatch();
    const userID = useSelector((state) => loginReducer.getUserID(state));
    const questionIndex = dispatch(chatGPTReducer.getQuestionIndexFromMessage(message));
    const question = useSelector((state) => chatGPTReducer.getConversationMessage(state, questionIndex ?? 0));
    const resultData = result.data;
    const userOutputFeedback = (resultData.output_feedback ?? []).find((f) => f.user_id == userID);
    const getStepFeedback = (match) => {
        const start = match.index ?? 0;
        const end = start + match[0].length;
        const step = userOutputFeedback?.feedback_items.find((item) => item.start_index == start && item.end_index == end);
        return {
            start_index: start,
            end_index: end,
            score: step?.score ?? 0,
            comment: step?.comment
        };
    };
    const thinkingContent = resultData.output?.content;
    const regex = /(<think>(.|\n)*?<\/think>)/g;
    const thinkingMatches = Array.from(thinkingContent?.matchAll(regex).map((match) => ({
        text: (match[1] ?? "").replace("<think>", "").replace("</think>", ""),
        feedback: getStepFeedback(match)
    })));
    if (thinkingMatches.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    const userMPrompt = question?.isQuestion ? question.userPrompt : undefined;
    const currFeedbackItems = userOutputFeedback
        ? userOutputFeedback?.feedback_items?.map((fItem) => fItem?.comment).filter((i) => i !== undefined)
        : undefined;
    const currFeedbackString = currFeedbackItems ? currFeedbackItems.join("\n\n") : undefined;
    const extraFeedback = useSelector((state) => chatGPTReducer.getReasoningFeedbackText(state, message?.messageIndex, templateId));
    const hintsArray = useSelector((state) => chatGPTReducer.getReasoningHintsArray(state, message?.messageIndex, templateId));
    const reasoningFeedbackIncludeInChat = useSelector((state) => chatGPTReducer.getReasoningFeedbackIncludeInChat(state));
    let retHintsArray = hintsArray;
    if (!reasoningFeedbackIncludeInChat) {
        retHintsArray = currFeedbackItems ?? [];
    }
    const latestHint = currFeedbackString;
    const hasExtraFeedback = extraFeedback?.length > 0;
    const retExtraFeedback = hasExtraFeedback
        ? "\n\n" + (reasoningFeedbackIncludeInChat ? extraFeedback : "\n\nHint:\n" + latestHint)
        : undefined;
    const userPromptAugment = latestHint ? "\n\nHint:\n" + latestHint : undefined;
    const markdownOverrides = {
        p: {
            style: {
                fontSize: "14px",
                lineHeight: "25px",
                minHeight: "25px"
            }
        }
    };
    const chunks = getSplitMessageOutputContent(resultData.output, [], result, userID);
    return (React.createElement("div", null,
        React.createElement(MarkdownPanel, { renderLeaf: (leaf) => (React.createElement(ResponseChunks, { message: message, index: 0, chunks: [leaf], resultId: result?.id, executionId: executionId, hideResponseChunkRetry: hideResponseChunkRetry })), overrides: markdownOverrides }, parseMarkdownGeneric(chunks, (t) => (isReasoningStep(t) ? t.chunks.map((c) => (typeof c === "string" ? c : c.text)).join("") : t.text), (t, x) => ({ ...t, text: x }), (t) => isReasoningStep(t)
            ? [t.chunks.map((c) => (typeof c === "string" ? c : c.text)).join("")]
            : (t.text?.split("\n") ?? []))),
        !hideFinalResponseRetry && userOutputFeedback !== undefined && (React.createElement("div", { className: styles.reasonRetry },
            React.createElement(Button, { type: "primary", onClick: () => onRetryWithFeedback !== undefined
                    ? onRetryWithFeedback(extraFeedback)
                    : dispatch(chatGPTReducer.handleAskGPT(userMPrompt, undefined, undefined, undefined, undefined, !userMPrompt, extraFeedback, true, executionId, retHintsArray, retExtraFeedback, userPromptAugment)) }, "Retry Question with Feedback")))));
};
const ReasoningMessageOld = ({ messageText, skipThinking = false }) => {
    const regex = /(&lt;think&gt;[\s\S]*?&lt;\/think&gt;)/g;
    const parts = messageText.split(regex).filter(Boolean);
    const results = parts.map((part) => {
        const isThinking = regex.test(part);
        return {
            type: isThinking ? "think" : "text",
            text: isThinking ? part.replace("&lt;think&gt;", "").replace("&lt;/think&gt;", "") : part
        };
    });
    return (React.createElement("div", null, results.map((result) => result?.type === "think" && skipThinking !== true ? (React.createElement(ReasoningMessageOldThinking, { thinkText: result?.text })) : (React.createElement(MarkdownPanel, null, chatGPTReducer.parseMessage(result?.text))))));
};
const ReasoningMessageOldThinking = ({ thinkText }) => {
    const dispatch = useDispatch();
    const [isOpenComment, updateIsOpenComment] = useState(false);
    const [commentThinking, updateCommentThinking] = useState("");
    const [thinkingFeedback, updateThinkingFeedback] = useState(0);
    const prompt = useSelector((state) => chatGPTReducer.getPrompt(state));
    const blueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    return (React.createElement("div", { className: styles.chatMessageReasoning },
        React.createElement("div", { className: styles.reasoningThinking },
            React.createElement("div", { style: { fontWeight: "bold" } }, "Thinking"),
            React.createElement("div", null,
                React.createElement("div", { className: styles.reasonLine },
                    React.createElement("div", { className: styles.reasonLineText }, chatGPTReducer.parseMessage(thinkText)),
                    React.createElement(ButtonGroup, null,
                        React.createElement(Button, { active: thinkingFeedback === 1, onClick: () => {
                                updateThinkingFeedback(1);
                                updateCommentThinking(commentThinking ?? "");
                                updateIsOpenComment(true);
                            }, style: { padding: "5px" } },
                            React.createElement(FontAwesomeIcon, { icon: faThumbsUp, style: { color: "green" } })),
                        React.createElement(Button, { active: thinkingFeedback === -1, onClick: () => {
                                updateThinkingFeedback(-1);
                                updateCommentThinking(commentThinking ?? "");
                                updateIsOpenComment(true);
                            }, style: { padding: "5px" } },
                            React.createElement(FontAwesomeIcon, { icon: faThumbsDown, style: { color: "red" } })))),
                isOpenComment && (React.createElement("div", { className: styles.reasonFeedbackComment },
                    React.createElement("div", { style: { fontWeight: "bold" } }, "What did I do " + (thinkingFeedback === -1 ? "wrong" : "right") + "?"),
                    React.createElement(LineInput, { style: { marginBottom: "10px", background: "white" }, value: commentThinking, onChange: (val) => updateCommentThinking(val) }),
                    React.createElement(Button, { type: "primary", style: { marginRight: "20px" }, onClick: () => {
                            updateIsOpenComment(false);
                        } }, "Improve Model"),
                    React.createElement(Button, { onClick: () => {
                            updateCommentThinking("");
                            updateIsOpenComment(false);
                        } }, "Cancel")))),
            commentThinking !== undefined && commentThinking !== "" && !isOpenComment && (React.createElement("div", null,
                React.createElement("div", { className: styles.reasonComment }, "Feedback: " + commentThinking),
                React.createElement("div", { className: styles.reasonRetry },
                    React.createElement(Button, { type: "primary", onClick: () => {
                            dispatch(chatGPTReducer.handleAgentIQ(prompt + "\n\nHint: " + commentThinking, false, blueprintId === "AGENT_IQ_TEAM" ? "reasoning-team" : "reasoning"));
                        } }, "Retry Question with Feedback")))))));
};
export const FindCosts = ({ message }) => {
    const dispatch = useDispatch();
    const [originalBusinessConstraints, updateOriginalBusinessConstraints] = useState(undefined);
    const [selectedStrategy, updateSelectedStrategy] = useState(undefined);
    const optimizeSetup = useSelector((state) => chatGPTReducer.getOptimizeSetup(state));
    const optimizeStepIndex = useSelector((state) => chatGPTReducer.getOptimizedStepIndex(state));
    const optimized = useSelector((state) => projectReducer.getOptimized(state, optimizeSetup?.projectId));
    const overallRunId = useSelector((state) => projectReducer.getOverallRunId(state, optimizeSetup?.projectId));
    const runId = overallRunId ?? optimized?.innerId;
    const businessConstraints = useSelector((state) => setupReducer.getBusinessConstraints(state, optimizeSetup?.projectId, runId));
    return (React.createElement("div", { style: { fontSize: "14px" } },
        React.createElement("div", null, "Here are your updated business assumptions"),
        React.createElement("div", null, optimized?.activeSegment?.name !== undefined && optimized?.activeSegment?.name !== ""
            ? " for " + optimized?.activeSegment?.name + ":\n\n"
            : ""),
        Object.keys(message?.findCosts?.suggestJson ?? {}).map((sKey, i) => (React.createElement("div", { style: message?.findCosts?.currentVariableState?.[sKey] !== message?.findCosts?.suggestJson[sKey]
                ? { fontWeight: "bold" }
                : {} }, sKey + ": " + message?.findCosts?.suggestJson[sKey])))));
};
export const OpenClawProjects = ({ message }) => {
    const dispatch = useDispatch();
    const reports = useSelector((state) => reportReducer.getReports(state));
    useEffect(() => {
        message?.openClawProjects.forEach((oc) => {
            console.log("initing next: " + oc?.nextId);
            dispatch(nextReducer.init(oc?.nextId, oc?.datasetId, false, undefined, undefined, undefined, undefined, undefined, true, undefined, true));
        });
    }, []);
    const fReports = reports.filter((r) => r?.metadata?.explorations?.[0]?.projectId !== undefined);
    const retOpenClawProjects = (message?.openClawProjects ?? []).map((p) => {
        const pId = fReports.find((r) => r?.id === p?.nextId)?.metadata?.explorations?.[0]?.projectId;
        return { ...p, isProjectLoading: useSelector((state) => projectReducer.getIsLoading(state, pId)) };
    });
    const optimizeSetup = useSelector((state) => chatGPTReducer.getOptimizeSetup(state, true));
    return (React.createElement("div", null, retOpenClawProjects.map((p) => {
        const project = reports.find((r) => r?.id === p?.nextId);
        const altStrategiesMessageKey = Object.keys(project?.metadata?.chatGPTConvo?.conversation ?? {}).findLast((cKey) => project?.metadata?.chatGPTConvo?.conversation?.[cKey]?.altStrategies !== undefined) ?? -1;
        const altStrategiesMessage = project?.metadata?.chatGPTConvo?.conversation?.[altStrategiesMessageKey];
        const forceOptimizeSetup = {
            projectId: project?.metadata?.explorations?.[0]?.projectId,
            datasetId: project?.metadata?.explorations?.[0]?.datasetId
        };
        return altStrategiesMessage === undefined ? (React.createElement("div", null)) : (React.createElement("div", { style: { marginTop: "40px" } },
            React.createElement("div", { style: { textAlign: "center" } }, project?.name),
            p?.isProjectLoading === true ? (React.createElement(LoadingIndicator, null)) : optimizeSetup?.projectId !== undefined &&
                optimizeSetup?.projectId === project?.metadata?.explorations?.[0]?.projectId ? (React.createElement(AltStrategies, { message: altStrategiesMessage, index: -1, isForceShowOptimize: true, forceOptimizeSetup: forceOptimizeSetup })) : (React.createElement(Button, { onClick: () => dispatch(chatGPTReducer.updateOptimizeSetup(forceOptimizeSetup)), style: { marginTop: "10px" } }, "Configure - " + project?.name))));
    })));
};
export const AltStrategies = ({ message, isForceShowOptimize, forceOptimizeSetup }) => {
    const dispatch = useDispatch();
    const [selectedStrategy, updateSelectedStrategy] = useState(undefined);
    const [descriptionType, setDescriptionType] = useState("RELATIVE");
    const [hStrategy, updateHStrategy] = useState(undefined);
    const optimizeSetup = forceOptimizeSetup ?? useSelector((state) => chatGPTReducer.getOptimizeSetup(state));
    const optimizeStepIndex = useSelector((state) => chatGPTReducer.getOptimizedStepIndex(state));
    const optimized = useSelector((state) => projectReducer.getOptimized(state, optimizeSetup?.projectId));
    const overallRunId = useSelector((state) => projectReducer.getOverallRunId(state, optimizeSetup?.projectId));
    const runId = overallRunId ?? optimized?.innerId;
    const unitLabel = optimized?.unitLabel;
    const isCurrencyUnit = optimized?.isCurrencyUnitType;
    const hoverStrategy = (strategy) => {
        if (isForceShowOptimize) {
            dispatch(chatGPTReducer.updateForceShowOptimize(true));
            setTimeout(() => {
                const scroller = document.getElementById("analytics_panel_scroller");
                const scrollTarget = document.getElementById("step_5");
                if (scroller && scrollTarget) {
                    scroller.scrollTo({
                        top: scrollTarget.offsetTop + 70
                    });
                }
            }, 10);
        }
        /*
        if (optimizeStepIndex !== 5) {
          dispatch(chatGPTReducer.updateOptimizeStepIndex(5));
        }
          */
        dispatch(chatGPTReducer.setOriginalBusinessConstraints());
        updateHStrategy(strategy);
        console.log("what is hoverStrat", strategy, optimizeSetup, runId);
        dispatch(setupReducer.updateAllBusinessConstraints(optimizeSetup?.projectId, runId, strategy));
        dispatch(chatGPTReducer.updateIsCheckBalance(true));
        /*
        const scroller = document.getElementById("analytics_panel_scroller");
        const scrollTarget = document.getElementById("step_4");
    
        if (scroller && scrollTarget) {
          setTimeout(() => {
            scroller.scrollTo({
              top: scrollTarget.offsetTop + 70,
              behavior: "smooth"
            });
          }, 1);
        }
        */
    };
    const hoverLeave = () => {
        if (selectedStrategy === undefined) {
            dispatch(chatGPTReducer.resetOriginalBusinessConstraints());
        }
        else {
            dispatch(setupReducer.updateAllBusinessConstraints(optimizeSetup?.projectId, runId, selectedStrategy === -1
                ? message?.originalStrategy?.strategy
                : message?.altStrategies?.[selectedStrategy]?.strategy));
        }
        if (isForceShowOptimize) {
            dispatch(chatGPTReducer.updateForceShowOptimize(false));
        }
        dispatch(chatGPTReducer.updateIsCheckBalance(false));
        updateHStrategy(undefined);
    };
    const projectId = useSelector((state) => nextReducer.getProjectId(state, nextReducer.getCurrentNextId(state)));
    const allScenarios = useSelector((state) => projectReducer.getAllScenarios(state, projectId));
    const hasLinkedProject = useSelector((state) => projectReducer.getHasLinkedProject(state, projectId));
    const isAskingBalance = useSelector((state) => chatGPTReducer.getIsAskingBalance(state));
    const [balancePrompt, setBalancePrompt] = useState("");
    const [mSubgroupData, updateMSubgroupData] = useState({});
    const linkedProjectId = useSelector((state) => projectReducer.getLinkedProjectId(state, projectId));
    const runIds = useSelector((state) => projectReducer.getAllJobIdsFromOptimizer(state, projectId));
    const linkedRuns = useSelector((state) => setupReducer.getLinkedRuns(state, runIds?.[0]));
    const hoverClick = (i) => {
        updateSelectedStrategy(selectedStrategy === i ? undefined : i);
        const mScenarioIndex = allScenarios?.findIndex((s) => s?.originalScenario?.name === message?.altStrategies?.[i]?.title);
        const mScenario = i === -1 ? allScenarios?.[0] : allScenarios?.[mScenarioIndex];
        // Maybe just don't viewScenario if we are clicking the top one for now (it was broken using the wrong scenario)
        // if (mScenario !== undefined && i !== -1) {
        //   dispatch(projectReducer.viewScenario(projectId, mScenario?.scenario, mScenarioIndex));
        // }
        if (mSubgroupData?.[i] === undefined) {
            const mdata = (mSubgroups ?? []).map((mSubgroup) => {
                return {
                    label: mSubgroup?.label,
                    value: Math.round(mSubgroup?.capValue)
                };
            });
            const mSubgroupDataUpdate = {
                ...mSubgroupData,
                [i]: mdata
            };
            updateMSubgroupData(mSubgroupDataUpdate);
        }
    };
    const modelGroups = useSelector((state) => projectReducer.getModelGroups(state, projectId));
    const mSubgroups = modelGroups?.drilldownValues;
    return (React.createElement("div", { style: { fontSize: "14px", marginBottom: "10px" } },
        React.createElement("div", null, "Results:"),
        React.createElement("div", { className: "mt-[8px]" },
            React.createElement(OptimizeStrategyCard, { strategy: message?.originalStrategy, selectedStrategy: selectedStrategy, updateSelectedStrategy: updateSelectedStrategy, hoverStrategy: hoverStrategy, hoverLeave: hoverLeave, hoverClick: hoverClick, strategyIndex: -1, originalStrategyMetrics: message?.originalStrategy?.metrics, unitLabel: unitLabel, isCurrencyUnit: isCurrencyUnit, descriptionType: descriptionType, mSubgroupData: mSubgroupData[-1] })),
        React.createElement("div", { className: "mt-[20px] font-bold" }, "I also found these other options for you to consider:"),
        React.createElement("div", { style: { display: "flex", alignItems: "center" } },
            React.createElement("div", { style: { marginRight: "20px" } }, "Explain Options by:"),
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { active: descriptionType === "RELATIVE", onClick: () => setDescriptionType("RELATIVE") }, "Change from Baseline"),
                React.createElement(Button, { active: descriptionType === "ABSOLUTE", onClick: () => setDescriptionType("ABSOLUTE") }, "Actual Values"))),
        React.createElement("div", { className: "mt-[8px]" }, message?.altStrategies?.map((aStrategy, i) => (React.createElement(OptimizeStrategyCard, { key: `altStrategy__${i}__${(aStrategy?.title ?? "").replace(/\s/g, "")}`, strategy: aStrategy, selectedStrategy: selectedStrategy, updateSelectedStrategy: updateSelectedStrategy, hoverStrategy: hoverStrategy, hoverLeave: hoverLeave, hoverClick: hoverClick, strategyIndex: i, originalStrategyMetrics: message?.originalStrategy?.metrics, unitLabel: unitLabel, isCurrencyUnit: isCurrencyUnit, descriptionType: descriptionType, mSubgroupData: mSubgroupData[i], hStrategy: hStrategy }))))));
};
export const ReasoningMessage = ({ message, index, onRetryWithFeedback, templateId, hideResponseChunkRetry, renderChunksAsStreaming, hideFinalResponseRetry }) => {
    const id = message?.reasoning?.executionId;
    const chatMessageDetail = useSelector((state) => getChatMessageDetails(state, id));
    if (id === undefined || chatMessageDetail === undefined) {
        return (React.createElement("div", { className: styles.chatMessageReasoning },
            React.createElement("div", { className: styles.reasoningThinking },
                React.createElement("div", { style: { fontWeight: "bold" } }, "Thinking"))));
    }
    return (React.createElement(React.Fragment, null, chatMessageDetail.results.map((result) => (React.createElement(ReasoningResult, { key: result.id, templateId: templateId, message: message, index: index, executionId: id, result: result, onRetryWithFeedback: onRetryWithFeedback, hideResponseChunkRetry: hideResponseChunkRetry, renderChunksAsStreaming: renderChunksAsStreaming, hideFinalResponseRetry: hideFinalResponseRetry })))));
};
const OutcomeSelectionMessage = ({ tryChatTemplate, message }) => {
    if (!tryChatTemplate || !message?.isOutcomeSelectionMessage) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: styles.chatBody },
        React.createElement("div", { className: styles.userIcon, style: { background: "unset" } }),
        React.createElement("div", { className: styles.messageBody },
            React.createElement(DatasetAnalytics, { defaultShow: true, skipRedirect: true, skipExploreStepDetection: true }))));
};
// THIS IS THE BASE MESSAGE DISPLAY HANDLER
const ChatMessage = ({ message, index, ignoredImports, updateIgnoredImports, emailUsers, isChatTemplate, tryChatTemplate, isLastMessage, isAssistantAgent }) => {
    debug("Render: ChatMessage");
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const currQuestionIndex = message?.questionIndex ?? index;
    const currStepsInProgress = useSelector((state) => chatGPTReducer.getCurrentStepsInProcess(state, currQuestionIndex, message?.isCacheShow));
    const currStepsShown = useSelector((state) => chatGPTReducer.getShowIntermediateSteps(state)?.[currQuestionIndex]);
    const isChatFiltered = useSelector((state) => chatGPTReducer.getIsChatFiltered(state, currQuestionIndex));
    const hasTools = message?.toolCalls?.length || message?.toolCall;
    const shouldFilterChat = isChatFiltered && !hasTools;
    return shouldFilterChat || message?.isHidden || message?.alwaysHide ? (React.createElement("div", null)) : message?.isOutcomeSelectionMessage ? (React.createElement(OutcomeSelectionMessage, { message: message, index: index, isChatTemplate: isChatTemplate, tryChatTemplate: tryChatTemplate })) : (message?.analytics?.blueprintId === "CHATAIBLE_SQL" ||
        currStepsShown ||
        currStepsInProgress ||
        currQuestionIndex === undefined ||
        message?.isQuestion ||
        message?.alwaysShowStep ||
        message?.chatType === "ASK_FOR_DATASET" ||
        message?.questionIndex === undefined) &&
        (message?.sqlQuery !== undefined || (message?.sqlLlmPrompt && message?.sqlQueryPrompt)) ? (React.createElement(SQLConfirmation, { message: message, index: index })) : (React.createElement("div", { key: index, className: styles.chatMessage, style: {
            height: message?.isHidden ? "auto" : "auto",
            background: chatApp?.wizard?.backgroundColor !== undefined ? "none" : "#FFFFFF"
        }, "data-msg-index": message?.messageIndex },
        (currStepsShown ||
            currStepsInProgress ||
            currQuestionIndex === undefined ||
            message?.isQuestion ||
            message?.alwaysShowStep ||
            message?.chatType === "ASK_FOR_DATASET" ||
            message?.reasoning ||
            hasTools ||
            message?.questionIndex === undefined ||
            message?.text !== undefined ||
            message?.analytics?.blueprintId === "OPENSHELL") && (React.createElement(ChatMessageBody, { message: message, index: index, emailUsers: emailUsers, isChatTemplate: isChatTemplate, tryChatTemplate: tryChatTemplate, isLastMessage: isLastMessage, isAssistantAgent: isAssistantAgent })),
        message?.datasets !== undefined && (React.createElement("div", { className: styles.datasetTile },
            React.createElement(SenseViewContainer, { forceDatasetIds: message.datasets.map((d) => d.id) }))),
        message?.importTables !== undefined && (React.createElement(AutoTableImport, { message: message, ignoredImports: ignoredImports, updateIgnoredImports: updateIgnoredImports })),
        message?.askChatGPT_MultipleDatasets !== undefined && React.createElement(AskMultipleDatasets, { message: message }),
        message?.leakageJSON !== undefined && React.createElement(LeakageInfo, { message: message })));
};
const PossibleColumns = ({ message, index }) => {
    const dispatch = useDispatch();
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const isChangeFocus = useSelector((state) => nextReducer.getIsChangeFocusColumnsByIndex(state, nextId, index));
    const updateIsChangeFocus = (val) => dispatch(nextReducer.updateIsChangeFocusColumnsByIndex(nextId, index, val));
    const [isRetrying, updateIsRetrying] = useState(false);
    const mSearchOpts = [
        ...(message?.possibleColumns?.columns ?? []).map((c) => ({ field: c, value: c, label: c })),
        ...(message?.possibleColumns?.values ?? []).map((v) => ({
            value: v?.column + ": " + v?.value,
            label: v?.column + ": " + v?.value,
            filterField: v?.column,
            filterValue: v?.value
        }))
    ];
    const searchOpts = useSelector((state) => nextReducer.getFocusColumnsByIndex(state, nextId, index)) ?? mSearchOpts;
    const updateSearchOpts = (val) => dispatch(nextReducer.updateFocusColumnsByIndex(nextId, index, val));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(nextId, state));
    return (React.createElement("div", { className: styles.possibleColumns },
        React.createElement("div", { className: styles.possibleColumnsText }, "I will focus on the following data to answer your question:"),
        isChangeFocus !== true ? (React.createElement("div", { className: styles.possibleColumnsActions },
            React.createElement(Button, { onClick: () => updateIsChangeFocus(true), isSmall: true }, "Change Focus"))) : (React.createElement("div", { className: styles.possibleColumnsActions },
            React.createElement(Button, { onClick: () => {
                    updateSearchOpts(mSearchOpts);
                    updateIsChangeFocus(false);
                }, isSmall: true }, "Cancel"),
            React.createElement(Button, { style: { marginLeft: "20px" }, onClick: () => {
                    dispatch(chatGPTReducer.retryQuestionWithNextSearchColumns(message, index, searchOpts));
                    updateIsChangeFocus(false);
                }, isLoading: isRetrying, type: "Primary", disabled: searchOpts?.length < 1, isSmall: true }, "Retry Question"))),
        isChangeFocus !== true ? (React.createElement("div", { className: styles.possibleColumnsFocus },
            (message?.possibleColumns?.columns ?? []).map((c) => (React.createElement("div", { className: styles.possibleColumnsPillbox, title: c }, c))),
            (message?.possibleColumns?.values ?? []).map((c) => (React.createElement("div", { className: styles.possibleColumnsPillbox, title: c?.column + ": " + c?.value }, c?.column + ": " + c?.value))))) : (React.createElement("div", { className: styles.possibleColumnsFocus, style: { flexWrap: "nowrap" } },
            React.createElement(NextSearchContainer, { id: nextId, datasetId: datasetId, showCollapsed: false, searchOpts: searchOpts, overrideSearch: (s) => updateSearchOpts(s), isOnlySearch: true, isHideSearchType: true, isChatColumnSelect: true, style: { height: "auto", position: "relative", borderBottom: "none", paddingRight: "20px" }, searchTopStyle: { margin: "0px" }, searchSelectStyle: { width: "100%" } })))));
};
const GeneratedStyles = () => {
    const conversation = useSelector((state) => chatGPTReducer.getConversation(state));
    const conversationArray = chatGPTReducer.getConversationArray(undefined, conversation);
    const generatedStyles = useSelector((state) => chatGPTReducer.getGeneratedStyles(state));
    const [ignoredImports, updateIgnoredImports] = useState({});
    const emailUsers = [];
    const itemList = (React.createElement("div", { className: styles.chatMainHolderCustom, id: "chatGPT_scroll_main" }, conversationArray
        .sort((a, b) => a?.questionIndex === undefined || b?.questionIndex === undefined
        ? 0
        : a?.questionIndex < b?.questionIndex
            ? -1
            : a?.questionIndex > b?.questionIndex
                ? 1
                : 0)
        .map((message, index) => (React.createElement(ChatMessage, { key: index, message: message, index: index, ignoredImports: ignoredImports, updateIgnoredImports: updateIgnoredImports, emailUsers: emailUsers })))));
    const [hookEl, setHookEl] = useState(null);
    useEffect(() => {
        const el = document.getElementById("message-array-hook");
        if (el)
            setHookEl(el);
    }, [generatedStyles]); // Re-run when new HTML is rendered
    console.log("what is hookEl?", hookEl);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { dangerouslySetInnerHTML: { __html: generatedStyles } }),
        hookEl && createPortal(itemList, hookEl)));
};
const ChatConversation = ({ currentViewMessage, updateCurrentViewMessage, tryChatTemplate, isChatTemplate, hideDetailsPanel, safeClawOptimize, isAssistantAgent }) => {
    debug("Render: ChatConversation");
    const dispatch = useDispatch();
    const conversation = useSelector((state) => chatGPTReducer.getConversation(state));
    const conversationArray = chatGPTReducer.getConversationArray(undefined, conversation);
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const backgroundColorDarkMode = useSelector((state) => chatGPTReducer.getBackgroundColorDarkMode(state));
    const [ignoredImports, updateIgnoredImports] = useState({});
    // TODO: Store on backend somewhere
    let emailUsers = [];
    const localEmailUsers = localStorage.getItem("chat_email_users");
    if (localEmailUsers !== undefined && localEmailUsers !== null) {
        emailUsers = JSON.parse(localEmailUsers);
    }
    emailUsers.push({
        name: "Jonathan Wray",
        email: "jonathan@aible.com",
        number: "949-555-1234"
    });
    const customBackgroundColor = location &&
        location.pathname &&
        (location.pathname.indexOf("next") !== -1 || location.pathname.indexOf("chatTemplate") !== -1) &&
        chatApp?.wizard?.backgroundColor !== undefined &&
        chatApp?.wizard?.backgroundColor !== ""
        ? chatApp?.wizard.backgroundColor
        : "#FFFFFF";
    const backgroundColorDarkColor = "#EFECF6";
    const hasHidden = useSelector((state) => chatGPTReducer.getIsAnyConversationMessageHidden(state));
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const showSettings = useSelector((state) => chatGPTReducer.getShowSettings(state));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const contextSelectionPanelTab = useSelector((state) => chatGPTReducer.getContextSelectionPanelTab(state));
    const chatScrollRef = useRef(null);
    const endOfListRef = useRef(null);
    const getElementNearBottom = () => {
        const chatScrollContainer = chatScrollRef.current;
        if (!chatScrollContainer)
            return null;
        let elements = [];
        if (chatScrollRef?.current) {
            elements = Array.from(chatScrollRef.current?.querySelectorAll(`.${styles.chatMessage}`));
        }
        const threshold = 250;
        let closestElement = null;
        let closestDistance = Infinity;
        elements.forEach((element) => {
            const messageIndex = Number(element.dataset.msgIndex);
            if (isNaN(messageIndex)) {
                return;
            }
            const rect = element.getBoundingClientRect();
            const distanceToBottom = window.innerHeight - rect.top;
            if (distanceToBottom >= threshold && distanceToBottom < closestDistance) {
                closestDistance = distanceToBottom;
                closestElement = element;
            }
        });
        return closestElement;
    };
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const closestElement = getElementNearBottom();
                    if (closestElement) {
                        const messageIndex = Number(closestElement.dataset.msgIndex);
                        if (currentViewMessage !== messageIndex && !isNaN(messageIndex)) {
                            updateCurrentViewMessage(messageIndex);
                        }
                    }
                }
            });
        }, {
            root: chatScrollRef.current,
            threshold: [0, 0.8]
        });
        let elements = [];
        if (chatScrollRef?.current) {
            elements = Array.from(chatScrollRef.current?.querySelectorAll(`.${styles.chatMessage}`));
        }
        if (endOfListRef.current) {
            observer.observe(endOfListRef.current);
        }
        elements.forEach((element) => {
            observer.observe(element);
        });
        return () => {
            elements.forEach((element) => {
                observer.unobserve(element);
            });
            if (endOfListRef.current) {
                observer.unobserve(endOfListRef.current);
            }
        };
    }, [conversationArray]);
    const generatedStyles = useSelector((state) => chatGPTReducer.getGeneratedStyles(state));
    const agentId = useSelector((state) => chatGPTReducer.getAgentId(state));
    const isAskingAgent = useSelector((state) => chatGPTReducer.getIsAskingAgent(state));
    const agentSteps = useSelector((state) => chatGPTReducer.getAgentSteps(state));
    const currentAgentStep = useSelector((state) => chatGPTReducer.getCurrentAgentStep(state));
    const currentAgentStepIndex = agentSteps?.findIndex((step) => step?.id === currentAgentStep?.id);
    const summaryStepIndex = agentSteps?.findIndex((step) => step?.id === "SUMMARIZATION" || step?.id === "SQL_SUMMARIZATION");
    const hasChatStreaming = isEnabled("chat-streaming-responses");
    // Don't show the steps message for the "Create Long Runnning Agent" step
    const hideStepProgressForCurrentStep = currentAgentStep?.id === "CREATE_CLAW";
    console.log("what is generatedStyles", generatedStyles);
    const sortedMessages = conversationArray.sort((a, b) => a?.questionIndex === undefined || b?.questionIndex === undefined
        ? 0
        : a?.questionIndex < b?.questionIndex
            ? -1
            : a?.questionIndex > b?.questionIndex
                ? 1
                : 0);
    // Filtering chats for virtuoso so that the chats don't appear to jump/skip as messages get hidden/dynamically change size
    const retFilterIndex = useSelector((state) => chatGPTReducer.getRetFilterIndex(state));
    const isChatTabs = useSelector((state) => chatGPTReducer.getIsChatTabs(state));
    const filteredMessages = sortedMessages.filter((msg, index) => {
        const isChatFiltered = msg?.index === retFilterIndex ? false : retFilterIndex !== index && isChatTabs === true;
        if (isChatFiltered || msg?.isHidden || msg?.alwaysHide) {
            if (msg?.index === sortedMessages?.length - 1 && (isAsking || isAskingAgent)) {
                return true;
            }
            return false;
        }
        return true;
    });
    const optimizeSetup = useSelector((state) => chatGPTReducer.getOptimizeSetup(state));
    const isOptimizeModelsRunning = useSelector((state) => chatGPTReducer.getIsOptimizeModelsRunning(state));
    const isProjectDone = useSelector((state) => projectReducer.getIsDone(state, optimizeSetup?.projectId));
    const optimized = useSelector((state) => projectReducer.getOptimized(state, optimizeSetup?.projectId));
    const modelCount = useSelector((state) => projectReducer.getModelCount(state, optimizeSetup?.projectId, optimized?.innerId));
    const isFirstModel = modelCount > 0 && !isNaN(optimized?.profit) && !isNaN(optimized?.totalCost);
    const USE_VIRTUALIZE = true;
    const locationP = useLocation();
    const params = queryString.parse(locationP.search);
    const scrollToSection = params.scrollToSection;
    const virtuoso = useRef(null);
    if (scrollToSection === "OPTIMIZE") {
        const fMessageIndex = filteredMessages.findLastIndex((f) => f?.altStrategies !== undefined);
        useEffect(() => {
            virtuoso?.current?.scrollToIndex({ index: fMessageIndex, align: "start", behaviour: "smooth" });
        }, [virtuoso]);
    }
    else {
        useEffect(() => {
            virtuoso?.current?.scrollToIndex({ index: filteredMessages.length - 1, align: "end", behaviour: "smooth" });
        }, [virtuoso]);
    }
    return generatedStyles !== undefined ? (React.createElement(GeneratedStyles, null)) : (React.createElement(React.Fragment, null,
        hasHidden && (React.createElement("div", { className: styles.hiddenConversationsWrapper },
            React.createElement(Button, { onClick: () => dispatch(chatGPTReducer.showAllConversationMessages()), style: { padding: "5px" } }, "Show All Conversations"))),
        USE_VIRTUALIZE === true ? (React.createElement(Virtuoso, { id: "chatGPT_scroll_real", style: {
                height: "100%",
                width: tryChatTemplate || hideDetailsPanel
                    ? "100%"
                    : (optimizeSetup !== undefined || chatType === "OPTIMIZE") && showSettings !== true
                        ? "60%"
                        : chatType === "OPENSHELL"
                            ? "60%"
                            : chatType === "DOCUMENT"
                                ? !contextSelectionPanelTab && (showSettings === true || artifactId === undefined)
                                    ? "100%"
                                    : "60%"
                                : (!contextSelectionPanelTab || showSettings === true) &&
                                    (datasetId === undefined || showSettings === true || datasetId === "new")
                                    ? "100%"
                                    : "60%",
                backgroundColor: customBackgroundColor,
                color: backgroundColorDarkMode ? backgroundColorDarkColor : "#333333"
            }, ref: virtuoso, data: filteredMessages, itemContent: (index, item) => {
                const message = filteredMessages[index];
                const isLastMessage = item?.index === conversationArray?.length - 1;
                const renderInProgressAfter = message?.isQuestion;
                const renderAgentStepsMessage = agentSteps && agentSteps?.length > 0 && (isAsking || isAskingAgent) && currentAgentStep;
                const hasStreamedText = message?.isStreamed && message?.userText && message.userText.length > 0 && !message?.alwaysHide;
                const renderAgentStepProgressBefore = !hideStepProgressForCurrentStep &&
                    isLastMessage &&
                    !renderInProgressAfter &&
                    renderAgentStepsMessage &&
                    // Checking if streaming is on, and then only render before streamed summarization response starts coming in
                    (!hasChatStreaming ||
                        currentAgentStepIndex < summaryStepIndex ||
                        (currentAgentStepIndex === summaryStepIndex && !hasStreamedText));
                const renderAgentStepProgressAfter = !hideStepProgressForCurrentStep && isLastMessage && renderInProgressAfter && renderAgentStepsMessage;
                const ChatIsAskingMessageElement = (React.createElement(ChatIsAskingMessageWrapper, { messageContent: React.createElement(InProgressStepsMessage, null) }));
                // Decides whether to render the placeholder inprogress indicator
                const renderIsAskingMessage = 
                // Don't render if we're showing any of the other elements
                !renderAgentStepProgressBefore &&
                    !renderAgentStepProgressAfter &&
                    // only render on the last question before anything comes in
                    isLastMessage &&
                    // only render while waiting for a response
                    (isAsking || isAskingAgent) &&
                    // this checks to make sure there's no agent steps or an active agent
                    // so we don't duplicate progress indicators for agents
                    (!agentSteps ||
                        (agentSteps && agentSteps?.length < 1) ||
                        agentId !== undefined ||
                        !currentAgentStep ||
                        hideStepProgressForCurrentStep) &&
                    // don't show when streaming message in
                    !(hasChatStreaming &&
                        (hasStreamedText || (currentAgentStepIndex > summaryStepIndex && !hideStepProgressForCurrentStep)));
                return (React.createElement("div", { style: { minHeight: "1px" } },
                    renderAgentStepProgressBefore && ChatIsAskingMessageElement,
                    React.createElement(ChatMessage, { key: index, message: message, index: index, ignoredImports: ignoredImports, updateIgnoredImports: updateIgnoredImports, emailUsers: emailUsers, isChatTemplate: isChatTemplate, tryChatTemplate: tryChatTemplate, isLastMessage: isLastMessage, isAssistantAgent: isAssistantAgent }),
                    renderAgentStepProgressAfter && ChatIsAskingMessageElement,
                    renderIsAskingMessage && isOptimizeModelsRunning !== true && (React.createElement(ChatIsAskingMessageWrapper, { messageContent: React.createElement(ChatIsAskingMessage, null) })),
                    isOptimizeModelsRunning && isLastMessage && (React.createElement(ChatIsAskingMessageWrapper, { messageContent: React.createElement(ChatIsAskingMessage, { forceText: isFirstModel && !isProjectDone
                                ? (isAsking ? "Generating suggestion and model " : "Model ") +
                                    "training in progress. New models may improve above optimization"
                                : (isAsking ? "Generating suggestion and model " : "Model ") +
                                    "training in progress. Once it completes I will display your optimized business plan here" }) }))));
            }, components: {
                Footer: () => React.createElement("div", { style: safeClawOptimize ? { height: "200px" } : { height: "300px" } })
            }, rangeChanged: ({ endIndex }) => {
                const bottomItem = filteredMessages[endIndex];
                if (currentViewMessage !== bottomItem?.messageIndex && bottomItem?.messageIndex !== undefined) {
                    updateCurrentViewMessage(bottomItem?.messageIndex);
                }
            } })) : (React.createElement("div", { className: styles.chatMain, id: "chatGPT_scroll_real", style: {
                width: tryChatTemplate
                    ? "100%"
                    : chatType === "DOCUMENT"
                        ? !contextSelectionPanelTab && (showSettings === true || artifactId === undefined)
                            ? "100%"
                            : "60%"
                        : (!contextSelectionPanelTab || showSettings === true) &&
                            (datasetId === undefined || showSettings === true || datasetId === "new")
                            ? "100%"
                            : "60%",
                backgroundColor: customBackgroundColor,
                color: backgroundColorDarkMode ? backgroundColorDarkColor : "#333333",
                overflowY: USE_VIRTUALIZE === true ? "hidden" : "auto"
            }, ref: chatScrollRef },
            conversationArray.length ? (React.createElement("div", { className: styles.chatMainHolder, id: "chatGPT_scroll_main", style: USE_VIRTUALIZE ? { height: "100%" } : {} },
                conversationArray
                    .sort((a, b) => a?.questionIndex === undefined || b?.questionIndex === undefined
                    ? 0
                    : a?.questionIndex < b?.questionIndex
                        ? -1
                        : a?.questionIndex > b?.questionIndex
                            ? 1
                            : 0)
                    .map((message, index) => {
                    const isLastMessage = index === conversationArray?.length - 1;
                    const renderInProgressAfter = message?.isQuestion;
                    const renderAgentStepsMessage = agentSteps &&
                        agentSteps?.length > 0 &&
                        (isAsking || isAskingAgent) &&
                        currentAgentStep &&
                        !hideStepProgressForCurrentStep;
                    const renderAgentStepProgressBefore = isLastMessage && !renderInProgressAfter && renderAgentStepsMessage;
                    const renderAgentStepProgressAfter = isLastMessage && renderInProgressAfter && renderAgentStepsMessage;
                    const ChatIsAskingMessageElement = (React.createElement(ChatIsAskingMessageWrapper, { messageContent: React.createElement(InProgressStepsMessage, null) }));
                    return (React.createElement(React.Fragment, null,
                        renderAgentStepProgressBefore && ChatIsAskingMessageElement,
                        React.createElement(ChatMessage, { key: index, message: message, index: index, ignoredImports: ignoredImports, updateIgnoredImports: updateIgnoredImports, emailUsers: emailUsers, isChatTemplate: isChatTemplate, tryChatTemplate: tryChatTemplate, isLastMessage: isLastMessage, isAssistantAgent: isAssistantAgent }),
                        renderAgentStepProgressAfter && ChatIsAskingMessageElement));
                }),
                (isAsking || isAskingAgent) &&
                    (!agentSteps ||
                        (agentSteps && agentSteps?.length < 1) ||
                        agentId !== undefined ||
                        !currentAgentStep ||
                        hideStepProgressForCurrentStep) && (React.createElement(ChatIsAskingMessageWrapper, { messageContent: React.createElement(ChatIsAskingMessage, null) })))) : (React.createElement("div", null,
                React.createElement(LoadingIndicator, null))),
            React.createElement("div", { ref: endOfListRef, className: styles.chatSpacer, style: USE_VIRTUALIZE ? { height: "0px" } : {} })))));
};
const ChatIsAskingMessageWrapper = ({ messageContent }) => {
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    if (!messageContent) {
        return React.createElement(React.Fragment, null);
    }
    const hasCustomIcon = chatApp?.wizard?.base64StringBot !== undefined && chatApp?.wizard?.base64StringBot !== "";
    return (React.createElement("div", { className: styles.chatMessage, style: {
            height: "auto",
            background: chatApp?.wizard?.backgroundColor !== undefined ? "none" : "transparent"
        } },
        React.createElement("div", { className: styles.chatBody },
            React.createElement("div", { className: styles.userIcon, style: { background: hasCustomIcon ? "#94A3B8" : "#3E1270" } },
                React.createElement("img", { className: hasCustomIcon ? styles.userIconImageCustom : styles.userIconImage, src: hasCustomIcon ? chatApp?.wizard?.base64StringBot : aibleBadge })),
            React.createElement("div", { className: styles.messageBody },
                React.createElement("div", { className: styles.messageText }, messageContent)))));
};
const ChatIsAskingMessage = ({ forceText }) => {
    const selectedBlueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const agentId = useSelector((state) => chatGPTReducer.getAgentId(state));
    const isAskingAgent = useSelector((state) => chatGPTReducer.getIsAskingAgent(state));
    const optimizeSetup = useSelector((state) => chatGPTReducer.getOptimizeSetup(state));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: "flex", alignItems: "center" } },
            React.createElement(LoadingIndicator, { style: {
                    margin: "0px",
                    marginRight: "35px",
                    height: "60px",
                    width: "20px",
                    transform: "scale(0.666)"
                }, color: "#B5B4D0" }),
            React.createElement("span", null, forceText !== undefined
                ? forceText
                : optimizeSetup !== undefined
                    ? "Generating Suggestion..."
                    : selectedBlueprintId === "CHATAIBLE_DATA_SEARCH" && agentId === undefined
                        ? "Searching for data that can answer your question"
                        : isAskingAgent && agentId === undefined
                            ? "Generating a plan and answering your question based on the available agents, tools, and data."
                            : isAskingAgent && agentId !== undefined
                                ? "Evaluating data and generating a response"
                                : "Evaluating..."))));
};
const ChatInterface = ({ isNoDataset, isSenseMode, tryChatTemplate, hideFooter, hideAutonomyControls, hideDetailsPanel, safeClawOptimize, isAssistantAgent }) => {
    debug("Render: ChatInterface");
    const dispatch = useDispatch();
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const isOpenFewShotModal = useSelector((state) => nextReducer.getIsOpenFewShotModal(state, nextId));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const showSettings = useSelector((state) => chatGPTReducer.getShowSettings(state));
    const contextSelectionPanelTab = useSelector((state) => chatGPTReducer.getContextSelectionPanelTab(state));
    const showTemplateRecommendations = useSelector((state) => chatGPTReducer.getShowTemplateRecommendations(state));
    console.log("Chat datasetId", datasetId);
    const currentViewMessage = useSelector((state) => chatGPTReducer.getCurrentViewMessage(state));
    const updateCurrentViewMessage = (val) => dispatch(chatGPTReducer.updateCurrentViewMessage(val));
    // const [currentViewMessage, updateCurrentViewMessage] = useState<number | undefined>(undefined);
    const optimizeSetup = useSelector((state) => chatGPTReducer.getOptimizeSetup(state));
    const isShowChart = useSelector((state) => chatGPTReducer.getShowChart(state).isShowChart);
    const [openClawAgent, updateOpenClawAgent] = useState({});
    const forceShowOptimize = useSelector((state) => chatGPTReducer.getForceShowOptimize(state));
    // Clearing hoverChart on scrollend to fix hoverCharts being stuck and not firing from onMouseEnd on chat scroll.
    useEffect(() => {
        const chatScroll = document.getElementById("chatGPT_scroll_real");
        const handleHoverLeave = () => dispatch(chatGPTReducer.handleHoverLeave());
        if (chatScroll) {
            chatScroll.addEventListener("scrollend", handleHoverLeave);
        }
        return () => {
            if (chatScroll) {
                chatScroll.removeEventListener("scrollend", handleHoverLeave);
            }
        };
    });
    return (React.createElement("div", { className: styles.realPanel },
        React.createElement(ChatConversation, { currentViewMessage: currentViewMessage, updateCurrentViewMessage: updateCurrentViewMessage, tryChatTemplate: tryChatTemplate, hideDetailsPanel: hideDetailsPanel, safeClawOptimize: safeClawOptimize, isAssistantAgent: isAssistantAgent }),
        hideFooter !== true && (React.createElement("div", null,
            React.createElement(Footer, { isNoDataset: isNoDataset, isSenseMode: isSenseMode, tryChatTemplate: tryChatTemplate, hideAutonomyControls: hideAutonomyControls, safeClawOptimize: safeClawOptimize }))),
        React.createElement("div", null,
            React.createElement(FewShotView, { nextId: nextId, isOpen: isOpenFewShotModal, onClose: () => dispatch(nextReducer.updateIsOpenFewShotModal(nextId, false)) })),
        chatType === "OPENSHELL" && isShowChart === undefined && forceShowOptimize !== true ? (React.createElement("div", { className: styles.analyticsPanel, style: { padding: "0px" }, id: "analytics_panel_scroller" },
            React.createElement(TemplateRightPanel, { selectedItem: chatGPTReducer.OPENSHELL, updateSelectedItem: (e) => console.log("e", e), isOpenShell: true }))) : forceShowOptimize === true ||
            ((optimizeSetup !== undefined || chatType === "OPTIMIZE") && showSettings !== true && !tryChatTemplate) ? (React.createElement("div", { className: styles.analyticsPanel, style: { padding: "0px" }, id: "analytics_panel_scroller" },
            React.createElement(TemplateOptimize, { isChat: true }))) : tryChatTemplate ? (React.createElement(React.Fragment, null)) : contextSelectionPanelTab && !showSettings ? (React.createElement("div", { className: styles.analyticsPanel },
            React.createElement(ContextSelectionPanel, { nextId: nextId, isClose: true, forceChatAppInit: true }))) : !showSettings ? (showTemplateRecommendations ? (React.createElement("div", { className: styles.analyticsPanel },
            React.createElement(SearchTemplateRecommendations, null))) : datasetId !== undefined && datasetId !== "new" && !hideDetailsPanel ? (React.createElement(AnalyticsPanel, { currentViewMessage: currentViewMessage })) : (artifactId !== undefined &&
            chatType === "DOCUMENT" &&
            !hideDetailsPanel && (React.createElement("div", { className: styles.analyticsPanel },
            React.createElement(ChatCapabilityList, { defaultShow: true, currentViewMessage: currentViewMessage }))))) : null));
};
const ChatChartsLoadingDialogue = ({ datasetId }) => {
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    return (React.createElement("div", { className: styles.chatChartsLoading },
        React.createElement("div", { className: styles.aStateBoxFlex },
            React.createElement("div", { className: styles.aStateBoxIcon, style: { height: "20px" } },
                React.createElement(LoadingIndicator, { style: {
                        margin: "0px",
                        marginLeft: "-10px",
                        transform: "scale(.3)"
                    } })),
            React.createElement("div", { className: styles.aStateBoxInfo },
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.analyticsPanelHeader }, `Evaluating ${dataset?.label} for what impacts ${dataset?.outcome}`))))));
};
const TopFactors = ({ datasetId, showAll }) => {
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    if (dataset?.status_name !== "DONE") {
        return React.createElement(ChatChartsLoadingDialogue, { datasetId: datasetId });
    }
    return (React.createElement("div", { className: styles.topFactors },
        React.createElement(UsefulVariables, { dataset: dataset, showAll: showAll, skipProblemPredictorsCheck: true })));
};
const CheckMark = () => {
    return (React.createElement("div", { className: styles.aStateBoxIcon, style: { fontSize: "16px", color: "green" } },
        React.createElement("img", { style: { width: "18px" }, src: circleCheckGreen })));
};
export const DatasetAnalytics = ({ defaultShow, skipRedirect, skipExploreStepDetection, isMessageFlow }) => {
    const dispatch = useDispatch();
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const isKPISelectionOpen = useSelector((state) => nextReducer.getIsKPISelectionOpen(state, nextId));
    const updateIsKPISelectionOpen = (val) => dispatch(nextReducer.updateIsKPISelectionOpen(nextId, val));
    const [localShowSteps, updateLocalShowSteps] = useState(defaultShow ?? isKPISelectionOpen ?? false);
    const modelId = useSelector((state) => chatGPTReducer.getModelId(state));
    const outcomeSuggestPrompt = useSelector((state) => chatGPTReducer.getOutcomeSuggestPrompt(state, true, modelId));
    const resetOutcomeSuggestPrompt = () => dispatch(chatGPTReducer.resetOutcomeSuggestPrompt(modelId));
    // We're controlling the local state through the reducer, but we still want default show to be able to open the accordion
    // The correct way is to chase down the cases we toggle default show and update the reducer there
    // This might just be in the try template view?
    const showSteps = localShowSteps;
    const updateShowSteps = (val) => {
        updateIsKPISelectionOpen(val);
        updateLocalShowSteps(val);
    };
    useEffect(() => {
        updateLocalShowSteps(isKPISelectionOpen);
    }, [isKPISelectionOpen]);
    const [showAllOutcomes, updateShowAllOutcomes] = useState(false);
    const [selectedOutcome, updateSelectedOutcome] = useState();
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    useEffect(() => {
        updateShowAllOutcomes(false);
    }, [datasetId]);
    const isDatasetFetching = useSelector((state) => globalReducer.getIsDatasetFetching(state))?.[datasetId];
    const isLoadingSuggestedColumns = useSelector((state) => nextReducer.getIsLoadingSuggestedColumns(state, nextId));
    const suggestedColumns = useSelector((state) => nextReducer.getSuggestedColumns(state, nextId));
    const rawOutcomeOptions = useSelector((state) => homeReducer.getOutcomeOptions(state, datasetId))
        .filter((o) => {
        return o.value !== dataset?.outcome;
    })
        .map((o) => {
        return {
            label: o?.label,
            value: o?.value ?? o?.label
        };
    });
    const outcomeOptions = rawOutcomeOptions.filter((o) => {
        if (suggestedColumns?.length) {
            return suggestedColumns.includes(o.value);
        }
        return false;
    });
    const outcomeField = dataset?.fields?.[dataset?.outcome ?? ""];
    const aiReadyMetrics = useSelector((state) => getAiReadyMetrics(state, "new", datasetId));
    const aiScore = (aiReadyMetrics?.aiReadinessScore ?? 0) * 10;
    const aiStatus = aiReadyMetrics?.aiReadinessStatus;
    const aiScoreColor = getColorFromStatus(aiStatus);
    const predictors = [...(aiReadyMetrics?.aiReady ?? []), ...(aiReadyMetrics?.secondOrder?.aiReady ?? [])].sort((a, b) => b.value - a.value);
    const topFactors = predictors?.length ?? 0;
    const isDataLeakageCheck = useSelector((state) => nextReducer.getIsDataLeakageCheck(state, nextId));
    const dataLeakageMessage = useSelector((state) => nextReducer.getDataLeakageMessage(state, nextId));
    console.log("what is dataLeakageMessage", dataLeakageMessage);
    const isDataInitialLoad = (!dataset && isDatasetFetching) ||
        (dataset?.status_name !== "DONE" &&
            dataset?.status_name !== "ERROR" &&
            !dataset?.labels?.length &&
            dataset?.number_of_rows === -1);
    const simpleFlowStep = useSelector((state) => nextReducer.getSimpleFlowStep(state, nextId));
    const simpleFlowStepDisplay = useSelector((state) => nextReducer.getSimpleFlowStepDisplay(state, nextId));
    const updateSimpleFlowStepDisplay = (newStep) => dispatch(nextReducer.updateSimpleFlowStepDisplay(nextId, newStep));
    const analysisState = !skipExploreStepDetection &&
        (chatType === "AIBLE" || chatType === "WHATS_CHANGED") &&
        dataset?.status_name === "DONE" &&
        dataset?.outcome !== undefined
        ? "EXPLORE"
        : simpleFlowStep !== undefined
            ? simpleFlowStep
            : dataset?.status_name !== "DONE" && !isDataInitialLoad
                ? "SCAN"
                : "BEGIN";
    // This is added because the component renders and a user can still change datasets
    useEffect(() => {
        if (isMessageFlow && defaultShow !== undefined && defaultShow !== showSteps && analysisState === "BEGIN") {
            updateShowSteps(defaultShow);
        }
    }, [defaultShow]);
    const insightCombinationCount = useSelector((state) => nextReducer.getInsightCombinationCount(state, undefined, datasetId));
    const handleCheckLeakage = (skipStepUpdate) => {
        return dispatch(nextReducer.dataLeakageCheckWaiter(nextId, datasetId, undefined, skipStepUpdate));
    };
    const handleReadinessScan = async (skipFetch) => {
        dispatch(nextReducer.updateSimpleFlowStep(nextId, "SCAN"));
        updateSimpleFlowStepDisplay("SCAN");
        if (!skipFetch) {
            await dispatch(homeReducer.awaitDatasetProcess(datasetId));
        }
        return handleCheckLeakage();
    };
    const handleOutcomeSelection = (targetOutcome) => {
        if (dataset?.outcome !== undefined) {
            return dispatch(homeReducer.changeDatasetTarget(datasetId, targetOutcome)).then(() => {
                return handleReadinessScan();
            });
        }
        else {
            return dispatch(homeReducer.setDatasetTarget(datasetId, targetOutcome)).then(() => {
                return handleReadinessScan();
            });
        }
    };
    const handleSuggestKPIs = async () => {
        await dispatch(nextReducer.suggestedColumnsCheck(nextId, datasetId));
        updateShowAllOutcomes(true);
    };
    const allowKPISwitching = (analysisState === "EXPLORE" && isEnabled("chat-aible-kpi-switching-flow")) || analysisState !== "EXPLORE";
    const useExploreHeader = analysisState === "EXPLORE" || (isMessageFlow && dataset?.outcome !== undefined);
    const [showKPIPrompt, setShowKPIPrompt] = useState(false);
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.analyticsPanelHeaderWrapper + " " + (!showSteps ? styles.analyticsPanelHeaderWrapperClosed : ""), style: {
                cursor: allowKPISwitching ? "pointer" : undefined
            }, onClick: () => {
                if (allowKPISwitching) {
                    updateShowSteps(!showSteps);
                }
            } },
            React.createElement("div", { className: styles.aStateBoxInfo, style: { width: "calc(100% - 20px)" } },
                React.createElement("div", { className: styles.aStateBoxFlex },
                    analysisState === "DONE" || useExploreHeader ? (React.createElement(CheckMark, null)) : (React.createElement("div", { className: styles.aStateBoxIcon })),
                    React.createElement("div", { className: styles.aStateBoxInfo },
                        React.createElement("div", { className: styles.analyticsPanelHeader }, isMessageFlow && dataset?.outcome === undefined && chatType !== "SQL" ? ("Lets start by selecting a KPI") : useExploreHeader ? (React.createElement("div", { style: {
                                whiteSpace: "pre",
                                display: "flex",
                                alignItems: "center"
                            } },
                            React.createElement("div", { className: styles.outcomeEllipsisText, style: { maxWidth: "360px" } }, dataset?.outcome),
                            React.createElement("div", null, ` has ${topFactors ? topFactors + " " : ""}Top Insights Available to Explore`))) : analysisState === "BEGIN" ? ("Would you like to automatically discover what influences your KPIs in " + dataset?.label + "?") : ("Would you like to explore how a KPI is impacted by this data?")),
                        useExploreHeader ? (React.createElement("div", { className: styles.analyticsPanelText }, insightCombinationCount !== undefined && insightCombinationCount > 0 && (React.createElement(React.Fragment, null,
                            React.createElement("strong", null, numeral(insightCombinationCount).format("0,0")),
                            React.createElement("span", null, " possible insights evaluated."))))) : analysisState === "BEGIN" ? null : (React.createElement("div", { className: styles.analyticsPanelText }, "You can select the field to evaluate or I can suggest potential KPIs I find in this data."))),
                    allowKPISwitching && (React.createElement("div", { className: styles.analyticsPanelAccordionIcon },
                        React.createElement(Icon, { type: showSteps ? "chevronUp" : "chevronDown" })))))),
        showSteps && (React.createElement("div", { className: styles.analyticsPanelContent },
            React.createElement(Accordion, { style: { marginBottom: "20px" }, show: simpleFlowStepDisplay === "BEGIN", onClick: () => updateSimpleFlowStepDisplay(simpleFlowStepDisplay === "BEGIN" ? "NONE" : "BEGIN"), header: React.createElement("div", { className: styles.aStateBoxInfo },
                    React.createElement("div", { className: styles.aStateBoxFlex },
                        isDataInitialLoad ? (React.createElement("div", { className: styles.aStateBoxIcon, style: { height: "20px" } },
                            React.createElement(LoadingIndicator, { style: {
                                    margin: "0px",
                                    marginLeft: "-10px",
                                    transform: "scale(.3)"
                                } }))) : analysisState === "SCAN" ||
                            analysisState === "INSIGHT_CHECK" ||
                            analysisState === "DONE" ||
                            analysisState === "EXPLORE" ? (React.createElement(CheckMark, null)) : (React.createElement("div", { className: styles.aStateBoxIcon })),
                        React.createElement("div", { className: styles.aStateBoxInfo }, isDataInitialLoad ? (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: styles.analyticsPanelHeader }, "Loading Dataset Details..."))) : analysisState === "BEGIN" ? (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: styles.analyticsPanelHeader }, isMessageFlow && chatType !== "SQL"
                                ? "What KPI would you like to explore?"
                                : "Automatically see what impacts KPI in this data"),
                            React.createElement("div", { className: styles.analyticsPanelText }, "KPIs (Key Performance Indicators) are metrics used to measure and track specific outcomes in your data. Examples include ‘Deal Won’ for sales, ‘Churned’ for customer loyalty, or ‘Loan Approved’ in banking."))) : (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: styles.analyticsPanelHeader }, `KPI Selected${dataset?.outcome !== undefined ? `: ${dataset?.outcome}` : ""}`),
                            dataset?.outcome !== undefined && (React.createElement("div", { className: styles.analyticsPanelText }, (rawOutcomeOptions?.length ?? 0) + " other KPIs available"))))))) },
                React.createElement("div", { className: styles.aStateBox }, isDataInitialLoad ? (React.createElement(React.Fragment, null)) : (React.createElement("div", { className: clsx(styles.outcomeOptionsBox, "flex flex-col gap-2.5 items-start") },
                    dataset?.outcome !== undefined && (React.createElement(Button, { onClick: (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleReadinessScan(true);
                        }, isLoading: isDatasetFetching, style: { padding: "10px 15px" }, active: true },
                        React.createElement("div", { className: styles.aStateBoxFlex },
                            outcomeField?.type === "categorical" && !outcomeField?.isNumeric ? (React.createElement("img", { src: CategoryIcon, style: { marginRight: "5px", width: "20px" }, title: "Categorical" })) : outcomeField?.type === "date" ? (React.createElement("img", { src: DateIcon, style: { marginRight: "5px", width: "18px", marginTop: "-2px" }, title: "Date" })) : outcomeField?.isNumeric ? (React.createElement("img", { src: NumberIcon, style: { marginRight: "5px", marginLeft: "-2px", width: "20px" }, title: "Numeric" })) : null,
                            React.createElement("div", { className: styles.outcomeEllipsisText }, dataset?.outcome)))),
                    React.createElement("div", { style: {
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "10px"
                        } },
                        React.createElement("div", null,
                            React.createElement("div", { className: styles.outcomeHolderSelect },
                                React.createElement(Select, { options: rawOutcomeOptions, placeholder: "Select KPI", value: selectedOutcome === undefined
                                        ? selectedOutcome
                                        : (rawOutcomeOptions?.find((o) => o.value === selectedOutcome) ?? {
                                            label: selectedOutcome,
                                            value: selectedOutcome
                                        }), onChange: (val) => {
                                        if (!isOptionType(val)) {
                                            return;
                                        }
                                        updateSelectedOutcome(val?.value);
                                    } }))),
                        React.createElement(Button, { onClick: (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleSuggestKPIs();
                            }, style: { padding: "9px 16px" }, isLoading: isLoadingSuggestedColumns }, "Suggest KPIs"),
                        React.createElement(Button, { type: "secondary", active: showKPIPrompt, style: { marginRight: "6px" }, onClick: () => setShowKPIPrompt(!showKPIPrompt) },
                            React.createElement("img", { src: IconVideoOptionsGray, style: { width: "18px" } }))),
                    selectedOutcome !== undefined && (React.createElement(Button, { isLoading: isDatasetFetching, onClick: (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            return handleOutcomeSelection(selectedOutcome);
                        }, style: {
                            padding: "9px 16px",
                            marginTop: "10px"
                        }, type: "primary" }, "Analyze KPI")),
                    showKPIPrompt && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.settingLabel },
                            "Suggest KPI Prompt",
                            React.createElement(Tooltip, { overlay: `This the prompt that gets sent to the LLM to ask it find potential KPIs from the dataset. The columns will be appended at the end of the prompt as "COLUMNS: []"` }),
                            React.createElement(Button, { isSmall: true, type: "secondary", style: { marginLeft: "auto" }, onClick: () => resetOutcomeSuggestPrompt() }, "Reset")),
                        React.createElement(TextInput, { className: styles.settingPrompt, value: outcomeSuggestPrompt ?? "", onChange: (val) => dispatch(chatGPTReducer.updateOutcomeSuggestPrompt(val, modelId)), isDisabled: isLoadingSuggestedColumns }))),
                    showAllOutcomes || outcomeOptions?.length ? (outcomeOptions?.length ? (React.createElement("div", { style: {
                            display: "grid",
                            gap: "10px",
                            gridTemplateColumns: "minmax(max-content, auto) minmax(max-content, auto) 1fr",
                            alignItems: "center",
                            minHeight: "50px"
                        } }, outcomeOptions.map((o) => {
                        const currField = dataset?.fields?.[o.value];
                        const isEvaluated = currField?.inclusionProbabilities && currField?.interactionInclusionProbabilities;
                        return (React.createElement("div", { key: o.value, style: {
                                display: "contents"
                            } },
                            React.createElement("div", { style: { display: "flex", alignItems: "center", maxWidth: "217px" } },
                                React.createElement(Button, { isLoading: isDatasetFetching, onClick: (e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        return handleOutcomeSelection(o?.value);
                                    }, style: { padding: "5px" } },
                                    React.createElement("div", { className: styles.aStateBoxFlex },
                                        currField?.type === "categorical" && !currField?.isNumeric ? (React.createElement("img", { src: CategoryIcon, style: {
                                                marginRight: "5px",
                                                width: "20px"
                                            }, title: "Categorical" })) : currField?.type === "date" ? (React.createElement("img", { src: DateIcon, style: {
                                                marginRight: "5px",
                                                width: "18px",
                                                marginTop: "-2px"
                                            }, title: "Date" })) : currField?.type === "number" || currField?.isNumeric ? (React.createElement("img", { src: NumberIcon, style: {
                                                marginRight: "5px",
                                                marginLeft: "-2px",
                                                width: "20px"
                                            }, title: "Numeric" })) : null,
                                        o?.label))),
                            React.createElement("div", { className: styles.smallSubText, style: { display: "flex", alignItems: "center" } }, isEvaluated ? "READY TO EXPLORE" : "NOT EVALUATED"),
                            React.createElement("div", { className: styles.outcomeGraph, style: { display: "flex", alignItems: "center" } },
                                React.createElement(DistributionChart, { dataset: dataset, field: currField }))));
                    }))) : (React.createElement("div", { className: "space-y-2.5" },
                        React.createElement("div", { className: styles.smallSubText }, `The LLM couldn't find any ${dataset?.outcome !== undefined ? "other " : ""} KPIs to recommend.`),
                        React.createElement("div", { className: styles.smallSubText }, `You can select a KPI to evaluate from the dropdown above.`)))) : null)))),
            (analysisState === "SCAN" ||
                analysisState === "INSIGHT_CHECK" ||
                analysisState === "DONE" ||
                analysisState === "EXPLORE") && (React.createElement(Accordion, { style: { marginBottom: "20px" }, disabled: !(analysisState === "SCAN" && dataset?.status_name === "DONE"), show: simpleFlowStepDisplay === "SCAN", onClick: () => updateSimpleFlowStepDisplay(simpleFlowStepDisplay === "SCAN" ? "NONE" : "SCAN"), header: React.createElement("div", { className: styles.aStateBoxInfo },
                    React.createElement("div", { className: styles.aStateBoxFlex },
                        analysisState === "SCAN" && dataset?.status_name !== "DONE" ? (React.createElement("div", { className: styles.aStateBoxIcon, style: { height: "20px" } },
                            React.createElement(LoadingIndicator, { style: {
                                    margin: "0px",
                                    marginLeft: "-10px",
                                    transform: "scale(.3)"
                                } }))) : (React.createElement(CheckMark, null)),
                        React.createElement("div", { className: styles.aStateBoxInfo }, analysisState === "SCAN" && dataset?.status_name !== "DONE" ? (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: styles.analyticsPanelHeader }, `Evaluating ${dataset?.label} for what impacts ${dataset?.outcome}`),
                            React.createElement("div", { className: styles.analyticsPanelText }, "I will rank the insights so you see the most important first"))) : (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: styles.analyticsPanelHeader }, dataset?.outcome + " Data Quality Check: Passed"),
                            React.createElement("div", { className: styles.analyticsPanelText }, aiStatus === "NO_SIGNAL"
                                ? "This dataset needs more data."
                                : aiStatus === "SUSPECT_SIGNAL"
                                    ? "This dataset may be too good to be true."
                                    : aiStatus === "LOW_SIGNAL"
                                        ? "This dataset can be useful, but more data will help."
                                        : "Very good dataset for understanding what impacts " + dataset?.outcome),
                            React.createElement("div", { className: styles.analyticsPanelBarOuter, style: { height: "6px" } },
                                React.createElement("div", { className: styles.analyticsPanelBarInner, style: {
                                        width: Math.min(100, aiScore * 10) + "%",
                                        background: aiScoreColor
                                    } }))))))) })),
            (analysisState === "INSIGHT_CHECK" || analysisState === "DONE" || analysisState === "EXPLORE") && (React.createElement(Accordion, { style: { marginBottom: "20px" }, show: simpleFlowStepDisplay === "INSIGHT_CHECK", onClick: () => updateSimpleFlowStepDisplay(simpleFlowStepDisplay === "INSIGHT_CHECK" ? "NONE" : "INSIGHT_CHECK"), header: React.createElement("div", { className: styles.aStateBoxInfo },
                    React.createElement("div", { className: styles.aStateBoxFlex },
                        analysisState === "DONE" || analysisState === "EXPLORE" ? (React.createElement(CheckMark, null)) : isDataLeakageCheck ? (React.createElement("div", { className: styles.aStateBoxIcon, style: { height: "20px" } },
                            React.createElement(LoadingIndicator, { style: {
                                    margin: "0px",
                                    marginLeft: "-10px",
                                    transform: "scale(.3)"
                                } }))) : (React.createElement("div", { className: styles.aStateBoxIcon })),
                        React.createElement("div", { className: styles.aStateBoxInfo, style: { minWidth: "unset", width: "unset" } }, analysisState === "INSIGHT_CHECK" &&
                            (!dataLeakageMessage?.leakageJSON?.length || isDataLeakageCheck) ? (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: styles.analyticsPanelHeader }, "Insight Quality Check"),
                            React.createElement("div", { className: styles.analyticsPanelText }, "Automatically find and remove factors that may reduce insight quality"))) : dataLeakageMessage !== undefined ? (dataLeakageMessage?.leakageJSON?.length ? (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: styles.analyticsPanelHeader }, `Removing ${dataLeakageMessage?.leakageJSON?.length} factors may improve the quality of the insights.`),
                            React.createElement("div", { className: styles.analyticsPanelText }, "This will help improve the quality of the insights"))) : (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: styles.analyticsPanelHeader }, `Insight Quality Check passed`),
                            React.createElement("div", { className: styles.analyticsPanelText }, "We couldn't find any factors that may reduce insight quality")))) : (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: styles.analyticsPanelHeader }, "Insight Quality Check Skipped")))),
                        (analysisState === "DONE" || analysisState === "EXPLORE") && (React.createElement(Button, { isLoading: isDataLeakageCheck, style: { padding: "5px", marginLeft: "10px" }, type: "secondary", onClick: (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleCheckLeakage();
                                updateSimpleFlowStepDisplay("INSIGHT_CHECK");
                            } }, "Check for Insight Quality")))), disabled: dataLeakageMessage === undefined },
                React.createElement("div", null, dataLeakageMessage !== undefined && (React.createElement("div", null,
                    React.createElement(LeakageInfo, { message: dataLeakageMessage, skipRedirect: skipRedirect }))))))))));
};
const DatasetColumnDetails = ({ isDisabled }) => {
    const dispatch = useDispatch();
    const datasetColumnDetails = useSelector((state) => chatGPTReducer.getDatasetColumnDetails(state));
    const updateDatasetColumnDetails = (val) => dispatch(chatGPTReducer.updateDatasetColumnDetails(val));
    const [isEditMode, updateIsEditMode] = useState(false);
    const [localDetails, updateLocalDetails] = useState(datasetColumnDetails);
    const isEmpty = !datasetColumnDetails;
    const placeholder = "Adding details about your dataset columns can help improve speed to insights by giving users an overview of the data. Define column names, data types, and descriptions to make your data more meaningful.";
    return (React.createElement("div", { className: styles.datasetColumnDetails },
        React.createElement("div", { className: styles.datasetColumnTitle },
            React.createElement("div", { className: styles.datasetColumnTitleText }, isEmpty ? "Add your data dictionary" : "Data Dictionary"),
            React.createElement("div", { className: styles.datasetColumnTitleActions }, !isDisabled && (React.createElement(Button, { style: { padding: "5px 10px" }, active: isEditMode, onClick: () => {
                    updateLocalDetails(datasetColumnDetails);
                    updateIsEditMode(!isEditMode);
                } }, isEmpty ? "Add Column Details" : "Edit")))),
        React.createElement("div", { className: styles.datasetColumnBody }, isEditMode ? (React.createElement(React.Fragment, null,
            React.createElement(TextInput, { className: styles.settingPrompt, value: localDetails, onChange: (val) => updateLocalDetails(val) }),
            React.createElement(Button, { onClick: () => {
                    updateDatasetColumnDetails(localDetails);
                    updateIsEditMode(false);
                } }, "Save"))) : isEmpty ? (placeholder) : (datasetColumnDetails))));
};
export const AnalyticsPanel = ({ currentViewMessage }) => {
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const isLiveChatApp = chatApp?.id !== undefined;
    const hideOutcomeSelection = useSelector((state) => chatAppReducer.getHideOutcomeSelection(state));
    const isShowChart = useSelector((state) => chatGPTReducer.getShowChart(state).isShowChart);
    const hoverMessage = useSelector((state) => chatGPTReducer.getHoverChart(state).message);
    const conversationArray = useSelector((state) => chatGPTReducer.getConversationArray(state, undefined, true));
    const currMessage = conversationArray?.find((msg) => msg?.messageIndex === currentViewMessage);
    let latestMessage = conversationArray?.findLast((msg) => {
        return (msg?.questionIndex === currMessage?.questionIndex &&
            (msg?.chatType === "AIBLE" || msg?.chatType === "SQL" || msg?.chatType === "WHATS_CHANGED") &&
            Boolean(msg?.currentPromptCharts?.length));
    });
    const lastMessage = conversationArray?.findLast((msg) => {
        return ((msg?.chatType === "AIBLE" || msg?.chatType === "SQL" || msg?.chatType === "WHATS_CHANGED") &&
            Boolean(msg?.currentPromptCharts?.length));
    });
    if (!latestMessage) {
        latestMessage = lastMessage;
    }
    const hasQuestions = Boolean(conversationArray.find((msg) => msg?.isQuestion));
    return (React.createElement("div", { className: isShowChart !== undefined ? styles.analyticsPanel + styles.chartAnalyticsPanel : styles.analyticsPanel },
        isShowChart !== undefined ? (React.createElement(HoverItem, { message: hoverMessage, listItem: isShowChart, isClose: true })) : (React.createElement(React.Fragment, null,
            !(isLiveChatApp && hideOutcomeSelection) && React.createElement(DatasetAnalytics, { defaultShow: true }),
            (chatType == "SQL" || chatType === "AIBLE" || chatType === "DOCUMENT" || chatType === "WHATS_CHANGED") && (React.createElement(ChatCapabilityList, { defaultShow: !hasQuestions, onFinishAction: "OPEN" })),
            chatType === "SQL" && React.createElement(DatasetColumnDetails, { isDisabled: isLiveChatApp && hideOutcomeSelection }))),
        currMessage?.prediction_table !== undefined && React.createElement(WhatIfPanel, { message: currMessage })));
};
export const WhatIfPanel = ({ message }) => {
    const project = useSelector((state) => projectReducer.getProject(state, message?.projectId));
    const forcePrediction = message?.prediction_table.map((pt) => message?.minMaxField === undefined
        ? {
            probability: Number(pt.score) * 100,
            value: pt[Object.keys(pt).filter((k) => k != "score")?.[0]],
            field: Object.keys(pt).filter((k) => k != "score")?.[0],
            otherFields: Object.keys(pt)
                .filter((k) => k != "score")
                .map((k) => ({ field: k, value: pt[k] }))
        }
        : {
            probability: Number(pt.score) * 100,
            value: pt[message?.minMaxField],
            field: message?.minMaxField,
            otherFields: Object.keys(pt)
                .filter((k) => k != "score" && k != message?.minMaxField)
                .map((k) => ({ field: k, value: pt[k] }))
        });
    return (React.createElement("div", null,
        React.createElement(FeatureChartContainer, { id: project?.settings?.innerId, label: "Select to see more information about each variable", isResults: true, predictMode: "predict", projectId: message?.projectId, forcePrediction: forcePrediction, isChatPanel: true })));
};
export const ChartsDisplay = ({ currentViewMessage, exploreState, updateExploreState, isAgentSteps }) => {
    const dispatch = useDispatch();
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const createMessageWithData = (message) => dispatch((dispatch, getState) => chatGPTReducer.injectDataIntoMessage(getState(), message));
    let retCurrentViewMessage = currentViewMessage !== undefined
        ? currentViewMessage
        : useSelector((state) => chatGPTReducer.getCurrentViewMessage(state));
    const conversationArray = useSelector((state) => chatGPTReducer.getConversationArray(state, undefined, true));
    const lastMessage = conversationArray?.findLast((msg) => {
        return ((msg?.chatType === "AIBLE" || msg?.chatType === "SQL" || msg?.chatType === "WHATS_CHANGED") &&
            Boolean(msg?.currentPromptCharts?.length));
    });
    // Default to the last message since that's what the steps do, or use latest if currently asking question
    if (!retCurrentViewMessage || isAsking) {
        retCurrentViewMessage = lastMessage?.messageIndex;
    }
    const currMessage = conversationArray?.find((msg) => msg?.messageIndex === retCurrentViewMessage);
    let latestMessage = conversationArray?.findLast((msg) => {
        return (msg?.questionIndex === currMessage?.questionIndex &&
            (msg?.chatType === "AIBLE" || msg?.chatType === "SQL" || msg?.chatType === "WHATS_CHANGED") &&
            Boolean(msg?.currentPromptCharts?.length));
    });
    if (!latestMessage) {
        latestMessage = lastMessage;
    }
    const retMessage = createMessageWithData(latestMessage);
    const hasCharts = retMessage !== undefined;
    const isLastMessage = lastMessage?.questionIndex === latestMessage?.questionIndex;
    if (!hasCharts && dataset?.outcome === undefined) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: isAgentSteps ? styles.chartsDisplayAgentStepsContainer : styles.chartsDisplayContainer },
        React.createElement(ButtonGroup, { style: { marginTop: "10px" } },
            hasCharts && (React.createElement(Button, { style: { padding: "5px 10px" }, onClick: () => updateExploreState("CHARTS"), active: exploreState === "CHARTS", greyscaleDefaultState: true, activeBold: true }, "Aible Top Charts")),
            dataset?.outcome !== undefined ? (React.createElement(React.Fragment, null,
                React.createElement(Button, { style: { padding: "5px 10px" }, onClick: () => updateExploreState("TOP_FACTORS"), active: exploreState === "TOP_FACTORS" || (!hasCharts && exploreState !== "MUSCLE_CHART"), greyscaleDefaultState: true, activeBold: true }, "Top Factors"),
                React.createElement(Button, { style: { padding: "5px 10px" }, onClick: () => updateExploreState("MUSCLE_CHART"), active: exploreState === "MUSCLE_CHART", greyscaleDefaultState: true, activeBold: true }, "Relationship Between Top Factors"))) : null),
        hasCharts && (!exploreState || exploreState === "CHARTS") ? (React.createElement(LLMChartDisplay, { displayMessage: retMessage, currentViewMessage: currentViewMessage, isLastMessage: isLastMessage })) : dataset !== undefined ? (exploreState === "MUSCLE_CHART" ? (React.createElement(PanelReport, null)) : (React.createElement(TopFactors, { datasetId: datasetId, showAll: true }))) : (React.createElement(React.Fragment, null))));
};
const LLMChartDisplay = ({ displayMessage }) => {
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const retMessage = displayMessage;
    const dataset = useSelector((state) => homeReducer.getDataset(state, retMessage?.datasetId ?? datasetId));
    const showAnalyticsChartsWarning = useSelector((state) => chatGPTReducer.getShowAnalyticsChartsWarning(state));
    // const messageCharts = useSelector((state) => chatGPTReducer.getChartsFromMessageObj(state, retMessage));
    const modelName = useSelector((state) => chatGPTReducer.getModelName(state));
    const isSQL = retMessage?.chatType === "SQL";
    const isAnalytics = retMessage?.chatType === "AIBLE" || retMessage?.chatType === "WHATS_CHANGED";
    if (retMessage === undefined) {
        return React.createElement("div", null);
    }
    if (dataset?.status_name !== "DONE") {
        return React.createElement(ChatChartsLoadingDialogue, { datasetId: datasetId });
    }
    return (React.createElement("div", null,
        isAnalytics && showAnalyticsChartsWarning && (React.createElement("div", { className: styles.analyticsChartsWarningWrapper },
            React.createElement("div", { className: "font-bold" }, "No relevant data was found to answer this question."),
            React.createElement("div", { className: "text-pretty" }, `The summary is based on overall ${dataset?.outcome ? dataset.outcome + " " : ""}patterns and does not address the specific question.`))),
        React.createElement("div", null, retMessage?.currentPromptCharts ? (React.createElement(MessageExpansionItem, { isLocked: true, nextId: nextId, dataset: dataset, index: retMessage?.messageIndex, message: retMessage, isOpen: true, modelName: modelName, isLoading: Boolean(isAsking) }, typeof retMessage.jsonData == "string"
            ? retMessage.jsonData
            : `${retMessage?.jsonData?.Dataset}\n\n${retMessage?.jsonData?.Outcome}\n\n${retMessage?.jsonData?.Interactions}\n\n${retMessage?.jsonData?.Charts}`)) : isSQL ? (React.createElement("div", { className: styles.NLQChart, style: { width: "100%" } },
            React.createElement("div", { className: styles.cHolder },
                React.createElement(SqlBarChart, { data: retMessage.data, message: retMessage })))) : isAnalytics ? (React.createElement(DashboardChart, { message: retMessage, index: retMessage.index })) : null)));
};
const Feedback = ({ message, index, updateIsCommenting }) => {
    debug("Render: Feedback");
    const isChatGPT = message.user === "ChatGPT";
    const shouldHaveFeedback = !isEnabled("spark-agents-templates-view") &&
        message.isHideFeedback !== true &&
        message.isEmailApp !== true &&
        message?.askChatGPT_MultipleDatasets === undefined &&
        (isChatGPT || hasOutputContent(message));
    const executionId = message.contentGenerationIds?.[0];
    const execution = useSelector((state) => getChatMessageDetails(state, executionId));
    const userID = useSelector((state) => loginReducer.getUserID(state));
    const dispatch = useDispatch();
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const isNextSaving = useSelector((state) => nextReducer.getIsSavingReport(state, nextId));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const chatTone = useSelector((state) => chatGPTReducer.getChatTone(state));
    const autoAddFewShot = useSelector((state) => nextReducer.getAutoAddFewShot(state, nextId));
    const hideFeedbackDatasetPopup = useSelector((state) => chatGPTReducer.getHideFeedbackDatasetPopup(state));
    const currentArtifact = useSelector((state) => nextReducer.getCurrentArtifact(state, nextId));
    const hasFewShot = useSelector((state) => nextReducer.checkMessageForFewShot(state, nextId, index));
    // Checks and state for showing the feedback/retry when user does not have reasoning or response had no reasoning chunks.
    const result = execution?.results.find((r) => r.id === message.response_data?.result_id);
    const chunks = getSplitMessageOutputContentFromMessage(message, result, userID);
    const noReasoningChunks = !chunks?.some((c) => isReasoningStep(c));
    const isThinkingOff = !isEnabled("chat-reason") || noReasoningChunks;
    const updateConversationFeedback = (conversationIndex, feedbackType) => dispatch(chatGPTReducer.updateConversationFeedback(conversationIndex, feedbackType));
    if (!shouldHaveFeedback || executionId === undefined) {
        return React.createElement(React.Fragment, null);
    }
    const disableFeedback = isAsking || isNextSaving;
    const retJsonData = message.jsonData;
    return (React.createElement(React.Fragment, null,
        React.createElement(RatingInput, { type: "CONTENT_GENERATION_EXECUTION", value: execution ?? {
                id: Number(executionId),
                dislike_count: 0,
                like_count: 0,
                feedback: "NONE"
            }, isDisabled: disableFeedback, disallowedFeedback: message?.isError ? ["LIKE"] : [], afterUpdate: (feedback) => dispatch(fetchChatMessageDetails(executionId)).then((updated) => {
                const latestResult = updated.results[updated.results.length - 1];
                if (feedback == "DISLIKE") {
                    updateConversationFeedback(index, "THUMBS_DOWN");
                    // Updates the show component state for adding feedback to retry question with thinking off/no reasoning step.
                    if (isThinkingOff && updateIsCommenting !== undefined) {
                        updateIsCommenting(true);
                    }
                }
                if (feedback != "LIKE" || latestResult === undefined) {
                    return;
                }
                const userPrompt = updated.request?.display_messages
                    ?.map((v) => v.content)
                    .filter((c) => typeof c === "string")
                    .join(" ") ??
                    latestResult.data.input.messages
                        .filter((m) => m.role == "user")
                        .map((m) => m.content)
                        .filter((c) => typeof c === "string")
                        .join(" ");
                const fineTuneData = {
                    input_text: userPrompt,
                    output_text: latestResult.data.output.content,
                    feedback_score: 1,
                    message: message
                };
                updateConversationFeedback(index, "THUMBS_UP");
                if (currentArtifact?.id ||
                    hideFeedbackDatasetPopup ||
                    !isEnabled("model-fine-tuning") ||
                    (isEnabled("model-fine-tuning") && isEnabled("create-training-data-from-use-case"))) {
                    // Used to add the thumbs up here, but we always want that thumbs up in conversation
                }
                else {
                    dispatch(chatGPTReducer.updateFeedbackData({
                        index: index,
                        type: "THUMBS_UP",
                        data: fineTuneData
                    }));
                    dispatch(chatGPTReducer.updateShowFeedbackDatasetPopup(true));
                }
                if (autoAddFewShot) {
                    dispatch(nextReducer.addFewShotExample(nextId, {
                        prompt: userPrompt,
                        response: fineTuneData.output_text,
                        data_json_object: retJsonData,
                        output_text: fineTuneData.output_text,
                        chat_tone: chatTone
                    }));
                }
            }) })));
};
const rgb2hex = (rgb) => {
    const m = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return m && m.length === 4
        ? "#" +
            ("0" + parseInt(m[1], 10).toString(16)).slice(-2) +
            ("0" + parseInt(m[2], 10).toString(16)).slice(-2) +
            ("0" + parseInt(m[3], 10).toString(16)).slice(-2)
        : "";
};
const EditChartModal = ({ editChart, updateEditChart }) => {
    debug("Render: EditChartModal");
    const dispatch = useDispatch();
    const conversation = useSelector((state) => chatGPTReducer.getConversation(state));
    const updateMessage = (cKey, message) => dispatch(chatGPTReducer.updateMessage(cKey, message));
    const [isShowCode, updateIsShowCode] = useState(false);
    const retMessage = {
        ...conversation?.[editChart?.index],
        isEditChart: false
    };
    const chart_sizes = [
        { label: "Hero", value: "Hero" },
        { label: "Medium", value: "Medium" },
        { label: "Thumbnail", value: "Thumbnail" }
    ];
    const chart_types = [
        { label: "Bar", value: "Bar" },
        { label: "Number", value: "Number" },
        { label: "Line", value: "Line" },
        { label: "Pie", value: "Pie" }
    ];
    const DEFAULT_CHART_SIZE = chart_sizes[1];
    const retColors = retMessage?.chartColors ?? nextReducer.colors;
    return (React.createElement(Dialog, { open: editChart !== undefined, onOpenChange: () => updateEditChart(undefined) },
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Would you like to edit this chart?")),
            React.createElement("div", { className: styles.chartModals },
                React.createElement("div", { className: styles.chartModalLeft },
                    retMessage?.chatType !== "AIBLE" && (React.createElement("div", { className: styles.createEmailUserInput },
                        React.createElement("div", null, "Chart Title"),
                        React.createElement(LineInput, { onChange: (val) => updateMessage(editChart?.index, {
                                ...retMessage,
                                chart_title: val
                            }), defaultValue: editChart?.chart_title ?? conversation?.[retMessage?.questionIndex ?? -1]?.userText }))),
                    retMessage?.chatType !== "DOCUMENT" && (retMessage?.data?.length ?? 0) > 0 && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.chartModalHolder },
                            React.createElement(SqlBarChart, { data: retMessage.data, message: retMessage, isEditChart: true })),
                        React.createElement("div", { className: styles.createEmailUserInput },
                            React.createElement(Button, { onClick: () => updateIsShowCode(!isShowCode), style: {
                                    marginTop: "36px"
                                } }, isShowCode ? "Hide Code" : "Show Code"),
                            isShowCode && React.createElement("div", { className: styles.sqlCode }, retMessage?.sqlQuery))))),
                React.createElement("div", { className: styles.chartModalRight },
                    retMessage?.blueprintId !== "CHATAIBLE_DOCUMENT_SUMMARIZATION" && (React.createElement("div", { className: styles.createEmailUserInput },
                        React.createElement("div", null, "Chart Type"),
                        React.createElement(Select, { options: chart_types, onChange: selectOnChangeWrapper((val) => updateMessage(editChart?.index, {
                                ...retMessage,
                                chart_type: val
                            })), value: chart_types.find((c) => c.value === retMessage?.chart_type) ?? chart_types?.[0], styles: {
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 4
                                })
                            } }))),
                    React.createElement("div", { className: styles.createEmailUserInput },
                        React.createElement("div", null, "Chart Size"),
                        React.createElement(Select, { options: chart_sizes, onChange: selectOnChangeWrapper((val) => updateMessage(editChart?.index, {
                                ...retMessage,
                                chart_size: val
                            })), value: chart_sizes.find((c) => c.value === retMessage?.chart_size) ?? DEFAULT_CHART_SIZE, styles: {
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 4
                                })
                            } })),
                    retMessage?.chatType !== "DOCUMENT" && (retMessage?.data?.length ?? 0) > 0 && (React.createElement("div", { className: styles.createEmailUserInput },
                        React.createElement("div", null, "Chart Colors"),
                        React.createElement("div", { className: styles.chartColors }, keysOf(retColors).map((cKey, colorIndex) => {
                            const color = retColors[cKey];
                            return (React.createElement("div", { key: cKey, className: styles.chartColor },
                                "Color " + colorIndex + ": ",
                                React.createElement(HexColorPicker, { color: color.indexOf("rgba") !== -1 ? rgb2hex(color) : color, onChange: (val) => {
                                        updateMessage(editChart?.index, {
                                            ...retMessage,
                                            chartColors: {
                                                ...retColors,
                                                [colorIndex]: val
                                            }
                                        });
                                    } })));
                        })))))),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { type: "secondary", onClick: () => {
                        updateMessage(editChart?.index, {
                            ...editChart
                        });
                        updateEditChart(undefined);
                    }, style: {
                        marginRight: "7px"
                    } }, "Cancel"),
                React.createElement(Button, { type: "Primary", onClick: () => updateEditChart(undefined) }, "Save")))));
};
const DashboardChart = ({ message, index, style }) => {
    const m = message;
    const i = index ?? message?.index;
    debug("Render: SQLMessageItem");
    const dispatch = useDispatch();
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const isHover = useSelector((state) => chatGPTReducer.getHoverChart(state).isHover);
    const nChartIndex = useSelector((state) => chatGPTReducer.getNChartIndex(state));
    const messageCharts = useSelector((state) => chatGPTReducer.getChartsFromMessageObj(state, message));
    return (React.createElement("div", { className: styles.NLQChart, style: { width: "100%", ...style } },
        React.createElement("div", { className: styles.cHolder },
            React.createElement(NextChartContainer, { id: dataset === undefined ? "DATASET_" + m?.datasetId : nextId, chart: nChartIndex?.[i] === undefined ? messageCharts?.[0] : messageCharts?.[nChartIndex[i]], datasetId: !isNaN(m?.datasetId ?? NaN) && parseInt(m.datasetId?.toString() ?? "") !== dataset?.id
                    ? m.datasetId
                    : undefined, showLeakage: true, showTooltip: true, isHideNarrative: true, isShowMore: true, isChatGPT: true, highlightProps: isHover !== undefined && isAnalyticsReferenceValueChart(isHover)
                    ? getAnalyticsReferenceChartValue(isHover)
                    : undefined })),
        React.createElement("div", { className: styles.chartPager },
            React.createElement(Button, { style: { padding: "3px", marginRight: "3px" }, disabled: (nChartIndex?.[i] ?? 0) - 1 < 0, onClick: () => dispatch(chatGPTReducer.updateNChartIndex({
                    ...nChartIndex,
                    [i]: (nChartIndex?.[i] ?? 0) - 1
                })) },
                React.createElement(FontAwesomeIcon, { icon: faChevronLeft })),
            (nChartIndex?.[i] ?? 0) + 1 + " / " + messageCharts?.length,
            React.createElement(Button, { style: { padding: "3px", marginLeft: "3px" }, disabled: (nChartIndex?.[i] ?? 0) + 1 >= messageCharts?.length, onClick: () => dispatch(chatGPTReducer.updateNChartIndex({
                    ...nChartIndex,
                    [i]: (nChartIndex?.[i] ?? 0) + 1
                })) },
                React.createElement(FontAwesomeIcon, { icon: faChevronRight })))));
};
const SQLMessageItem = ({ message, index, hidePrompt, updateHidePrompt, updateEditChart }) => {
    const m = message;
    const i = index;
    debug("Render: SQLMessageItem");
    const dispatch = useDispatch();
    const conversation = useSelector((state) => chatGPTReducer.getConversation(state));
    const isSmallScreen = useSelector((state) => viewReducer.getIsSmallScreen(state));
    const messageCharts = useSelector((state) => chatGPTReducer.getChartsFromMessageObj(state, message));
    const hasNoData = m?.data?.length === 0 || m?.data === undefined;
    console.log("what is m", m);
    const retChartSize = m?.chart_size ?? "Medium";
    const messageText = m?.text ?? m?.userText;
    const thinkingRegex = /(<think>(.|\n)*?<\/think>)/g;
    const thinkStrippedMessageText = messageText?.replace(thinkingRegex, "");
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const conversationArray = useSelector((state) => chatGPTReducer.getConversationArrayWithoutIndex(state));
    const [hasAskedQuestion, updateHasAskedQuestion] = useState(false);
    useEffect(() => {
        if (isAsking && !hasAskedQuestion) {
            updateHasAskedQuestion(true);
        }
    }, [isAsking]);
    const simulateStreamNewMessage = isEnabled("chat-streaming-responses") &&
        hasAskedQuestion &&
        message?.index === conversationArray?.length - 1 &&
        !message?.isQuestion &&
        !message.content_references;
    return m?.isHidden === true ? (React.createElement("div", null)) : messageCharts === undefined || messageCharts?.length === 0 ? (React.createElement("div", { className: retChartSize === "Hero"
            ? styles.NLQTileHero
            : retChartSize === "Medium"
                ? styles.NLQTileMedium
                : retChartSize === "Thumbnail"
                    ? styles.NLQTileThumbnail
                    : styles.NLQTileMedium },
        React.createElement("div", { className: retChartSize === "Thumbnail" || retChartSize === "Medium" ? styles.chartActionsThumbnail : styles.chartActions },
            React.createElement("div", { className: styles.chartActionsWrapper },
                React.createElement(Feedback, { message: m, index: m?.index }),
                React.createElement(Button, { style: isSmallScreen ? { padding: "4px 8px", marginRight: "4px" } : { padding: "3px", marginRight: "3px" }, disabled: i - 1 < 0, onClick: () => dispatch(chatGPTReducer.updateOrder(i, "UP")) },
                    React.createElement(FontAwesomeIcon, { icon: faChevronUp })),
                React.createElement(Button, { style: isSmallScreen ? { padding: "4px 8px", marginRight: "4px" } : { padding: "3px" }, disabled: i + 1 > Object.keys(conversation).length, onClick: () => dispatch(chatGPTReducer.updateOrder(i, "DOWN")) },
                    React.createElement(FontAwesomeIcon, { icon: faChevronDown })),
                React.createElement(Button, { style: { padding: "3px", marginLeft: "5px", minWidth: "48px" }, onClick: () => {
                        keysOf(conversation).forEach((c) => {
                            if (conversation[c]?.questionIndex === m?.questionIndex) {
                                dispatch(chatGPTReducer.updateMessage(c, {
                                    ...conversation[c],
                                    isHidden: true
                                }));
                            }
                        });
                    } }, "Hide"),
                React.createElement(Button, { style: { padding: "3px", marginLeft: "5px", minWidth: "48px" }, onClick: () => updateEditChart(m), className: styles.chartEditButton }, "Edit"),
                m?.chatType !== "DOCUMENT" && (React.createElement(Button, { style: { padding: "3px", marginLeft: "5px" }, onClick: () => updateHidePrompt(!hidePrompt), disabled: hasNoData }, !hidePrompt ? "Hide Summary" : "View Summary")))),
        m?.chatType !== "DOCUMENT" && m?.chatType !== "CHAT" && hidePrompt && m?.mType !== "AIBLE_ANYWHERE" ? (React.createElement("div", null)) : (React.createElement("div", { className: m?.chatType === "DOCUMENT" || hasNoData ? styles.NLQTileLeftFull : styles.NLQTileLeft },
            m?.prediction_table !== undefined || m?.buttonActions !== undefined ? (React.createElement("div", null)) : (React.createElement("div", { className: styles.NLQChartPrompt },
                React.createElement("div", { className: retChartSize === "Thumbnail" || retChartSize === "Medium"
                        ? styles.NLQUserQuestionThumbnail
                        : styles.NLQUserQuestion }, m?.userPrompt ?? m?.userPrompt_Force))),
            m?.prediction_table !== undefined || m?.buttonActions !== undefined ? (React.createElement("div", null,
                message?.title && (React.createElement("div", { className: styles.NLQChartPrompt },
                    React.createElement("div", { className: styles.aaSuccess }, message?.title))),
                message?.successMessage && (React.createElement("div", { className: styles.aaSuccess, style: { marginBottom: "20px" } }, message?.successMessage)),
                message?.buttonActions && (React.createElement("div", { className: styles.aaButtonActions }, message.buttonActions.map((ba) => (React.createElement(Button, { style: { marginRight: "10px" } }, ba?.Text))))),
                message?.prediction_table && React.createElement(PredictionTable, { message: message }))) : !hasOutputContent(m) ? (React.createElement("div", null,
                React.createElement(MarkdownPanel, null, thinkStrippedMessageText))) : (React.createElement("div", { className: simulateStreamNewMessage
                    ? `${styles.NLQChartResponse} ${styles.simulateStreamingMessage}`
                    : styles.NLQChartResponse },
                React.createElement(ResponseWithIds, { message: m, index: i, hideThinkingSteps: true, renderChunksAsStreaming: simulateStreamNewMessage }))))),
        m?.chatType === "DOCUMENT" || hasNoData ? (React.createElement("div", null)) : (React.createElement("div", { className: styles.NLQChart, style: hidePrompt ? { width: "100%" } : {} },
            React.createElement("div", { className: !hidePrompt
                    ? styles.nlqHiddenPromptSpacer
                    : retChartSize === "Thumbnail" || retChartSize === "Medium"
                        ? styles.nlqChartTitleThumbnail
                        : styles.nlqChartTitle }, hidePrompt && (m?.chart_title ?? m?.userPrompt)),
            React.createElement("div", { className: styles.cHolder },
                React.createElement(SqlBarChart, { data: m.data, message: m })))))) : (React.createElement("div", { className: retChartSize === "Hero"
            ? styles.NLQTileHero
            : retChartSize === "Medium"
                ? styles.NLQTileMedium
                : retChartSize === "Thumbnail"
                    ? styles.NLQTileThumbnail
                    : styles.NLQTile },
        React.createElement("div", { className: retChartSize === "Thumbnail" || retChartSize === "Medium" ? styles.chartActionsThumbnail : styles.chartActions },
            React.createElement("div", { className: styles.chartActionsWrapper },
                React.createElement(Feedback, { message: m, index: m?.index }),
                React.createElement(Button, { style: isSmallScreen ? { padding: "4px 8px", marginRight: "4px" } : { padding: "3px", marginRight: "3px" }, disabled: i - 1 < 0, onClick: () => dispatch(chatGPTReducer.updateOrder(i, "UP")) },
                    React.createElement(FontAwesomeIcon, { icon: faChevronUp })),
                React.createElement(Button, { style: isSmallScreen ? { padding: "4px 8px", marginRight: "4px" } : { padding: "3px" }, disabled: i + 1 > keysOf(conversation).length, onClick: () => dispatch(chatGPTReducer.updateOrder(i, "DOWN")) },
                    React.createElement(FontAwesomeIcon, { icon: faChevronDown })),
                React.createElement(Button, { style: { padding: "3px", marginLeft: "5px", minWidth: "48px" }, onClick: () => {
                        keysOf(conversation).forEach((c) => {
                            if (conversation[c]?.questionIndex === m?.questionIndex) {
                                dispatch(chatGPTReducer.updateMessage(c, {
                                    ...conversation[c],
                                    isHidden: true
                                }));
                            }
                        });
                    } }, "Hide"),
                React.createElement(Button, { style: { padding: "3px", marginLeft: "5px", minWidth: "48px" }, onClick: () => updateEditChart(m), className: styles.chartEditButton }, "Edit"),
                React.createElement(Button, { style: { padding: "3px", marginLeft: "5px" }, onClick: () => updateHidePrompt(!hidePrompt) }, !hidePrompt ? "Hide Summary" : "View Summary"))),
        hidePrompt ? (React.createElement("div", null)) : (React.createElement("div", { className: styles.NLQTileLeft },
            React.createElement("div", { className: styles.NLQChartPrompt },
                React.createElement("div", { className: retChartSize === "Thumbnail" || retChartSize === "Medium"
                        ? styles.NLQUserQuestionThumbnail
                        : styles.NLQUserQuestion }, m?.userPrompt
                    ? m?.userPrompt
                    : !isNaN(m?.datasetId ?? NaN) && m?.outcome
                        ? `What are the top factors impacting ${m?.outcome} of this dataset`
                        : `What are the top factors impacting the outcome in this dataset`)),
            React.createElement("div", { className: styles.NLQChartResponse },
                React.createElement(ResponseWithIds, { message: m, index: i, hideThinkingSteps: true })))),
        React.createElement("div", { className: styles.nlqChartWrapper, style: hidePrompt ? { width: "100%" } : { width: "60%" } },
            hidePrompt && (React.createElement("div", { className: styles.hiddenSummaryPrompt }, m?.userPrompt
                ? m?.userPrompt
                : !isNaN(m?.datasetId ?? NaN) && m?.outcome
                    ? `What are the top factors impacting ${m?.outcome} of this dataset`
                    : `What are the top factors impacting the outcome in this dataset`)),
            React.createElement(DashboardChart, { message: m, index: i, style: { width: "100%", height: "calc(100% - 20px)" } }))));
};
const FileUploadMessage = ({ message }) => {
    const dispatch = useDispatch();
    const agentId = useSelector((state) => chatGPTReducer.getAgentId(state));
    const agent = useSelector((state) => aibleAnywhereReducer.getAibleAnywhere(state, agentId));
    const prompt = useSelector((state) => chatGPTReducer.getPrompt(state));
    const artifacts = useSelector((state) => languagageModelArtifactReducer.getArtifactList(state, "CORPUS"));
    const [uploadedArtifactId, updateUploadedArtifactId] = useState(undefined);
    const uArtifact = artifacts.find((a) => uploadedArtifactId !== undefined && a.id === uploadedArtifactId);
    return (React.createElement("div", null, uArtifact !== undefined ? (React.createElement("div", null, "Uploaded File: " + uArtifact?.name)) : (React.createElement(UploadDocument, { onComplete: (artifact) => {
            if (artifact?.id) {
                dispatch(chatGPTReducer.addArtifactIdStep(artifact?.id, message?.stepIndex));
                updateUploadedArtifactId(artifact?.id);
                dispatch(chatGPTReducer.handleAibleAnywhereSteps(agent, prompt, message?.stepIndex - 1));
            }
        } }))));
};
const FileAttachMessage = ({ message, index }) => {
    const dispatch = useDispatch();
    const agentId = useSelector((state) => chatGPTReducer.getAgentId(state));
    const agent = useSelector((state) => aibleAnywhereReducer.getAibleAnywhere(state, agentId));
    const prompt = useSelector((state) => chatGPTReducer.getPrompt(state));
    return (React.createElement("div", null, message?.attachedFileName !== undefined ? (React.createElement("div", null, "Attached File: " + message?.attachedFileName)) : (React.createElement("div", null,
        "Please select a file to attach.",
        React.createElement(AttachFile, { onComplete: (fileName) => {
                if (fileName !== undefined && index !== undefined) {
                    dispatch(chatGPTReducer.updateMessage(index, { ...message, attachedFileName: fileName }));
                    dispatch(chatGPTReducer.handleAibleAnywhereSteps(agent, prompt, message?.stepIndex - 1));
                }
            } })))));
};
const AgentIQPredictionTable = ({ message }) => {
    const cleanedData = (message?.agentiq_prediction ?? [])
        .sort((a, b) => b.score - a.score)
        .map((item) => {
        const { score, threshold, ...rest } = item;
        const cleanedFields = Object.entries(rest)
            .filter(([key]) => key !== "predict_score" &&
            key !== "model_name" &&
            key !== "predict" &&
            key !== "row_level_prediction_driver_json")
            .reduce((acc, [key, value]) => {
            acc[key] = String(value);
            return acc;
        }, {});
        return {
            fields: cleanedFields,
            score,
            threshold
        };
    });
    return (React.createElement("div", { className: styles.scoreTable },
        React.createElement("div", { className: styles.scoreTableHeader },
            React.createElement("div", { className: styles.columnFields }, "Fields"),
            React.createElement("div", { className: styles.columnScore }, "Score")),
        cleanedData.map((item, index) => {
            const fieldValues = Object.entries(item.fields)
                .map(([key, value]) => `${key}: ${value}`)
                .join(", ");
            const scorePercent = item.score * 100;
            const thresholdPercent = item.threshold * 100;
            const barColor = item.score >= item.threshold ? "rgb(123 203 126 / 100%)" : "rgb(158 31 20 / 100%)";
            return (React.createElement(Tooltip, { key: "score_table" + index, trigger: ["hover"], overlay: React.createElement("div", null,
                    React.createElement("div", null, fieldValues),
                    React.createElement("div", null, `Score: ${item.score}`),
                    React.createElement("div", null, `Threshold: ${item.threshold}`)) },
                React.createElement("div", { className: styles.scoreTableRow, key: index },
                    React.createElement("div", { className: styles.columnFields },
                        React.createElement("div", { className: styles.fieldNames }, fieldValues)),
                    React.createElement("div", { className: styles.columnScore },
                        React.createElement("div", { className: styles.scoreBarContainer },
                            React.createElement("div", { className: styles.scoreBarFill, style: {
                                    width: `${scorePercent}%`,
                                    backgroundColor: barColor
                                } }),
                            React.createElement("div", { className: styles.thresholdTick, style: { left: `${thresholdPercent}%` } }))))));
        })));
};
const PredictionTable = ({ message }) => {
    const project = useSelector((state) => projectReducer.getProject(state, message?.projectId));
    const forcePrediction = message?.prediction_table.map((pt) => message?.minMaxField === undefined
        ? {
            probability: Number(pt.score) * 100,
            value: pt[Object.keys(pt).filter((k) => k != "score")?.[0]],
            field: Object.keys(pt).filter((k) => k != "score")?.[0],
            otherFields: Object.keys(pt)
                .filter((k) => k != "score")
                .map((k) => ({ field: k, value: pt[k] }))
        }
        : {
            probability: Number(pt.score) * 100,
            value: pt[message?.minMaxField],
            field: message?.minMaxField,
            otherFields: Object.keys(pt)
                .filter((k) => k != "score" && k != message?.minMaxField)
                .map((k) => ({ field: k, value: pt[k] }))
        });
    let highest = undefined;
    let highestScore = -Infinity;
    forcePrediction.forEach((item) => {
        const score = parseFloat(item.probability);
        if (score > highestScore) {
            highestScore = score;
            highest = item;
        }
    });
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.aaSuccess }, message?.minMaxField === undefined
            ? highest?.value
            : "The best " + message?.minMaxField + " is " + highest?.value),
        React.createElement(FeatureChartContainer, { id: project?.settings?.innerId, label: "Select to see more information about each variable", isResults: true, predictMode: "predict", projectId: message?.projectId, isChat: true, forcePrediction: forcePrediction })));
};
const NLQDashboard = ({ tryChatTemplate }) => {
    debug("Render: NLQDashboard");
    const dispatch = useDispatch();
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const conversation = useSelector((state) => chatGPTReducer.getConversation(state));
    const uiState = useSelector((state) => globalReducer.getUiState(state));
    const isHover = useSelector((state) => chatGPTReducer.getHoverChart(state).isHover);
    const [hidePrompt, updateHidePrompt] = useState(true);
    const [editChart, updateEditChart] = useState(undefined);
    const sqlMessages = useSelector((state) => chatGPTReducer.getSqlMessages(state));
    const hasHidden = keysOf(conversation)?.find((c) => conversation[c]?.isHidden === true);
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const customBackgroundColor = location &&
        location.pathname &&
        (location.pathname.indexOf("next") !== -1 || location.pathname.indexOf("chatTemplate") !== -1) &&
        chatApp?.wizard?.backgroundColor !== undefined &&
        chatApp?.wizard?.backgroundColor !== ""
        ? chatApp?.wizard.backgroundColor
        : undefined;
    const isShareLink = uiState?.type === "SHARE_LINK";
    console.log("what is sqlMessages", sqlMessages);
    return (React.createElement("div", { className: styles.NLQDashboard, style: {
            backgroundColor: customBackgroundColor
        } },
        React.createElement(EditChartModal, { editChart: editChart, updateEditChart: updateEditChart }),
        React.createElement(Footer, { tryChatTemplate: tryChatTemplate, nlqDashFooter: true }),
        hasHidden !== undefined && (React.createElement("div", { className: styles.hiddenMessage },
            "Some insights have been hidden.",
            React.createElement(Button, { onClick: () => {
                    keysOf(conversation).forEach((c) => {
                        if (conversation[c]?.isHidden === true) {
                            dispatch(chatGPTReducer.updateMessage(c, {
                                ...conversation[c],
                                isHidden: false
                            }));
                        }
                    });
                }, style: { padding: "3px", marginLeft: "5px" } }, "Show all insights"))),
        React.createElement("div", { className: styles.NLQCharts, id: "nlqDash_scroll_real" },
            sqlMessages?.map((m, i) => (React.createElement(SQLMessageItem, { key: i, message: m, index: i, hidePrompt: hidePrompt, updateHidePrompt: updateHidePrompt, updateEditChart: updateEditChart }))),
            sqlMessages?.length < 1 && (React.createElement("div", { className: styles.noChartsWarningWrapper },
                React.createElement("div", { className: styles.noChartsWarning },
                    React.createElement("div", { className: styles.noChartsWarningTitle }, "Hello!"),
                    React.createElement("div", { className: styles.noChartsWarningMessage }, conversation?.[0]?.userText ?? "Please ask questions below to create your dashboard")))),
            isHover !== undefined && !isDocumentReference(isHover) && React.createElement(HoverItem, { listItem: isHover }),
            React.createElement("div", { className: styles.nlqDashboardSpacer })),
        isEnabled("model-fine-tuning") && !isShareLink && React.createElement(FeedbackDatasetPopup, { nextId: nextId })));
};
const CreateEmailUserModal = () => {
    debug("Render: CreateEmailUserModal");
    const dispatch = useDispatch();
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const chatButtonDarkMode = useSelector((state) => chatGPTReducer.getChatButtonDarkMode(state));
    const linkColorDarkMode = useSelector((state) => chatGPTReducer.getLinkColorDarkMode(state));
    const emailUser = useSelector((state) => chatGPTReducer.getEmailUser(state));
    const [name, updateName] = useState("");
    const [email, updateEmail] = useState("");
    const [phoneNumber, updatePhoneNumber] = useState("");
    const chatButtonDarkColor = "#1F181C";
    const linkColorDarkColor = "#1F181C";
    return (React.createElement(Dialog, { open: emailUser?.value === "CREATE_NEW", onOpenChange: () => dispatch(chatGPTReducer.updateEmailUser(undefined)) },
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Add New Person")),
            React.createElement("div", { className: styles.createEmailUserInput },
                React.createElement("div", null, "Name"),
                React.createElement(LineInput, { value: name, onChange: updateName })),
            React.createElement("div", { className: styles.createEmailUserInput },
                React.createElement("div", null, "Email"),
                React.createElement(LineInput, { value: email, onChange: updateEmail })),
            React.createElement("div", { className: styles.createEmailUserInput },
                React.createElement("div", null, "Phone Number"),
                React.createElement(LineInput, { value: phoneNumber, onChange: updatePhoneNumber })),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { type: "secondary", onClick: () => dispatch(chatGPTReducer.updateEmailUser(undefined)), style: {
                        color: linkColorDarkMode
                            ? linkColorDarkColor
                            : chatApp?.wizard?.linkColor !== undefined
                                ? "#FFFFFF"
                                : "#7E69D7",
                        ...(chatApp?.wizard?.linkColor !== undefined
                            ? {
                                background: chatApp?.wizard?.linkColor,
                                borderColor: chatApp?.wizard?.linkColor
                            }
                            : {})
                    } }, "Cancel"),
                React.createElement(Button, { type: "Primary", onClick: () => {
                        const localEmailUsers = localStorage.getItem("chat_email_users") === null ||
                            localStorage.getItem("chat_email_users") === undefined
                            ? []
                            : JSON.parse(localStorage.getItem("chat_email_users") ?? "[]");
                        const retEmailUser = {
                            name: name,
                            email: email,
                            number: phoneNumber
                        };
                        const retEmailUsers = [retEmailUser, ...localEmailUsers];
                        localStorage.setItem("chat_email_users", JSON.stringify(retEmailUsers));
                        dispatch(chatGPTReducer.updateEmailUser({
                            label: retEmailUser?.name,
                            value: retEmailUser?.name,
                            email_user: retEmailUser
                        }));
                    }, style: {
                        color: chatButtonDarkMode ? chatButtonDarkColor : "",
                        ...(chatApp?.wizard?.chatButtonColor !== undefined
                            ? {
                                background: chatApp?.wizard?.chatButtonColor,
                                borderColor: chatApp?.wizard?.chatButtonColor
                            }
                            : {})
                    } }, "Create")))));
};
const MultiDataModal = ({ isMultiDataModal, updateIsMultiDataModal }) => {
    debug("Render: MultiDataModal");
    const conversation = useSelector((state) => chatGPTReducer.getConversation(state));
    const multiDatasets_Options = useSelector((state) => chatGPTReducer.getMultiDatasets_Options(state));
    const message = multiDatasets_Options !== undefined
        ? {
            askChatGPT_MultipleDatasets: multiDatasets_Options.datasets,
            askChatGPT_MultipleDocuments: multiDatasets_Options.documents,
            user_prompt: multiDatasets_Options.userPrompt
        }
        : conversation?.[keysOf(conversation).filter((c) => conversation[c].askChatGPT_MultipleDatasets !== undefined)?.[0]];
    return (React.createElement(Dialog, { open: isMultiDataModal, onOpenChange: () => updateIsMultiDataModal(false) },
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Multiple Data Selection")),
            React.createElement("div", { className: styles.multiDataModalBody },
                React.createElement(AskMultipleDatasets, { message: message, updateIsMultiDataModal: updateIsMultiDataModal, isModal: true })))));
};
const RightPanelHoverItem = () => {
    debug("Render: RightPanelHoverItem");
    const isHover = useSelector((state) => chatGPTReducer.getHoverChart(state).isHover);
    const hoverMessage = useSelector((state) => chatGPTReducer.getHoverChart(state).message);
    if (isHover === undefined) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement(HoverItem, { message: hoverMessage, listItem: isHover });
};
const ChatGPT = ({ isSenseMode, isNoDataset, tryChatTemplate, skipNextLoading, hideFooter, hideRightPanel, hideAutonomyControls, hideDetailsPanel, style, safeClawOptimize, isAssistantAgent }) => {
    const dispatch = useDispatch();
    console.log("BIG RE-RENDER");
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const activeTab = useSelector((state) => nextReducer.getActiveTab(state, nextId));
    const isNextLoading = useSelector((state) => globalReducer.getIsNextLoading(state));
    const isShowPowerBISettings = useSelector((state) => chatGPTReducer.getIsShowPowerBISettings(state));
    const isPowerBIExport = useSelector((state) => chatGPTReducer.getIsPowerBIExport(state));
    const [isMultiDataModal, updateIsMultiDataModal] = useState(false);
    const isLookerMode = window?.looker_API !== undefined;
    const activeCapability = useSelector((state) => tagsReducer.getActiveCapability(state));
    const capabilityTimerId = useSelector((state) => tagsReducer.getCapabilityTimerId(state));
    //Reset active capability on component cleanup
    useEffect(() => {
        return () => {
            if (capabilityTimerId) {
                clearTimeout(capabilityTimerId);
                dispatch(tagsReducer.updateCapabilityTimerId(undefined));
            }
            if (activeCapability !== undefined) {
                dispatch(tagsReducer.updateActiveCapability(undefined));
            }
        };
    }, []);
    let retStyle = tryChatTemplate
        ? {
            height: "calc(100% - 48px)"
        }
        : isLookerMode
            ? {
                width: "100%",
                marginTop: "0px",
                height: "calc(100vh - 60px)",
                borderLeft: "1px solid rgba(0, 0, 0, 0.5)"
            }
            : {};
    retStyle = {
        ...retStyle,
        ...(style || {})
    };
    if (isNextLoading && skipNextLoading !== true) {
        return (React.createElement("div", { className: isNoDataset ? styles.chatGPTHolderNoDataset : styles.chatGPTHolder, style: retStyle },
            React.createElement(LoadingIndicator, null)));
    }
    return activeTab === "NLQ Dashboard" && !tryChatTemplate ? (React.createElement(NLQDashboard, { tryChatTemplate: tryChatTemplate })) : (React.createElement("div", { className: styles.chatGPTHolder, style: retStyle },
        React.createElement("div", { id: "reportHolder", style: isPowerBIExport ? { width: "100vw", height: "100vh", display: "none" } : {} }),
        isShowPowerBISettings ? (React.createElement(PowerBISettings, null)) : (React.createElement(ChatInterface, { isNoDataset: isNoDataset, isSenseMode: isSenseMode, tryChatTemplate: tryChatTemplate, hideFooter: hideFooter, hideAutonomyControls: hideAutonomyControls, hideDetailsPanel: hideDetailsPanel, safeClawOptimize: safeClawOptimize, isAssistantAgent: isAssistantAgent })),
        React.createElement(RightPanelHoverItem, null),
        hideRightPanel || isLookerMode ? React.createElement("div", null) : React.createElement(RightPanel, null),
        React.createElement(CreateEmailUserModal, null),
        React.createElement(MultiDataModal, { isMultiDataModal: isMultiDataModal, updateIsMultiDataModal: updateIsMultiDataModal }),
        React.createElement(ChatExportModal, null)));
};
const TableauExportButtonContainer = () => {
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const recentCharts = []; // useSelector((state) => chatGPTReducer.getMostRecentChartsFromMessages(state)) ?? [];
    if (dataset === undefined) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement(TableauExportButton, { dataset: dataset, recentCharts: recentCharts });
};
class TableauExportButton extends React.Component {
    addSecondOrderToWorksheet(worksheetNode, chart, sheetIndex) {
        const random_uuid = sheetIndex < 10 ? "0" + sheetIndex : sheetIndex % 100;
        const mColumn = chart?.chart?.xAxis?.label;
        const oColumn = chart?.metadata?.properties?.find((p) => p.column !== mColumn);
        const oColumnColumn = isColumn(oColumn) && oColumn?.column === "SubCategory" ? "Sub-Category" : oColumn?.column;
        const mColumnColumn = mColumn === "SubCategory" ? "Sub-Category" : mColumn;
        const min = oColumn !== undefined && "start" in oColumn ? oColumn?.start : undefined;
        const max = oColumn !== undefined && "start" in oColumn ? oColumn?.end : undefined;
        const value = oColumn !== undefined && "value" in oColumn ? oColumn?.value : undefined;
        console.log("mColumn oColumn", mColumn, oColumn, chart);
        const calcName = "Calculation_12490454496397312" + sheetIndex;
        const tableXMLString = `
      <worksheet name="Sheet ${sheetIndex}">
      <table>
        <view>
          <datasources>
            <datasource caption='Sample - Superstore' name='federated.0i2xvnq1xr8lm1159nv9u1hxcxjc' />
          </datasources>
          <datasource-dependencies datasource='federated.0i2xvnq1xr8lm1159nv9u1hxcxjc'>
            <column caption='` +
            chart?.narrative?.conditionsLabel +
            `' datatype='real' name='[${calcName}]' role='measure' type='quantitative'>
              <calculation class='tableau' formula=` +
            (min !== undefined
                ? `'IF [${oColumnColumn}] &gt; ${min} AND [${oColumnColumn}] &lt; ${max} THEN&#10;    [Profit]&#10;ELSE&#10;    NULL&#10;END'`
                : `'IF [${oColumnColumn}] = ${value} THEN&#10;    [Profit]&#10;ELSE&#10;    NULL&#10;END'`) +
            `/>
            </column>
            <column datatype='string' name='[${mColumnColumn}]' role='dimension' type='nominal' />
            <column datatype='real' name='[Profit]' role='measure' type='quantitative' />
            <column datatype='real' name='[${oColumnColumn}]' role='measure' type='quantitative' />
            <column-instance column='[${calcName}]' derivation='Avg' name='[avg:${calcName}:qk]' pivot='key' type='quantitative' />
            <column-instance column='[Profit]' derivation='Avg' name='[avg:Profit:qk]' pivot='key' type='quantitative' />
            <column-instance column='[${mColumnColumn}]' derivation='None' name='[none:${mColumnColumn}:nk]' pivot='key' type='nominal' />
          </datasource-dependencies>
          <filter class='categorical' column='[federated.0i2xvnq1xr8lm1159nv9u1hxcxjc].[:Measure Names]'>
            <groupfilter function='union'>
              <groupfilter function='member' level='[:Measure Names]' member='&quot;[federated.0i2xvnq1xr8lm1159nv9u1hxcxjc].[avg:Profit:qk]&quot;' />
              <groupfilter function='member' level='[:Measure Names]' member='&quot;[federated.0i2xvnq1xr8lm1159nv9u1hxcxjc].[avg:${calcName}:qk]&quot;' />
            </groupfilter>
          </filter>
          <slices>
            <column>[federated.0i2xvnq1xr8lm1159nv9u1hxcxjc].[:Measure Names]</column>
          </slices>
          <aggregation value='true' />
        </view>
        <style />
        <panes>
          <pane selection-relaxation-option='selection-relaxation-allow'>
            <view>
              <breakdown value='auto' />
            </view>
            <mark class='Automatic' />
            <encodings>
              <color column='[federated.0i2xvnq1xr8lm1159nv9u1hxcxjc].[:Measure Names]' />
            </encodings>
          </pane>
        </panes>
        <rows>[federated.0i2xvnq1xr8lm1159nv9u1hxcxjc].[Multiple Values]</rows>
        <cols>([federated.0i2xvnq1xr8lm1159nv9u1hxcxjc].[none:${mColumnColumn}:nk] / [federated.0i2xvnq1xr8lm1159nv9u1hxcxjc].[:Measure Names])</cols>
          </table>
      <simple-id uuid="{C1DF61BE-4CB1-4308-A31B-D505E2FC${random_uuid}BE}"/>
      </worksheet>
    `;
        const parser = new DOMParser();
        const tableNode = parser.parseFromString(tableXMLString, "application/xml").documentElement;
        worksheetNode.appendChild(tableNode);
    }
    addTableToWorksheet(worksheetNode, columnName, sheetIndex) {
        const random_uuid = sheetIndex < 10 ? "0" + sheetIndex : sheetIndex % 100;
        const retColumnName = columnName === "SubCategory" ? "Sub-Category" : columnName;
        const tableXMLString = `
    <worksheet name="Sheet ${sheetIndex}">
      <table>
        <view>
          <datasources>
            <datasource caption="Sample - Superstore" name="federated.0i2xvnq1xr8lm1159nv9u1hxcxjc"/>
          </datasources>
          <datasource-dependencies datasource="federated.0i2xvnq1xr8lm1159nv9u1hxcxjc">
            <column datatype="string" name="[${retColumnName}]" role="dimension" semantic-role="[${retColumnName}].[Name]" type="nominal"/>
            <column datatype="real" name="[Profit]" role="measure" type="quantitative"/>
            <column-instance column="[Profit]" derivation="Avg" name="[avg:Profit:qk]" pivot="key" type="quantitative"/>
            <column-instance column="[${retColumnName}]" derivation="None" name="[none:${retColumnName}:nk]" pivot="key" type="nominal"/>
          </datasource-dependencies>
          <aggregation value="true"/>
        </view>
        <style/>
        <panes>
          <pane selection-relaxation-option="selection-relaxation-allow">
            <view>
              <breakdown value="auto"/>
            </view>
            <mark class="Automatic"/>
            <encodings>
              <color column="[federated.0i2xvnq1xr8lm1159nv9u1hxcxjc].[none:${retColumnName}:nk]"/>
            </encodings>
          </pane>
        </panes>
        <rows>[federated.0i2xvnq1xr8lm1159nv9u1hxcxjc].[avg:Profit:qk]</rows>
        <cols>[federated.0i2xvnq1xr8lm1159nv9u1hxcxjc].[none:${retColumnName}:nk]</cols>
      </table>
      <simple-id uuid="{C1DF61BE-4CB1-4308-A33B-D525E2FC${random_uuid}BE}"/>
    </worksheet>`;
        const parser = new DOMParser();
        const tableNode = parser.parseFromString(tableXMLString, "application/xml").documentElement;
        worksheetNode.appendChild(tableNode);
    }
    updateXML(xmlString) {
        const { recentCharts } = this.props;
        console.log("what rc", recentCharts);
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlString, "application/xml");
        const worksheetNode = xmlDoc.querySelector("worksheets");
        console.log("what is worksheetNode", worksheetNode);
        while (worksheetNode?.firstChild) {
            worksheetNode.removeChild(worksheetNode.firstChild);
        }
        recentCharts.forEach((rc, i) => {
            if (worksheetNode === null) {
                return;
            }
            else if (rc?.metadata?.properties?.length === 1) {
                this.addTableToWorksheet(worksheetNode, rc?.metadata?.properties?.[0].column, i + 2);
            }
            else {
                this.addSecondOrderToWorksheet(worksheetNode, rc, i + 2);
            }
        });
        const serializer = new XMLSerializer();
        const updatedXmlString = serializer.serializeToString(xmlDoc);
        return updatedXmlString;
    }
    async editXMLInZip(zipFileBlob) {
        const { dataset } = this.props;
        const jsZip = new JSZip();
        // Load the zip file
        const zip = await jsZip.loadAsync(zipFileBlob);
        console.log("what is zip/", zip, jsZip);
        // Extract the XML file you want to edit
        const xmlFileName = "testbook1.twb";
        const xmlFile = await zip.file(xmlFileName)?.async("text");
        if (xmlFile === undefined) {
            return;
        }
        // Edit the XML content (you can use any XML library to parse and modify the content)
        const newXMLContent = this.updateXML(xmlFile);
        // Replace the XML file in the zip archive with the edited content
        zip.file(xmlFileName, newXMLContent);
        // Generate a new zip file with the modified content
        const newZipFile = await zip.generateAsync({ type: "blob" });
        // Now you can save the new zip file using FileSaver or perform any other action you need
        saveAs(newZipFile, dataset?.name + "_Tableau.twbx");
    }
    dataUrlToBlob(dataUrl) {
        console.log("wtf at", dataUrl);
        const binaryString = atob(dataUrl.split(",")[1]);
        const mimeType = dataUrl.split(",")[0].match(/:(.*?);/)?.[1];
        const arrayBuffer = new ArrayBuffer(binaryString.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryString.length; i++) {
            uint8Array[i] = binaryString.charCodeAt(i);
        }
        return new Blob([arrayBuffer], { type: mimeType });
    }
    /*
    TODO: Tableau Export? this Zip file is relatively large so removing it for now
  
    async testGen() {
      const zipFileBlob = this.dataUrlToBlob(zipFileDataUrl);
  
      await this.editXMLInZip(zipFileBlob);
    }
    */
    render() {
        return (React.createElement(Button, { onClick: () => null /*this.testGen() TODO: Tableau Export? this Zip file is relatively large so removing it for now */, isSmall: true, style: {
                whiteSpace: "nowrap",
                marginLeft: "10px"
            } }, "Export to Tableau"));
    }
}
const PowerBIExportButtonContainer = () => {
    const dispatch = useDispatch();
    const context = useContext(MsalContext);
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const recentCharts = []; // useSelector((state) => chatGPTReducer.getMostRecentChartsFromMessages(state)) ?? [];
    const bestCharts = useSelector((state) => nextReducer.getBestCharts(state, nextId, true));
    const updateIsPowerBIExport = (isPowerBIExport) => dispatch(chatGPTReducer.updateIsPowerBIExport(isPowerBIExport));
    if (dataset === undefined) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(PowerBIExportButton, { context: context, dataset: dataset, recentCharts: recentCharts, bestCharts: bestCharts, updateIsPowerBIExport: updateIsPowerBIExport }));
};
class PowerBIExportButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            powerbi_report_id: localStorage.getItem("powerbi_report_id"),
            powerbi_dataset_id: localStorage.getItem("powerbi_dataset_id"),
            powerbi_workspace_id: localStorage.getItem("powerbi_workspace_id"),
            powerbi_client_id: localStorage.getItem("powerbi_client_id"),
            powerReportId: undefined,
            accessToken: "",
            embedUrl: "",
            error: []
        };
    }
    // Authenticating to get the access token
    authenticate() {
        const msalInstance = this.props.context.instance;
        const msalAccounts = this.props.context.accounts;
        const msalInProgress = this.props.context.inProgress;
        const isAuthenticated = this.props.context.accounts.length > 0;
        if (this.state.error.length > 0) {
            return;
        }
        const eventCallback = msalInstance.addEventCallback((message) => {
            if (message.eventType === EventType.LOGIN_SUCCESS && !accessToken) {
                const payload = message.payload;
                accessToken = payload.accessToken;
                this.tryRefreshUserPermissions();
            }
        });
        const loginRequest = {
            scopes: config.scopeBase,
            account: msalAccounts[0]
        };
        if (!isAuthenticated && msalInProgress === InteractionStatus.None) {
            console.log("1");
            msalInstance.loginRedirect(loginRequest);
        }
        else if (isAuthenticated && accessToken && !embedUrl && eventCallback) {
            console.log("2");
            this.getembedUrl();
            msalInstance.removeEventCallback(eventCallback);
        }
        else if (isAuthenticated && !accessToken && !embedUrl && msalInProgress === InteractionStatus.None) {
            console.log("3");
            // get access token silently from cached id-token
            msalInstance
                .acquireTokenSilent(loginRequest)
                .then(async (response) => {
                accessToken = response.accessToken;
                const aToken = await this.getembedUrl();
                console.log("we got aToken?", aToken);
                this.init();
            })
                .catch((error) => {
                // Refresh access token silently from cached id-token
                // Makes the call to handleredirectcallback
                if (error.errorCode === "consent_required" ||
                    error.errorCode === "interaction_required" ||
                    error.errorCode === "login_required") {
                    msalInstance.acquireTokenRedirect(loginRequest);
                }
                else if (error.errorCode === "429") {
                    this.setState({
                        error: ["Our Service Token Server (STS) is overloaded, please try again in sometime"]
                    });
                }
                else {
                    this.setState({
                        error: ["There was some problem fetching the access token" + error.toString()]
                    });
                }
            });
        }
    }
    // Power BI REST API call to refresh User Permissions in Power BI
    // Refreshes user permissions and makes sure the user permissions are fully updated
    // https://docs.microsoft.com/rest/api/power-bi/users/refreshuserpermissions
    tryRefreshUserPermissions() {
        fetch(config.powerBiApiUrl + "v1.0/myorg/RefreshUserPermissions", {
            headers: {
                Authorization: "Bearer " + accessToken
            },
            method: "POST"
        })
            .then(function (response) {
            if (response.ok) {
                console.log("User permissions refreshed successfully.");
            }
            else {
                // Too many requests in one hour will cause the API to fail
                if (response.status === 429) {
                    console.error("Permissions refresh will be available in up to an hour.");
                }
                else {
                    console.error(response);
                }
            }
        })
            .catch(function (error) {
            console.error("Failure in making API call." + error);
        });
    }
    //https://api.powerbi.com/v1.0/myorg/groups/${groupId}/reports/GenerateToken
    // Power BI REST API call to get the embed URL of the report
    async getembedUrl() {
        console.log("Get embed responsqwqdqwedqwe");
        return fetch(config.powerBiApiUrl +
            "v1.0/myorg/groups/" +
            this.state.powerbi_workspace_id +
            "/reports/" +
            this.state.powerbi_report_id, {
            headers: {
                Authorization: "Bearer " + accessToken
            },
            method: "GET"
        })
            .then(async (response) => {
            console.log("Get embed response", response, accessToken);
            const jsonResponse = await response.json();
            console.log("what is jsonResponse", jsonResponse);
            const errorMessage = [];
            if (response.ok) {
                embedUrl = jsonResponse["embedUrl"];
                this.setState({
                    accessToken: accessToken,
                    embedUrl: embedUrl
                });
            }
            else {
                errorMessage.push("Error " + response.status + ": " + response.statusText);
                this.setState({ error: errorMessage });
            }
        })
            .catch((e) => {
            // Error in making the API call
            this.setState({ error: [e?.toString?.()] });
        });
    }
    async listReports(workspaceId, accessToken) {
        const apiUrl = `https://api.powerbi.com/v1.0/myorg/groups/${workspaceId}/reports`;
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
            }
        });
        const data = await response.json();
        return data.value;
    }
    async init() {
        const { recentCharts, bestCharts, dataset } = this.props;
        console.log("init what is state", this.state, this.state.accessToken);
        const reportContainer = document.getElementById("reportHolder");
        if (reportContainer === null) {
            return;
        }
        else if (this.state.error.length) {
            // Cleaning the report container contents and rendering the error message in multiple lines
            reportContainer.textContent = "";
            this.state.error.forEach((line) => {
                reportContainer.appendChild(document.createTextNode(line));
                reportContainer.appendChild(document.createElement("br"));
            });
        }
        else if (this.state.accessToken !== "" && this.state.embedUrl !== "") {
            console.log("we here?");
            const embedConfiguration = {
                type: "report",
                tokenType: models.TokenType.Aad,
                accessToken,
                embedUrl,
                id: this.state.powerbi_report_id
            };
            const powerbi = new service.Service(factories.hpmFactory, factories.wpmpFactory, factories.routerFactory);
            const report = powerbi.embed(reportContainer, embedConfiguration);
            console.log("what is report?", report, recentCharts, bestCharts, embedConfiguration);
            window.report = report;
            // Clear any other loaded handler events
            report.off("loaded");
            // Triggers when a content schema is successfully loaded
            report.on("loaded", async () => {
                console.log("Report load successful");
                window.report = report;
                // Adds a new page for the authoring APIs
                if (report !== undefined && report.addPage !== undefined) {
                    const retCharts = [...recentCharts, ...(bestCharts?.[0]?.relatedCharts ?? []).filter((a, i) => i < 3)];
                    let nextAuthoringPage;
                    for (let i = 0; i < retCharts.length; i++) {
                        const chart = retCharts[i];
                        if (i % 3 === 0) {
                            const pageName = chart.narrative?.title;
                            console.log("Building Page: ", pageName);
                            nextAuthoringPage = await report.addPage(pageName);
                            console.log("page response", nextAuthoringPage);
                            window.p = nextAuthoringPage;
                            const resize = await nextAuthoringPage.resizePage(4, window.innerWidth / 2 - 200, window.innerHeight - 200);
                            console.log("resize reponse?", resize);
                        }
                        console.log("Building Chart: ", chart);
                        if (nextAuthoringPage !== undefined) {
                            const rChart = await this.buildChart(nextAuthoringPage, chart, i % 3);
                        }
                    }
                    const saveResponse = await report.saveAs({
                        name: dataset.name + "_TEST2"
                    });
                    setTimeout(async () => {
                        const allReports = await this.listReports(this.state.powerbi_workspace_id ?? "", this.state.accessToken);
                        console.log("all reports?", allReports);
                        const lastReport = allReports?.[allReports.length - 1];
                        window.open(lastReport.webUrl);
                        this.props.updateIsPowerBIExport(false);
                    }, 5000);
                }
            });
            // Clear any other rendered handler events
            report.off("rendered");
            // Triggers when a content is successfully embedded in UI
            report.on("rendered", async function () {
                console.log("Report render successful");
                //let createVisualResponse = await pbi.Page.createVisual('areaChart');
                //let visual = createVisualResponse.visual;
            });
            // Clear any other error handler event
            report.off("error");
            // Below patch of code is for handling errors that occur during embedding
            report.on("error", function (event) {
                const errorMsg = event.detail;
                console.log("wtf where is this happening?", event);
                // Use errorMsg variable to log error in any destination of choice
                console.error(errorMsg);
            });
        }
    }
    async buildChart(page, chart, i) {
        if (chart?.metadata?.properties.length === 1) {
            const layout = {
                x: 0,
                y: (i % 3) * 275,
                z: 1,
                width: 750,
                height: 250,
                displayState: { mode: 0 }
            };
            return await this.buildFirstOrderChart(page, chart, layout);
        }
        else if (chart?.metadata?.properties.length === 2) {
            const firstLayout = {
                x: 0,
                y: (i % 3) * 275,
                z: 1,
                width: 350,
                height: 250,
                displayState: { mode: 0 }
            };
            const secondLayout = {
                x: 400,
                y: (i % 3) * 275,
                z: 1,
                width: 350,
                height: 250,
                displayState: { mode: 0 }
            };
            const fChart = await this.buildSecondOrderChart(page, chart, firstLayout);
            console.log("first chart?", fChart);
            const sChart = await this.buildSecondOrderChart(page, chart, secondLayout, true);
            console.log("second Chart?", sChart);
            return sChart;
        }
    }
    async buildSecondOrderChart(page, chart, customLayout, isNot = false) {
        const { bestCharts } = this.props;
        console.log("buidls econd order elts go", page, chart, customLayout, isNot);
        const visual = await page.createVisual("columnChart", customLayout);
        console.log("did we eget visual?", visual, await visual.visual.getCapabilities());
        const mainColumn = chart?.metadata?.properties?.find(isColumn);
        const secondColumn = chart?.metadata?.properties?.find((x) => "value" in x);
        if (mainColumn === undefined || secondColumn === undefined) {
            return;
        }
        console.log("chart and mIndex sIndex", chart, mainColumn, secondColumn, chart?.metadata?.properties);
        console.log("second order chart mian second", chart, mainColumn, secondColumn);
        visual.visual.setProperty({ objectName: "title", propertyName: "titleText" }, {
            schema: "http://powerbi.com/product/schema#default",
            value: isNot ? mainColumn.column + " when " + secondColumn.column + " is all other" : chart.narrative.title
        });
        const mainField = {
            $schema: "http://powerbi.com/product/schema#column",
            table: "SmallBank_Good",
            column: mainColumn.column.replace(/_/g, " ")
        };
        const secondField = {
            $schema: "http://powerbi.com/product/schema#column",
            table: "SmallBank_Good",
            column: secondColumn.column.replace(/_/g, " ")
        };
        const outcomeField = {
            $schema: "http://powerbi.com/product/schema#column",
            table: "SmallBank_Good",
            column: "Term Deposit Conversion",
            aggregationFunction: "Avg"
        };
        const mr = await visual.visual.addDataField("Category", mainField);
        console.log("mr,", mr);
        //const sr = await visual.visual.addDataField("Category", secondField);
        // console.log("sr", sr);
        const yr = await visual.visual.addDataField("Y", outcomeField);
        console.log("yr,", yr);
        const secondBaseChart = bestCharts?.find((c) => c.narrative.title === secondColumn.column);
        const filter = {
            $schema: "http://powerbi.com/product/schema#basic",
            filterType: FilterType.Basic, // TODO: actually check if this is correct
            target: secondField,
            operator: "In",
            values: isNot
                ? (secondBaseChart?.chart?.data ?? []).filter((a) => a.name !== secondColumn.value).map((a) => a.name)
                : [secondColumn?.value]
        };
        console.log("what is filter>", filter);
        visual.visual.setFilters([filter]);
    }
    async buildFirstOrderChart(page, chart, customLayout) {
        const visual = await page.createVisual("columnChart", customLayout);
        visual.visual.setProperty({ objectName: "title", propertyName: "titleText" }, {
            schema: "http://powerbi.com/product/schema#default",
            value: chart.narrative?.title
        });
        console.log("v return", visual);
        const mainColumn = chart?.metadata?.properties?.[0].column.replace(/_/g, " ");
        const mainField = {
            $schema: "http://powerbi.com/product/schema#column",
            table: "SmallBank_Good",
            column: mainColumn
        };
        const outcomeField = {
            $schema: "http://powerbi.com/product/schema#column",
            table: "SmallBank_Good",
            column: "Term Deposit Conversion",
            aggregationFunction: "Avg"
        };
        const cReturn = await visual.visual.addDataField("Category", mainField);
        const yReturn = await visual.visual.addDataField("Y", outcomeField);
        console.log("returns?", cReturn, yReturn);
        return Promise.resolve();
    }
    exportToPowerBI() {
        this.props.updateIsPowerBIExport(true);
        this.authenticate();
    }
    render() {
        return (React.createElement(Button, { style: {
                whiteSpace: "nowrap"
            }, isSmall: true, onClick: () => this.exportToPowerBI(), type: "secondary" }, "Power BI Export"));
    }
}
export default ChatGPT;
const DocumentSummarizationExpansionItem = ({ message }) => {
    const [openMessageIndex, updateOpenMessageIndex] = useState();
    const [showContent, updateShowContent] = useState({});
    const [showAll, updateShowAll] = useState(false);
    const handleUpdateShowContent = (i, val) => updateShowContent({
        ...showContent,
        [i]: val
    });
    const index = 1;
    const documentData = message?.document_data;
    const sourceDocuments = documentData?.source_documents ?? [];
    const documentNames = [
        ...new Set(sourceDocuments.map((d) => d.metadata?.source).filter((x) => x !== undefined))
    ];
    const handleShowAll = () => {
        const newContent = {};
        sourceDocuments.forEach((d, i) => {
            newContent[i] = !showAll;
        });
        updateShowContent(newContent);
        updateShowAll(!showAll);
    };
    return (React.createElement(MessageExpansionItem, { openLabel: "Close", closedLabel: "See what was sent", index: index, isOpen: openMessageIndex === index, updateOpenMessageIndex: (val) => {
            updateOpenMessageIndex(val);
            if (val !== index) {
                updateShowContent({});
            }
        } },
        React.createElement("div", { style: { padding: "10px" } },
            React.createElement("div", { style: {
                    marginBottom: "8px"
                } },
                React.createElement("div", { className: styles.expansionTitle }, `${documentNames.length} Document${documentNames.length !== 1 ? "s" : ""} Analyzed:`),
                React.createElement("div", null,
                    React.createElement("ul", null, documentNames.map((d, i) => (React.createElement("li", { key: "doc_" + i, className: styles.expansionSubItem }, d)))))),
            React.createElement("div", { style: {
                    marginBottom: "8px"
                } },
                React.createElement("div", { className: styles.expansionTitle },
                    `${sourceDocuments.length} Excerpt${sourceDocuments.length !== 1 ? "s" : ""} Referenced (source_documents):`,
                    React.createElement(Button, { isSmall: true, style: { marginLeft: "20px" }, onClick: () => handleShowAll() }, showAll ? "Hide All Excerpts" : "Show All Excerpts")),
                React.createElement("div", null,
                    React.createElement("ul", null, sourceDocuments.map((d, i) => {
                        const source = d?.metadata?.source;
                        const page = d?.metadata?.page;
                        const content = d?.page_content;
                        const showCurrContent = showContent[i];
                        return (React.createElement("li", { key: "sourcedoc_" + i, className: styles.expansionSubItem },
                            React.createElement("div", { className: styles.expansionTitle },
                                source
                                    ? `${source}${page !== undefined ? ` (page ${isNaN(page) ? page : Number(page) + 1})` : ""}:`
                                    : "page_content:",
                                React.createElement("a", { style: {
                                        display: "inline-block",
                                        marginLeft: "10px"
                                    }, onClick: () => handleUpdateShowContent(i, !showCurrContent) }, showCurrContent ? "Hide Content" : "Show Content")),
                            showCurrContent ? React.createElement("div", null, content) : null));
                    })))))));
};
const MessageExpansionItemAnimation = ({ nextId, dataset, currentPromptCharts }) => {
    const [animationChartIndex, updateAnimationChartIndex] = useState(0);
    const [animationChartHighlightIndex, updateAnimationChartHighlightIndex] = useState(0);
    const charts = currentPromptCharts?.filter((c) => c !== undefined) ?? [];
    const updateTime = (animationChartIndex, animationChartHighlightIndex) => {
        if (!currentPromptCharts) {
            return;
        }
        const charts = currentPromptCharts.filter((c) => c !== undefined);
        const retChart = charts[animationChartIndex];
        const hasNextSlice = retChart?.chart?.data?.[animationChartHighlightIndex + 1] !== undefined;
        const newAnimationChartHighlightIndex = hasNextSlice ? animationChartHighlightIndex + 1 : 0;
        const newAnimationChartIndex = hasNextSlice
            ? animationChartIndex
            : animationChartIndex > charts.length - 2
                ? 0
                : animationChartIndex + 1;
        updateAnimationChartHighlightIndex(newAnimationChartHighlightIndex);
        updateAnimationChartIndex(newAnimationChartIndex);
        delay(ANIMATION_HEARTBEAT).then(() => updateTime(newAnimationChartIndex, newAnimationChartHighlightIndex));
    };
    useEffect(() => updateTime(animationChartIndex, animationChartHighlightIndex), []);
    const retChart = charts[animationChartIndex];
    const highlightProps = animationChartHighlightIndex === 0
        ? retChart?.narrative?.summaryValue
        : retChart?.narrative?.expandText?.[animationChartHighlightIndex - 1]?.column;
    return retChart == undefined ? (React.createElement("div", null)) : (React.createElement("div", { className: styles.expansionItemContentDash },
        React.createElement("div", { className: styles.showDashChart, style: retChart?.metadata?.type === "Difference" ? { minHeight: "500px", paddingBottom: "50px" } : {} },
            React.createElement(NextChartContainer, { id: nextId ?? "new", chart: retChart, highlightProps: highlightProps, dataset: dataset, showLeakage: true, showTooltip: true, isShowMore: false, isChatGPT: true, isComparisonDashboard: retChart?.metadata?.type === "Difference" }))));
};
const OpenMessageExpansionItem = ({ nextId, dataset, children, text, modelName, showSentType, updateShowSentType, messageIndex, message }) => {
    const insightCombinationCount = useSelector((state) => nextReducer.getInsightCombinationCount(state, undefined, dataset?.id));
    const currentPromptCharts = useSelector((state) => (messageIndex === undefined
        ? message?.currentPromptCharts
        : chatGPTReducer.getConversationMessageCurrentPromptCharts(state, messageIndex)) ?? message?.currentPromptCharts);
    const retCharts = currentPromptCharts ? currentPromptCharts.filter((c) => c !== undefined && c !== null) : [];
    return (React.createElement("div", { className: styles.pBackground },
        retCharts?.length > 0 && (React.createElement("div", null,
            React.createElement("div", { className: styles.animatedBriefingTop },
                React.createElement("div", { className: styles.animatedBriefingTopText }, "Aible detected the " +
                    retCharts.length +
                    " most relevant charts out of " +
                    numeral(insightCombinationCount).format("0,0") +
                    " possible questions you could ask of this data. " +
                    modelName +
                    " is reviewing and summarizing key insights out of these charts so you don't have to. This may take a minute.")),
            React.createElement("div", { className: styles.dashToggle },
                React.createElement(ButtonGroup, { style: { marginTop: "10px", marginBottom: "10px" } },
                    React.createElement(Button, { style: { padding: "3px 10px" }, active: showSentType === "ANIMATION", onClick: () => updateShowSentType("ANIMATION"), greyscaleDefaultState: true }, "Animation"),
                    React.createElement(Button, { style: { padding: "3px 10px", minWidth: "64px" }, active: showSentType === "JSON", onClick: () => updateShowSentType("JSON"), greyscaleDefaultState: true }, "Data"),
                    React.createElement(Button, { style: { padding: "3px 10px" }, active: showSentType === "DASHBOARD", onClick: () => updateShowSentType("DASHBOARD"), greyscaleDefaultState: true }, "Dashboard"))),
            React.createElement("div", { style: { marginLeft: "10px" } }))),
        showSentType === undefined ||
            showSentType === "JSON" ||
            (showSentType === "ANIMATION" && !(retCharts?.length > 0)) ? (React.createElement("div", { className: styles.expansionItemContent }, children)) : showSentType === "ANIMATION" ? (React.createElement(MessageExpansionItemAnimation, { nextId: nextId, dataset: dataset, currentPromptCharts: currentPromptCharts, message: message })) : (React.createElement(Virtuoso, { style: { height: "500px" }, data: retCharts.filter((chart) => chart !== undefined && chart !== null), itemContent: (i) => {
                const chart = retCharts.filter((chart) => chart !== undefined && chart !== null)[i];
                const highlightProps = chart?.narrative?.summaryValue;
                return (React.createElement("div", { className: styles.expansionItemContentDash },
                    React.createElement("div", { className: styles.showDashChart, key: "dashboard_" + i, style: chart?.metadata?.type === "Difference"
                            ? { minHeight: "500px", paddingBottom: "50px", display: "flex", alignItems: "center" }
                            : { display: "flex", alignItems: "center" } },
                        React.createElement(NextChartContainer, { id: nextId ?? "new", chart: chart, highlightProps: highlightProps, dataset: dataset, showLeakage: true, showTooltip: true, isShowMore: false, isChatGPT: true, isComparisonDashboard: chart?.metadata?.type === "Difference" }))));
            } })),
        text !== undefined && Boolean(text) && (React.createElement(Button, { onClick: () => navigator.clipboard.writeText(text), isSmall: true }, "Copy to clipboard"))));
};
const ANIMATION_HEARTBEAT = 666;
const MessageExpansionItem = ({ children, openLabel, closedLabel, text, className, nextId, dataset, updateOpenMessageIndex, isOpen, index, modelName, isLocked, isLoading, message, messageIndex }) => {
    const [showSentType, updateShowSentType] = useState(isLoading !== undefined && !isLoading ? "DASHBOARD" : "ANIMATION");
    useEffect(() => {
        if (!isLoading && showSentType === "ANIMATION") {
            updateShowSentType("DASHBOARD");
        }
        else if (isLoading && showSentType !== "ANIMATION") {
            updateShowSentType("ANIMATION");
        }
    }, [isLoading]);
    const retOpenLabel = openLabel ?? "Hide";
    const retClosedLabel = closedLabel ?? "Show";
    return (React.createElement("div", { className: (showSentType === "DASHBOARD" ? styles.expansionItemWrapperDash : styles.expansionItemWrapper) +
            " " +
            (isOpen ? styles.isOpen : "") +
            " " +
            (className ?? "") },
        !isLocked && (React.createElement("a", { className: styles.expansionItemLink, onClick: () => {
                updateOpenMessageIndex?.(isOpen ? undefined : index);
            } }, isOpen ? retOpenLabel : retClosedLabel)),
        isOpen && (React.createElement(OpenMessageExpansionItem, { dataset: dataset, nextId: nextId, children: children, modelName: modelName, text: text, showSentType: showSentType, updateShowSentType: updateShowSentType, message: message, messageIndex: messageIndex }))));
};
export const BlueprintPopup = ({ onClick, handleClose }) => {
    return (React.createElement(Popover, { id: "blueprintSelectorPopup", className: styles.blueprintPopupContainer, placement: "top", positionTop: -175, onClick: () => {
            handleClose?.();
        } },
        React.createElement("div", { className: styles.blueprintAnalyticsPopup },
            React.createElement("div", { className: styles.blueprintPopupClose }, "X"),
            React.createElement("div", { className: styles.blueprintPopupText },
                React.createElement("div", { style: { marginBottom: "8px" } },
                    React.createElement("span", null, "Aible has switched the agent template to "),
                    React.createElement("strong", null, CHATAIBLE_BLUEPRINTS.CHATAIBLE_ANALYTICS.name),
                    React.createElement("span", null, ` for behavior-related insights about this data. For row-level answers, like "What is my average revenue?" choose the `),
                    React.createElement("strong", null, CHATAIBLE_SQL.name),
                    React.createElement("span", null, " agent template.")),
                onClick && React.createElement("a", { onClick: onClick }, "Switch to Natural Language Queries")))));
};
